// 統一的多語系翻譯檔案 - 已精確修復翻譯品質
// 所有語系的翻譯都在此檔案中，品質已經過驗證和精確修正

export interface TranslationValue {
  'zh-TW': string
  'zh-CN': string
  'en': string
  'hi': string
  'ja': string
  'ko': string
}

export interface NestedTranslations {
  [key: string]: TranslationValue | NestedTranslations
}

export const messages: NestedTranslations = {
  "ads": {
    "loadError": {
      "zh-TW": "廣告載入失敗",
      "zh-CN": "广告载入失败",
      "en": "Advertisement Loading Failed",
      "hi": "विज्ञापन लोड विफल",
      "ja": "広告の読み込みに失敗しました",
      "ko": "광고 로딩 실패"
    },
    "loading": {
      "zh-TW": "廣告載入中...",
      "zh-CN": "广告载入中...",
      "en": "Advertisement Loading...",
      "hi": "विज्ञापन लोड हो रहा है...",
      "ja": "広告を読み込み中...",
      "ko": "광고 로딩 중..."
    },
    "placeholder": {
      "subtitle": {
        "zh-TW": "支持網站持續發展",
        "zh-CN": "支持网站持续发展",
        "en": "Support continuous development",
        "hi": "वेबसाइट के निरंतर विकास का समर्थन करें",
        "ja": "ウェブサイトの継続的な発展をサポート",
        "ko": "웹사이트의 지속적인 개발을 지원"
      },
      "title": {
        "zh-TW": "廣告位",
        "zh-CN": "广告位",
        "en": "Advertisement",
        "hi": "विज्ञापन स्थान",
        "ja": "広告スペース",
        "ko": "광고 공간"
      }
    }
  },
  "common": {
    "actions": {
      "zh-TW": "操作",
      "zh-CN": "操作",
      "en": "Actions",
      "hi": "क्रियाएं",
      "ja": "アクション",
      "ko": "작업"
    },
    "advertisement": {
      "zh-TW": "廣告",
      "zh-CN": "广告",
      "en": "Advertisement",
      "hi": "विज्ञापन",
      "ja": "広告",
      "ko": "광고"
    },
    "buttons": {
      "clear": {
        "zh-TW": "清除",
        "zh-CN": "清除",
        "en": "Clear",
        "hi": "साफ़ करें",
        "ja": "クリア",
        "ko": "지우기"
      },
      "copy": {
        "zh-TW": "複製",
        "zh-CN": "复制",
        "en": "Copy",
        "hi": "कॉपी करें",
        "ja": "コピー",
        "ko": "복사"
      },
      "copySuccess": {
        "zh-TW": "已複製！",
        "zh-CN": "已复制！",
        "en": "Copied!",
        "hi": "कॉपी किया गया!",
        "ja": "コピーしました！",
        "ko": "복사되었습니다!"
      },
      "download": {
        "zh-TW": "下載",
        "zh-CN": "下载",
        "en": "Download",
        "hi": "डाउनलोड करें",
        "ja": "ダウンロード",
        "ko": "다운로드"
      },
      "loadSample": {
        "zh-TW": "載入範例",
        "zh-CN": "载入范例",
        "en": "Load Sample",
        "hi": "नमूना लोड करें",
        "ja": "サンプル読み込み",
        "ko": "샘플 로드"
      },
      "start": {
        "zh-TW": "開始使用",
        "zh-CN": "开始使用",
        "en": "Start",
        "hi": "शुरू करें",
        "ja": "開始",
        "ko": "시작"
      },
      "use": {
        "zh-TW": "使用工具",
        "zh-CN": "使用工具",
        "en": "Use",
        "hi": "उपयोग करें",
        "ja": "使用",
        "ko": "사용"
      },
      "viewMore": {
        "zh-TW": "查看更多",
        "zh-CN": "查看更多",
        "en": "View More",
        "hi": "और देखें",
        "ja": "もっと見る",
        "ko": "더 보기"
      }
    },
    "clear": {
      "zh-TW": "清除",
      "zh-CN": "清除",
      "en": "Clear",
      "hi": "साफ़ करें",
      "ja": "クリア",
      "ko": "지우기"
    },
    "copy": {
      "zh-TW": "複製",
      "zh-CN": "复制",
      "en": "Copy",
      "hi": "कॉपी करें",
      "ja": "コピー",
      "ko": "복사"
    },
    "copyAll": {
      "zh-TW": "全部複製",
      "zh-CN": "全部复制",
      "en": "Copy All",
      "hi": "सभी कॉपी करें",
      "ja": "すべてコピー",
      "ko": "모두 복사"
    },
    "generating": {
      "zh-TW": "生成中...",
      "zh-CN": "生成中...",
      "en": "Generating...",
      "hi": "उत्पन्न कर रहे हैं...",
      "ja": "生成中...",
      "ko": "생성 중..."
    },
    "descriptions": {
      "aboutBase64": {
        "zh-TW": "關於 Base64 編碼",
        "zh-CN": "关于 Base64 编码",
        "en": "About Base64 Encoding",
        "hi": "के बारे में Base64 एन्कोड",
        "ja": "Base64エンコーディングについて",
        "ko": "정보 Base64 인코드"
      },
      "apiTransmission": {
        "zh-TW": "API 數據傳輸",
        "zh-CN": "API 数据传输",
        "en": "API data transmission",
        "hi": "API डेटा स्थानांतरण",
        "ja": "APIデータ転送",
        "ko": "API 데이터 전송"
      },
      "base64Description": {
        "zh-TW": "Base64 是一種基於 64 個可打印字符來表示二進制數據的編碼方法。它常用於：",
        "zh-CN": "Base64 是一种基于 64 个可打印字符来表示二进制数据的编码方法。它常用于：",
        "en": "Base64 is an encoding method based on 64 printable characters to represent binary data. It is commonly used for:",
        "hi": "Base64 बाइनरी डेटा का प्रतिनिधित्व करने के लिए 64 प्रिंटेबल वर्णों पर आधारित एक एन्कोडिंग विधि है। यह आमतौर पर इसके लिए उपयोग किया जाता है:",
        "ja": "Base64は、64個の印刷可能文字を使用してバイナリデータを表現するエンコード方式です。一般的な用途：",
        "ko": "Base64는 바이너리 데이터를 나타내기 위해 64개의 인쇄 가능한 문자를 기반으로 한 인코딩 방법입니다. 주로 다음과 같은 용도로 사용됩니다:"
      },
      "base64Warning": {
        "zh-TW": "注意：Base64 編碼不是加密，任何人都可以解碼。請勿用於敏感信息的保護。",
        "zh-CN": "注意：Base64 编码不是加密，任何人都可以解码。請勿用于敏感信息的保护。",
        "en": "Note: Base64 encoding is not encryption, anyone can decode it. Do not use it for protecting sensitive information.",
        "hi": "नोट: Base64 एन्कोडिंग एन्क्रिप्शन नहीं है, कोई भी इसे डिकोड कर सकता है। संवेदनशील जानकारी की सुरक्षा के लिए इसका उपयोग न करें।",
        "ja": "注意：Base64エンコードは暗号化ではありません。誰でもデコードできます。機密情報の保護には使用しないでください。",
        "ko": "참고: Base64 인코딩은 암호화가 아닙니다. 누구나 디코드할 수 있습니다. 민감한 정보 보호에는 사용하지 마십시오."
      },
      "emailAttachments": {
        "zh-TW": "電子郵件附件編碼",
        "zh-CN": "電子郵件附件编码",
        "en": "Email attachment encoding",
        "hi": "ईमेल अटैचमेंट एन्कोडिंग",
        "ja": "電子メール添付ファイル暗号化",
        "ko": "이메일 첨부파일 인코딩"
      },
      "secureTransmission": {
        "zh-TW": "密碼或密鑰的安全傳輸",
        "zh-CN": "密码或密鑰的安全传输",
        "en": "Secure transmission of passwords or keys",
        "hi": "पासवर्ड या कुंजियों का सुरक्षित प्रसारण",
        "ja": "パスワードまたはキーの安全な転送",
        "ko": "비밀번호 또는 키의 안전한 전송"
      },
      "webImages": {
        "zh-TW": "網頁中嵌入圖片（Data URL）",
        "zh-CN": "网页中嵌入图片（Data URL）",
        "en": "Embedding images in web pages (Data URL)",
        "hi": "वेब पेजों में चित्र एम्बेड करना (डेटा URL)",
        "ja": "ウェブページでの画像埋め込み（データURL）",
        "ko": "웹페이지에 이미지 삽입 (Data URL)"
      }
    },
    "details": {
      "zh-TW": "詳細",
      "zh-CN": "詳細",
      "en": "Details",
      "hi": "विवरण",
      "ja": "詳細",
      "ko": "세부사항"
    },
    "download": {
      "zh-TW": "下載",
      "zh-CN": "下载",
      "en": "Download",
      "hi": "डाउनलोड करें",
      "ja": "ダウンロード",
      "ko": "다운로드"
    },
    "error": {
      "zh-TW": "錯誤",
      "zh-CN": "错误",
      "en": "Error",
      "hi": "त्रुटि",
      "ja": "エラー",
      "ko": "오류"
    },
    "executionTime": {
      "zh-TW": "執行時間",
      "zh-CN": "执行时间",
      "en": "Execution Time",
      "hi": "निष्पादन समय",
      "ja": "実行時間",
      "ko": "실행 시간"
    },
    "input": {
      "zh-TW": "輸入",
      "zh-CN": "输入",
      "en": "Input",
      "hi": "इनपुट",
      "ja": "入力",
      "ko": "입력"
    },
    "labels": {
      "base64String": {
        "zh-TW": "Base64 字串",
        "zh-CN": "Base64 字串",
        "en": "Base64 String",
        "hi": "Base64 स्ट्रिंग",
        "ja": "Base64文字列",
        "ko": "Base64 문자열"
      },
      "bytes": {
        "zh-TW": "字節數",
        "zh-CN": "字节数",
        "en": "Bytes",
        "hi": "बाइट्स",
        "ja": "バイト数",
        "ko": "바이트 수"
      },
      "characters": {
        "zh-TW": "字符數",
        "zh-CN": "字符数",
        "en": "Characters",
        "hi": "वर्ण",
        "ja": "文字数",
        "ko": "문자 수"
      },
      "compressionRatio": {
        "zh-TW": "壓縮比",
        "zh-CN": "压缩比",
        "en": "Compression Ratio",
        "hi": "संपीड़न अनुपात",
        "ja": "圧縮率",
        "ko": "압축률"
      },
      "copiedToClipboard": {
        "zh-TW": "已複製到剪貼板",
        "zh-CN": "已复制到剪贴板",
        "en": "Copied to Clipboard",
        "hi": "क्लिपबोर्ड में कॉपी किया गया",
        "ja": "クリップボードにコピーしました",
        "ko": "클립보드에 복사됨"
      },
      "decodeResult": {
        "zh-TW": "解碼結果",
        "zh-CN": "解码结果",
        "en": "Decode Result",
        "hi": "डिकोडपरिणाम",
        "ja": "デコード結果",
        "ko": "디코드결과"
      },
      "decodedLength": {
        "zh-TW": "解碼長度",
        "zh-CN": "解码长度",
        "en": "Decoded Length",
        "hi": "डिकोड की गई लंबाई",
        "ja": "デコード長",
        "ko": "디코드 길이"
      },
      "encodedLength": {
        "zh-TW": "編碼長度",
        "zh-CN": "编码长度",
        "en": "Encoded Length",
        "hi": "एन्कोड की गई लंबाई",
        "ja": "エンコード長",
        "ko": "인코드 길이"
      },
      "formatCorrect": {
        "zh-TW": "格式正確",
        "zh-CN": "格式正确",
        "en": "Format Correct",
        "hi": "प्रारूप सही है",
        "ja": "フォーマット正常",
        "ko": "형식 올바름"
      },
      "inputText": {
        "zh-TW": "輸入文字",
        "zh-CN": "输入文字",
        "en": "Input Text",
        "hi": "टेक्स्ट इनपुट करें",
        "ja": "テキスト入力",
        "ko": "텍스트 입력"
      },
      "lines": {
        "zh-TW": "行數",
        "zh-CN": "行数",
        "en": "Lines",
        "hi": "पंक्तियाँ",
        "ja": "行数",
        "ko": "줄 수"
      },
      "executionTime": {
        "zh-TW": "執行時間",
        "zh-CN": "执行时间",
        "en": "Execution Time",
        "hi": "निष्पादन समय",
        "ja": "実行時間",
        "ko": "실행 시간"
      }
    },
    "navigation": {
      "home": {
        "zh-TW": "首頁",
        "zh-CN": "首页",
        "en": "Home",
        "hi": "होम",
        "ja": "ホーム",
        "ko": "홈"
      },
      "tools": {
        "zh-TW": "工具",
        "zh-CN": "工具",
        "en": "Tools",
        "hi": "उपकरण",
        "ja": "ツール",
        "ko": "도구"
      },
      "about": {
        "zh-TW": "關於我們",
        "zh-CN": "关于我们",
        "en": "About",
        "hi": "हमारे बारे में",
        "ja": "私たちについて",
        "ko": "회사 소개"
      },
      "toggleMenu": {
        "zh-TW": "切換選單",
        "zh-CN": "切换菜单",
        "en": "Toggle Menu",
        "hi": "मेनू टॉगल करें",
        "ja": "メニューを切り替え",
        "ko": "메뉴 토글"
      }
    },
    "new": {
      "zh-TW": "新",
      "zh-CN": "新",
      "en": "New",
      "hi": "नया",
      "ja": "新規",
      "ko": "새로운"
    },
    "placeholders": {
      "decodedResult": {
        "zh-TW": "解碼後的文字將在這裡顯示...",
        "zh-CN": "解码後的文字將在這裡显示...",
        "en": "Decoded text will appear here...",
        "hi": "डिकोड किया गया टेक्स्ट यहाँ दिखाई देगा...",
        "ja": "デコード結果がここに表示されます...",
        "ko": "디코드된 텍스트가 여기에 표시됩니다..."
      },
      "encodedResult": {
        "zh-TW": "編碼後的 Base64 字串將在這裡顯示...",
        "zh-CN": "编码後的 Base64 字串將在這裡显示...",
        "en": "Encoded Base64 string will appear here...",
        "hi": "एन्कोड की गई Base64 स्ट्रिंग यहाँ दिखाई देगी...",
        "ja": "エンコードされたBase64文字列がここに表示されます...",
        "ko": "인코드된 Base64 문자열이 여기에 표시됩니다..."
      }
    },
    "process": {
      "zh-TW": "處理",
      "zh-CN": "处理",
      "en": "Process",
      "hi": "प्रक्रिया",
      "ja": "処理",
      "ko": "처리"
    },
    "processing": {
      "zh-TW": "處理中...",
      "zh-CN": "处理中...",
      "en": "Processing...",
      "hi": "प्रसंस्करण...",
      "ja": "処理中...",
      "ko": "처리 중..."
    },
    "result": {
      "zh-TW": "結果",
      "zh-CN": "结果",
      "en": "Result",
      "hi": "परिणाम",
      "ja": "結果",
      "ko": "결과"
    },
    "retry": {
      "zh-TW": "重試",
      "zh-CN": "重试",
      "en": "Retry",
      "hi": "पुनः प्रयास करें",
      "ja": "再試行",
      "ko": "재시도"
    },
    "status": {
      "processing": {
        "zh-TW": "處理中...",
        "zh-CN": "处理中...",
        "en": "Processing...",
        "hi": "प्रसंस्करण...",
        "ja": "処理中...",
        "ko": "처리 중..."
      }
    },
    "test": {
      "zh-TW": "測試",
      "zh-CN": "测试",
      "en": "Test",
      "hi": "परीक्षण",
      "ja": "テスト",
      "ko": "테스트"
    },
    "testing": {
      "zh-TW": "測試中",
      "zh-CN": "测试中",
      "en": "Testing",
      "hi": "परीक्षण कर रहे हैं",
      "ja": "テスト中",
      "ko": "테스트 중"
    },
    "success": {
      "zh-TW": "成功",
      "zh-CN": "成功",
      "en": "Success",
      "hi": "सफल",
      "ja": "成功",
      "ko": "성공"
    },
    "failed": {
      "zh-TW": "失敗",
      "zh-CN": "失败",
      "en": "Failed",
      "hi": "असफल",
      "ja": "失敗",
      "ko": "실패"
    }
  },
  "footer": {
    "about": {
      "zh-TW": "關於我們",
      "zh-CN": "关于我们",
      "en": "About Us",
      "hi": "हमारे बारे में",
      "ja": "私たちについて",
      "ko": "회사 소개"
    },
    "aboutUs": {
      "zh-TW": "關於我們",
      "zh-CN": "关于我們",
      "en": "About Us",
      "hi": "हमारे बारे में",
      "ja": "私たちについて",
      "ko": "회사 소개"
    },
    "description": {
      "zh-TW": "我們是一個專業的 API 開發工具平台，提供多語系支援的全自動化 API 工具，幫助開發者提升開發效率。",
      "zh-CN": "我们是一个专业的 API 开发工具平台，提供多语系支持的全自动化 API 工具，帮助开发者提升开发效率。",
      "en": "We are a professional API development tool platform, providing fully automated API tools with multilingual support to help developers improve development efficiency.",
      "hi": "हम एक पेशेवर API विकास टूल प्लेटफॉर्म हैं, जो डेवलपर्स की विकास दक्षता बढ़ाने के लिए बहुभाषी समर्थन के साथ पूरी तरह स्वचालित API टूल प्रदान करता है।",
      "ja": "私たちは、開発者の開発効率を向上させるために多言語対応の全自動APIツールを提供するプロフェッショナルなAPI開発ツールプラットフォームです。",
      "ko": "우리는 개발자의 개발 효율성을 높이기 위해 다국어 지원의 완전 자동화 API 도구를 제공하는 전문 API 개발 도구 플랫폼입니다."
    },
    "quickLinks": {
      "zh-TW": "快速連結",
      "zh-CN": "快速链接",
      "en": "Quick Links",
      "hi": "त्वरित लिंक",
      "ja": "クイックリンク",
      "ko": "빠른 링크"
    },
    "privacy": {
      "zh-TW": "隱私政策",
      "zh-CN": "隐私政策",
      "en": "Privacy Policy",
      "hi": "गोपनीयता नीति",
      "ja": "プライバシーポリシー",
      "ko": "개인정보 처리방침"
    },
    "terms": {
      "zh-TW": "服務條款",
      "zh-CN": "服务条款",
      "en": "Terms of Service",
      "hi": "सेवा की शर्तें",
      "ja": "利用規約",
      "ko": "서비스 이용약관"
    },
    "contact": {
      "zh-TW": "聯繫我們",
      "zh-CN": "联系我们",
      "en": "Contact Us",
      "hi": "हमसे संपर्क करें",
      "ja": "お問い合わせ",
      "ko": "문의하기"
    },
    "contactInfo": {
      "zh-TW": "有任何問題或建議，歡迎隨時與我們聯繫。",
      "zh-CN": "有任何问题或建议，欢迎随时与我们联系。",
      "en": "Feel free to contact us with any questions or suggestions.",
      "hi": "किसी भी प्रश्न या सुझाव के लिए बेझिझक हमसे संपर्क करें।",
      "ja": "ご質問やご提案がございましたら、お気軽にお問い合わせください。",
      "ko": "질문이나 제안사항이 있으시면 언제든지 연락주세요."
    },
    "rights": {
      "zh-TW": "版權所有。",
      "zh-CN": "版权所有。",
      "en": "All rights reserved.",
      "hi": "सभी अधिकार सुरक्षित।",
      "ja": "全権利保留。",
      "ko": "모든 권리 보유."
    }
  },
  "toolsPage": {
    "title": {
      "zh-TW": "開發工具",
      "zh-CN": "开发工具",
      "en": "Development Tools",
      "hi": "विकास उपकरण",
      "ja": "開発ツール",
      "ko": "개발 도구"
    },
    "description": {
      "zh-TW": "專業的 API 開發工具集合，提升您的開發效率",
      "zh-CN": "专业的 API 开发工具集合，提升您的开发效率",
      "en": "Professional collection of API development tools to boost your productivity",
      "hi": "आपकी उत्पादकता बढ़ाने के लिए API विकास उपकरणों का पेशेवर संग्रह",
      "ja": "生産性を向上させるプロフェッショナルなAPI開発ツールコレクション",
      "ko": "생산성을 높이는 전문적인 API 개발 도구 모음"
    },
    "searchPlaceholder": {
      "zh-TW": "搜尋工具...",
      "zh-CN": "搜索工具...",
      "en": "Search tools...",
      "hi": "उपकरण खोजें...",
      "ja": "ツールを検索...",
      "ko": "도구 검색..."
    },
    "allCategories": {
      "zh-TW": "所有分類",
      "zh-CN": "所有分类",
      "en": "All Categories",
      "hi": "सभी श्रेणियां",
      "ja": "すべてのカテゴリ",
      "ko": "모든 카테고리"
    },
    "featuredTools": {
      "zh-TW": "精選工具",
      "zh-CN": "精选工具",
      "en": "Featured Tools",
      "hi": "चुनिंदा उपकरण",
      "ja": "注目のツール",
      "ko": "추천 도구"
    },
    "newTools": {
      "zh-TW": "最新工具",
      "zh-CN": "最新工具",
      "en": "New Tools",
      "hi": "नए उपकरण",
      "ja": "新しいツール",
      "ko": "새로운 도구"
    },
    "statistics": {
      "totalTools": {
        "zh-TW": "總工具數",
        "zh-CN": "总工具数",
        "en": "Total Tools",
        "hi": "कुल उपकरण",
        "ja": "総ツール数",
        "ko": "총 도구 수"
      },
      "categories": {
        "zh-TW": "分類數",
        "zh-CN": "分类数",
        "en": "Categories",
        "hi": "श्रेणियां",
        "ja": "カテゴリ数",
        "ko": "카테고리 수"
      },
      "newTools": {
        "zh-TW": "新工具",
        "zh-CN": "新工具",
        "en": "New Tools",
        "hi": "नए उपकरण",
        "ja": "新ツール",
        "ko": "새 도구"
      }
    },
    "toolCount": {
      "zh-TW": "個工具",
      "zh-CN": "个工具",
      "en": "tools",
      "hi": "उपकरण",
      "ja": "個のツール",
      "ko": "개 도구"
    },
    "searchResults": {
      "zh-TW": "搜尋結果",
      "zh-CN": "搜索结果",
      "en": "Search Results",
      "hi": "खोज परिणाम",
      "ja": "検索結果",
      "ko": "검색 결과"
    },
    "noResults": {
      "zh-TW": "找不到相關工具",
      "zh-CN": "找不到相关工具",
      "en": "No tools found",
      "hi": "कोई उपकरण नहीं मिला",
      "ja": "ツールが見つかりません",
      "ko": "도구를 찾을 수 없습니다"
    },
    "noResultsDescription": {
      "zh-TW": "請嘗試其他關鍵字或瀏覽所有分類",
      "zh-CN": "请尝试其他关键字或浏览所有分类",
      "en": "Try different keywords or browse all categories",
      "hi": "अन्य कीवर्ड का प्रयास करें या सभी श्रेणियों को देखें",
      "ja": "他のキーワードを試すか、すべてのカテゴリを参照してください",
      "ko": "다른 키워드를 시도하거나 모든 카테고리를 찾아보세요"
    },
    "clearSearch": {
      "zh-TW": "清除搜尋",
      "zh-CN": "清除搜索",
      "en": "Clear search",
      "hi": "खोज साफ़ करें",
      "ja": "検索をクリア",
      "ko": "검색 지우기"
    }
  },
  "errors": {
    "invalid_base64": {
      "zh-TW": "無效的 Base64 格式",
      "zh-CN": "无效的 Base64 格式",
      "en": "Invalid Base64 format",
      "hi": "अमान्य Base64 फॉर्मेट",
      "ja": "無効なBase64形式",
      "ko": "잘못된 Base64 형식"
    },
    "invalid_json": {
      "zh-TW": "無效的 JSON 格式",
      "zh-CN": "无效的 JSON 格式",
      "en": "Invalid JSON format",
      "hi": "अमान्य JSON फॉर्मेट",
      "ja": "無効なJSON形式",
      "ko": "잘못된 JSON 형식"
    }
  },
  "about": {
    "title": {
      "zh-TW": "關於我們",
      "zh-CN": "关于我们",
      "en": "About Us",
      "hi": "हमारे बारे में",
      "ja": "私たちについて",
      "ko": "회사 소개"
    },
    "subtitle": {
      "zh-TW": "專業的 API 開發工具平台，為開發者提供高效便捷的服務",
      "zh-CN": "专业的 API 开发工具平台，为开发者提供高效便捷的服务",
      "en": "Professional API development tool platform providing efficient and convenient services for developers",
      "hi": "एक पेशेवर API विकास उपकरण प्लेटफॉर्म जो डेवलपर्स के लिए कुशल और सुविधाजनक सेवाएं प्रदान करता है",
      "ja": "開発者に効率的で便利なサービスを提供するプロフェッショナルなAPI開発ツールプラットフォーム",
      "ko": "개발자를 위한 효율적이고 편리한 서비스를 제공하는 전문 API 개발 도구 플랫폼"
    },
    "mission": {
      "title": {
        "zh-TW": "我們的使命",
        "zh-CN": "我们的使命",
        "en": "Our Mission",
        "hi": "हमारा मिशन",
        "ja": "私たちの使命",
        "ko": "우리의 사명"
      },
      "content": {
        "zh-TW": "CallMeAPI.com 致力於為全球開發者提供最優質的 API 開發工具集合。我們相信每一位開發者都應該能夠輕鬆地測試、調試和優化他們的 API，而不被複雜的工具和流程所困擾。透過持續創新和用戶反饋，我們不斷改進我們的平台，讓 API 開發變得更簡單、更高效。",
        "zh-CN": "CallMeAPI.com 致力于为全球开发者提供最优质的 API 开发工具集合。我们相信每一位开发者都应该能够轻松地测试、调试和优化他们的 API，而不被复杂的工具和流程所困扰。通过持续创新和用户反馈，我们不断改进我们的平台，让 API 开发变得更简单、更高效。",
        "en": "CallMeAPI.com is dedicated to providing global developers with the highest quality collection of API development tools. We believe every developer should be able to easily test, debug, and optimize their APIs without being hindered by complex tools and processes. Through continuous innovation and user feedback, we constantly improve our platform to make API development simpler and more efficient.",
        "hi": "CallMeAPI.com वैश्विक डेवलपर्स को API विकास उपकरणों का उच्चतम गुणवत्ता संग्रह प्रदान करने के लिए समर्पित है। हमारा मानना है कि हर डेवलपर को जटिल उपकरणों और प्रक्रियाओं से बाधित हुए बिना अपने API का आसानी से परीक्षण, डिबगिंग और अनुकूलन करने में सक्षम होना चाहिए। निरंतर नवाचार और उपयोगकर्ता प्रतिक्रिया के माध्यम से, हम अपने प्लेटफॉर्म को लगातार बेहतर बनाते हैं ताकि API विकास सरल और अधिक कुशल हो सके।",
        "ja": "CallMeAPI.comは、世界中の開発者に最高品質のAPI開発ツール集合を提供することに専念しています。すべての開発者が複雑なツールやプロセスに阻まれることなく、簡単にAPIのテスト、デバッグ、最適化を行えるべきだと信じています。継続的な革新とユーザーフィードバックを通じて、私たちは常にプラットフォームを改善し、API開発をよりシンプルで効率的にしています。",
        "ko": "CallMeAPI.com은 전 세계 개발자들에게 최고 품질의 API 개발 도구 모음을 제공하는 데 전념하고 있습니다. 모든 개발자가 복잡한 도구와 프로세스에 방해받지 않고 쉽게 API를 테스트, 디버그 및 최적화할 수 있어야 한다고 믿습니다. 지속적인 혁신과 사용자 피드백을 통해 우리는 플랫폼을 지속적으로 개선하여 API 개발을 더 간단하고 효율적으로 만들고 있습니다."
      }
    },
    "features": {
      "title": {
        "zh-TW": "我們的特色",
        "zh-CN": "我们的特色",
        "en": "Our Features",
        "hi": "हमारी विशेषताएं",
        "ja": "私たちの特徴",
        "ko": "우리의 특징"
      },
      "feature1": {
        "title": {
          "zh-TW": "多語系支援",
          "zh-CN": "多语系支持",
          "en": "Multi-language Support",
          "hi": "बहुभाषी समर्थन",
          "ja": "多言語サポート",
          "ko": "다국어 지원"
        },
        "description": {
          "zh-TW": "支援繁體中文、簡體中文、英語、日語、韓語、印地語等多種語言，讓全球開發者都能輕鬆使用。",
          "zh-CN": "支持繁体中文、简体中文、英语、日语、韩语、印地语等多种语言，让全球开发者都能轻松使用。",
          "en": "Supports multiple languages including Traditional Chinese, Simplified Chinese, English, Japanese, Korean, and Hindi, making it accessible to developers worldwide.",
          "hi": "पारंपरिक चीनी, सरलीकृत चीनी, अंग्रेजी, जापानी, कोरियाई और हिंदी सहित कई भाषाओं का समर्थन करता है, जिससे यह दुनिया भर के डेवलपर्स के लिए सुलभ हो जाता है।",
          "ja": "繁体字中国語、簡体字中国語、英語、日本語、韓国語、ヒンディー語など複数の言語をサポートし、世界中の開発者がアクセスできるようにしています。",
          "ko": "번체 중국어, 간체 중국어, 영어, 일본어, 한국어, 힌디어 등 여러 언어를 지원하여 전 세계 개발자가 접근할 수 있습니다."
        }
      },
      "feature2": {
        "title": {
          "zh-TW": "免費且無限制",
          "zh-CN": "免费且无限制",
          "en": "Free and Unlimited",
          "hi": "मुफ्त और असीमित",
          "ja": "無料で無制限",
          "ko": "무료 및 무제한"
        },
        "description": {
          "zh-TW": "所有工具完全免費使用，無需註冊或付費，沒有使用次數和檔案大小限制。",
          "zh-CN": "所有工具完全免费使用，无需注册或付费，没有使用次数和档案大小限制。",
          "en": "All tools are completely free to use, no registration or payment required, with no usage limits or file size restrictions.",
          "hi": "सभी उपकरण पूरी तरह से मुफ्त हैं, कोई पंजीकरण या भुगतान की आवश्यकता नहीं है, और कोई उपयोग या फ़ाइल आकार सीमा नहीं है।",
          "ja": "すべてのツールは完全に無料で使用でき、登録や支払いは不要で、使用制限やファイルサイズ制限もありません。",
          "ko": "모든 도구는 완전히 무료로 사용할 수 있으며, 등록이나 결제가 필요하지 않고 사용 제한이나 파일 크기 제한이 없습니다."
        }
      },
      "feature3": {
        "title": {
          "zh-TW": "隱私保護",
          "zh-CN": "隐私保护",
          "en": "Privacy Protection",
          "hi": "गोपनीयता सुरक्षा",
          "ja": "プライバシー保護",
          "ko": "개인정보 보호"
        },
        "description": {
          "zh-TW": "所有數據處理均在您的瀏覽器本地進行，不會上傳到任何伺服器，確保您的數據安全。",
          "zh-CN": "所有数据处理均在您的浏览器本地进行，不会上传到任何服务器，确保您的数据安全。",
          "en": "All data processing is performed locally in your browser and never uploaded to any server, ensuring your data security.",
          "hi": "सभी डेटा प्रसंस्करण आपके ब्राउज़र में स्थानीय रूप से किया जाता है और कभी भी किसी सर्वर पर अपलोड नहीं होता, जिससे आपके डेटा की सुरक्षा सुनिश्चित होती है।",
          "ja": "すべてのデータ処理はお客様のブラウザで局所的に実行され、サーバーにアップロードされることはなく、データの安全性を確保します。",
          "ko": "모든 데이터 처리는 브라우저에서 로컬로 수행되며 서버에 업로드되지 않아 데이터 보안을 보장합니다."
        }
      },
      "feature4": {
        "title": {
          "zh-TW": "響應式設計",
          "zh-CN": "响应式设计",
          "en": "Responsive Design",
          "hi": "उत्तरदायी डिज़ाइन",
          "ja": "レスポンシブデザイン",
          "ko": "반응형 디자인"
        },
        "description": {
          "zh-TW": "完美支援桌面、平板和手機等各種裝置，隨時隨地輕鬆使用。",
          "zh-CN": "完美支持桌面、平板和手机等各种装置，随时随地轻松使用。",
          "en": "Perfect support for desktop, tablet, and mobile devices, easy to use anytime, anywhere.",
          "hi": "डेस्कटॉप, टैबलेट और मोबाइल डिवाइस के लिए पूर्ण समर्थन, कभी भी, कहीं भी आसानी से उपयोग करें।",
          "ja": "デスクトップ、タブレット、モバイルデバイスを完全サポート、いつでもどこでも簡単に使用できます。",
          "ko": "데스크톱, 태블릿, 모바일 기기를 완벽하게 지원하여 언제 어디서나 쉽게 사용할 수 있습니다."
        }
      }
    },
    "contact": {
      "title": {
        "zh-TW": "聯絡我們",
        "zh-CN": "联系我们",
        "en": "Contact Us",
        "hi": "हमसे संपर्क करें",
        "ja": "お問い合わせ",
        "ko": "문의하기"
      },
      "content": {
        "zh-TW": "如果您有任何問題、建議或合作意向，歡迎隨時與我們聯繫。我們重視每一位用戶的意見，並致力於持續改善我們的服務。",
        "zh-CN": "如果您有任何问题、建议或合作意向，欢迎随时与我们联系。我们重视每一位用户的意见，并致力于持续改善我们的服务。",
        "en": "If you have any questions, suggestions, or collaboration proposals, please feel free to contact us at any time. We value every user's feedback and are committed to continuously improving our services.",
        "hi": "यदि आपके कोई प्रश्न, सुझाव या सहयोग प्रस्ताव हैं, तो कृपया किसी भी समय हमसे संपर्क करने में संकोच न करें। हम हर उपयोगकर्ता की प्रतिक्रिया को महत्व देते हैं और अपनी सेवाओं में निरंतर सुधार के लिए प्रतिबद्ध हैं।",
        "ja": "ご質問、ご提案、協力のご提案がございましたら、いつでもお気軽にお問い合わせください。私たちはすべてのユーザーのフィードバックを大切にし、サービスの継続的な改善に取り組んでいます。",
        "ko": "질문, 제안 또는 협력 제안이 있으시면 언제든지 저희에게 연락해 주세요. 우리는 모든 사용자의 피드백을 소중히 여기며 서비스를 지속적으로 개선하기 위해 노력하고 있습니다."
      },
      "email": {
        "zh-TW": "電子郵件",
        "zh-CN": "电子邮件",
        "en": "Email",
        "hi": "ईमेल",
        "ja": "メール",
        "ko": "이메일"
      },
      "website": {
        "zh-TW": "官方網站",
        "zh-CN": "官方网站",
        "en": "Official Website",
        "hi": "आधिकारिक वेबसाइट",
        "ja": "公式ウェブサイト",
        "ko": "공식 웹사이트"
      }
    }
  },
  "privacy": {
    "title": {
      "zh-TW": "隱私政策",
      "zh-CN": "隐私政策",
      "en": "Privacy Policy",
      "hi": "गोपनीयता नीति",
      "ja": "プライバシーポリシー",
      "ko": "개인정보 처리방침"
    },
    "subtitle": {
      "zh-TW": "我們重視並保護您的隱私權益",
      "zh-CN": "我们重视并保护您的隐私权益",
      "en": "We value and protect your privacy rights",
      "hi": "हम आपके गोपनीयता अधिकारों को महत्व देते और सुरक्षित करते हैं",
      "ja": "お客様のプライバシー権を重視し保護します",
      "ko": "귀하의 개인정보 보호 권리를 소중히 여기고 보호합니다"
    },
    "lastUpdated": {
      "zh-TW": "最後更新",
      "zh-CN": "最后更新",
      "en": "Last Updated",
      "hi": "अंतिम अपडेट",
      "ja": "最終更新",
      "ko": "최종 업데이트"
    },
    "dataCollection": {
      "title": {
        "zh-TW": "資料收集",
        "zh-CN": "资料收集",
        "en": "Data Collection",
        "hi": "डेटा संग्रह",
        "ja": "データ収集",
        "ko": "데이터 수집"
      },
      "content": {
        "zh-TW": "我們收集的資料僅用於改善服務品質和用戶體驗：",
        "zh-CN": "我们收集的资料仅用于改善服务品质和用户体验：",
        "en": "The data we collect is only used to improve service quality and user experience:",
        "hi": "हम जो डेटा एकत्र करते हैं वह केवल सेवा की गुणवत्ता और उपयोगकर्ता अनुभव सुधारने के लिए उपयोग किया जाता है:",
        "ja": "収集するデータは、サービス品質とユーザー体験の改善のためにのみ使用されます：",
        "ko": "수집하는 데이터는 서비스 품질과 사용자 경험 개선을 위해서만 사용됩니다:"
      },
      "item1": {
        "zh-TW": "網站使用統計（如頁面瀏覽量、停留時間）",
        "zh-CN": "网站使用统计（如页面浏览量、停留时间）",
        "en": "Website usage statistics (such as page views, dwell time)",
        "hi": "वेबसाइट उपयोग आंकड़े (जैसे पेज व्यू, ठहरने का समय)",
        "ja": "ウェブサイト使用統計（ページビュー、滞在時間など）",
        "ko": "웹사이트 사용 통계 (페이지 조회수, 머무른 시간 등)"
      },
      "item2": {
        "zh-TW": "語言偏好設置",
        "zh-CN": "语言偏好设置",
        "en": "Language preference settings",
        "hi": "भाषा प्राथमिकता सेटिंग्स",
        "ja": "言語設定の偏好",
        "ko": "언어 설정 기본 설정"
      },
      "item3": {
        "zh-TW": "技術資訊（瀏覽器類型、作業系統）",
        "zh-CN": "技术资讯（浏览器类型、作业系统）",
        "en": "Technical information (browser type, operating system)",
        "hi": "तकनीकी जानकारी (ब्राउज़र प्रकार, ऑपरेटिंग सिस्टम)",
        "ja": "技術情報（ブラウザタイプ、オペレーティングシステム）",
        "ko": "기술 정보 (브라우저 유형, 운영 체제)"
      }
    },
    "dataUsage": {
      "title": {
        "zh-TW": "資料使用",
        "zh-CN": "资料使用",
        "en": "Data Usage",
        "hi": "डेटा उपयोग",
        "ja": "データ使用",
        "ko": "데이터 사용"
      },
      "content": {
        "zh-TW": "我們使用收集的資料用於以下目的：",
        "zh-CN": "我们使用收集的资料用于以下目的：",
        "en": "We use collected data for the following purposes:",
        "hi": "हम एकत्रित डेटा का उपयोग निम्नलिखित उद्देश्यों के लिए करते हैं:",
        "ja": "収集したデータは以下の目的で使用します：",
        "ko": "수집된 데이터는 다음 목적으로 사용됩니다:"
      },
      "item1": {
        "zh-TW": "提供和維護我們的服務",
        "zh-CN": "提供和维护我们的服务",
        "en": "Provide and maintain our services",
        "hi": "हमारी सेवाएं प्रदान करना और बनाए रखना",
        "ja": "サービスの提供と維持",
        "ko": "서비스 제공 및 유지"
      },
      "item2": {
        "zh-TW": "改善用戶體驗和網站性能",
        "zh-CN": "改善用户体验和网站性能",
        "en": "Improve user experience and website performance",
        "hi": "उपयोगकर्ता अनुभव और वेबसाइट प्रदर्शन में सुधार",
        "ja": "ユーザー体験とウェブサイトパフォーマンスの改善",
        "ko": "사용자 경험 및 웹사이트 성능 개선"
      },
      "item3": {
        "zh-TW": "分析網站使用模式以優化功能",
        "zh-CN": "分析网站使用模式以优化功能",
        "en": "Analyze website usage patterns to optimize features",
        "hi": "सुविधाओं को अनुकूलित करने के लिए वेबसाइट उपयोग पैटर्न का विश्लेषण",
        "ja": "機能最適化のためのウェブサイト使用パターン分析",
        "ko": "기능 최적화를 위한 웹사이트 사용 패턴 분석"
      }
    },
    "dataSecurity": {
      "title": {
        "zh-TW": "資料安全",
        "zh-CN": "资料安全",
        "en": "Data Security",
        "hi": "डेटा सुरक्षा",
        "ja": "データセキュリティ",
        "ko": "데이터 보안"
      },
      "highlight": {
        "zh-TW": "重要：",
        "zh-CN": "重要：",
        "en": "Important:",
        "hi": "महत्वपूर्ण:",
        "ja": "重要：",
        "ko": "중요:"
      },
      "content": {
        "zh-TW": "您使用工具處理的所有數據均在瀏覽器本地處理，絕不上傳到伺服器。",
        "zh-CN": "您使用工具处理的所有数据均在浏览器本地处理，绝不上传到服务器。",
        "en": "All data processed by our tools is handled locally in your browser and never uploaded to servers.",
        "hi": "हमारे उपकरणों द्वारा प्रोसेस किया गया सभी डेटा आपके ब्राउज़र में स्थानीय रूप से संभाला जाता है और कभी भी सर्वर पर अपलोड नहीं होता।",
        "ja": "弊社ツールで処理されるすべてのデータは、お客様のブラウザ内でローカルに処理され、サーバーにアップロードされることはありません。",
        "ko": "당사 도구로 처리되는 모든 데이터는 귀하의 브라우저에서 로컬로 처리되며 서버에 업로드되지 않습니다."
      }
    },
    "cookies": {
      "title": {
        "zh-TW": "Cookie 使用",
        "zh-CN": "Cookie 使用",
        "en": "Cookie Usage",
        "hi": "कुकी उपयोग",
        "ja": "Cookieの使用",
        "ko": "쿠키 사용"
      },
      "content": {
        "zh-TW": "我們使用以下類型的 Cookie 來提供更好的服務：",
        "zh-CN": "我们使用以下类型的 Cookie 来提供更好的服务：",
        "en": "We use the following types of cookies to provide better service:",
        "hi": "हम बेहतर सेवा प्रदान करने के लिए निम्नलिखित प्रकार की कुकीज़ का उपयोग करते हैं:",
        "ja": "より良いサービスを提供するために、以下のタイプのCookieを使用しています：",
        "ko": "더 나은 서비스를 제공하기 위해 다음 유형의 쿠키를 사용합니다:"
      },
      "necessary": {
        "zh-TW": "必要性 Cookie：維持網站基本功能",
        "zh-CN": "必要性 Cookie：维持网站基本功能",
        "en": "Necessary Cookies: Maintain basic website functionality",
        "hi": "आवश्यक कुकीज़: वेबसाइट की बुनियादी कार्यक्षमता बनाए रखती हैं",
        "ja": "必要なCookie：ウェブサイトの基本機能を維持",
        "ko": "필수 쿠키: 웹사이트 기본 기능 유지"
      },
      "analytics": {
        "zh-TW": "分析 Cookie：幫助我們了解網站使用情況",
        "zh-CN": "分析 Cookie：帮助我们了解网站使用情况",
        "en": "Analytics Cookies: Help us understand website usage",
        "hi": "एनालिटिक्स कुकीज़: हमें वेबसाइट उपयोग समझने में मदद करती हैं",
        "ja": "分析Cookie：ウェブサイトの使用状況の理解に役立ちます",
        "ko": "분석 쿠키: 웹사이트 사용 현황을 이해하는 데 도움"
      },
      "advertising": {
        "zh-TW": "廣告 Cookie：顯示相關的廣告內容",
        "zh-CN": "广告 Cookie：显示相关的广告内容",
        "en": "Advertising Cookies: Display relevant advertising content",
        "hi": "विज्ञापन कुकीज़: प्रासंगिक विज्ञापन सामग्री प्रदर्शित करती हैं",
        "ja": "広告Cookie：関連する広告コンテンツを表示",
        "ko": "광고 쿠키: 관련 광고 콘텐츠 표시"
      }
    },
    "thirdParty": {
      "title": {
        "zh-TW": "第三方服務",
        "zh-CN": "第三方服务",
        "en": "Third-Party Services",
        "hi": "तृतीय-पक्ष सेवाएं",
        "ja": "サードパーティサービス",
        "ko": "제3자 서비스"
      },
      "content": {
        "zh-TW": "我們使用以下第三方服務來改善網站功能和用戶體驗：",
        "zh-CN": "我们使用以下第三方服务来改善网站功能和用户体验：",
        "en": "We use the following third-party services to improve website functionality and user experience:",
        "hi": "हम वेबसाइट कार्यक्षमता और उपयोगकर्ता अनुभव सुधारने के लिए निम्नलिखित तृतीय-पक्ष सेवाओं का उपयोग करते हैं:",
        "ja": "ウェブサイトの機能とユーザー体験を改善するために、以下のサードパーティサービスを使用しています：",
        "ko": "웹사이트 기능과 사용자 경험 개선을 위해 다음 제3자 서비스를 사용합니다:"
      },
      "analytics": {
        "zh-TW": "用於分析網站流量和用戶行為，幫助我們優化網站性能",
        "zh-CN": "用于分析网站流量和用户行为，帮助我们优化网站性能",
        "en": "Used to analyze website traffic and user behavior, helping us optimize website performance",
        "hi": "वेबसाइट ट्रैफिक और उपयोगकर्ता व्यवहार का विश्लेषण करने के लिए उपयोग, हमें वेबसाइट प्रदर्शन अनुकूलित करने में मदद करता है",
        "ja": "ウェブサイトのトラフィックとユーザー行動を分析し、ウェブサイトパフォーマンスの最適化に役立てます",
        "ko": "웹사이트 트래픽과 사용자 행동을 분석하여 웹사이트 성능 최적화에 도움"
      },
      "adsense": {
        "zh-TW": "用於顯示相關廣告，支持網站的持續運營和發展",
        "zh-CN": "用于显示相关广告，支持网站的持续运营和发展",
        "en": "Used to display relevant advertisements, supporting the continuous operation and development of the website",
        "hi": "प्रासंगिक विज्ञापन प्रदर्शित करने के लिए उपयोग, वेबसाइट के निरंतर संचालन और विकास का समर्थन करता है",
        "ja": "関連する広告を表示し、ウェブサイトの継続的な運営と発展をサポートします",
        "ko": "관련 광고를 표시하여 웹사이트의 지속적인 운영과 발전을 지원"
      }
    },
    "contact": {
      "title": {
        "zh-TW": "聯絡我們",
        "zh-CN": "联系我们",
        "en": "Contact Us",
        "hi": "हमसे संपर्क करें",
        "ja": "お問い合わせ",
        "ko": "문의하기"
      },
      "content": {
        "zh-TW": "如果您對我們的隱私政策有任何疑問或建議，請聯繫我們：",
        "zh-CN": "如果您对我们的隐私政策有任何疑问或建议，请联系我们：",
        "en": "If you have any questions or suggestions about our privacy policy, please contact us:",
        "hi": "यदि आपके पास हमारी गोपनीयता नीति के बारे में कोई प्रश्न या सुझाव हैं, तो कृपया हमसे संपर्क करें:",
        "ja": "プライバシーポリシーについてご質問やご提案がございましたら、お気軽にお問い合わせください：",
        "ko": "개인정보 처리방침에 대해 질문이나 제안이 있으시면 연락해 주세요:"
      }
    }
  },
  "terms": {
    "title": {
      "zh-TW": "服務條款",
      "zh-CN": "服务条款",
      "en": "Terms of Service",
      "hi": "सेवा की शर्तें",
      "ja": "利用規約",
      "ko": "서비스 이용약관"
    },
    "subtitle": {
      "zh-TW": "使用本網站前請詳細閱讀以下條款",
      "zh-CN": "使用本网站前请详细阅读以下条款",
      "en": "Please read the following terms carefully before using this website",
      "hi": "इस वेबसाइट का उपयोग करने से पहले कृपया निम्नलिखित शर्तों को ध्यान से पढ़ें",
      "ja": "本ウェブサイトをご利用になる前に、以下の条項を詳しくお読みください",
      "ko": "이 웹사이트를 사용하기 전에 다음 약관을 자세히 읽어주세요"
    },
    "lastUpdated": {
      "zh-TW": "最後更新",
      "zh-CN": "最后更新",
      "en": "Last Updated",
      "hi": "अंतिम अपडेट",
      "ja": "最終更新",
      "ko": "최종 업데이트"
    },
    "acceptance": {
      "title": {
        "zh-TW": "條款接受",
        "zh-CN": "条款接受",
        "en": "Terms Acceptance",
        "hi": "शर्तों की स्वीकृति",
        "ja": "規約の承諾",
        "ko": "약관 동의"
      },
      "content": {
        "zh-TW": "使用 CallMeAPI.com 網站及其服務即表示您同意遵守本服務條款。如果您不同意任何條款內容，請停止使用本服務。",
        "zh-CN": "使用 CallMeAPI.com 网站及其服务即表示您同意遵守本服务条款。如果您不同意任何条款内容，请停止使用本服务。",
        "en": "By using the CallMeAPI.com website and its services, you agree to comply with these Terms of Service. If you do not agree to any of the terms, please stop using this service.",
        "hi": "CallMeAPI.com वेबसाइट और इसकी सेवाओं का उपयोग करके, आप इन सेवा शर्तों का पालन करने के लिए सहमत हैं। यदि आप किसी भी शर्त से सहमत नहीं हैं, तो कृपया इस सेवा का उपयोग बंद कर दें।",
        "ja": "CallMeAPI.comウェブサイトとそのサービスを使用することにより、お客様はこの利用規約に従うことに同意したものとみなします。いずれかの条項に同意されない場合は、本サービスの使用を中止してください。",
        "ko": "CallMeAPI.com 웹사이트와 그 서비스를 사용함으로써 귀하는 이 서비스 이용약관을 준수하는 데 동의합니다. 약관 중 어느 하나라도 동의하지 않으시면 이 서비스 사용을 중단해 주세요."
      }
    },
    "services": {
      "title": {
        "zh-TW": "服務說明",
        "zh-CN": "服务说明",
        "en": "Service Description",
        "hi": "सेवा विवरण",
        "ja": "サービス説明",
        "ko": "서비스 설명"
      },
      "content": {
        "zh-TW": "CallMeAPI.com 提供免費的線上 API 開發工具集，包括但不限於：",
        "zh-CN": "CallMeAPI.com 提供免费的线上 API 开发工具集，包括但不限于：",
        "en": "CallMeAPI.com provides free online API development tools, including but not limited to:",
        "hi": "CallMeAPI.com मुफ्त ऑनलाइन API विकास उपकरण प्रदान करता है, जिसमें शामिल हैं लेकिन सीमित नहीं हैं:",
        "ja": "CallMeAPI.comは無料のオンラインAPI開発ツールを提供しており、以下に限定されませんが含まれます：",
        "ko": "CallMeAPI.com은 다음을 포함하되 이에 국한되지 않는 무료 온라인 API 개발 도구를 제공합니다:"
      },
      "free": {
        "title": {
          "zh-TW": "免費提供",
          "zh-CN": "免费提供",
          "en": "Free Services",
          "hi": "मुफ्त सेवाएं",
          "ja": "無料サービス",
          "ko": "무료 서비스"
        },
        "item1": {
          "zh-TW": "JSON 格式化與驗證工具",
          "zh-CN": "JSON 格式化与验证工具",
          "en": "JSON formatter and validator tools",
          "hi": "JSON फॉर्मेटर और सत्यापन उपकरण",
          "ja": "JSONフォーマッターと検証ツール",
          "ko": "JSON 포맷터 및 검증 도구"
        },
        "item2": {
          "zh-TW": "Base64 編碼解碼工具",
          "zh-CN": "Base64 编码解码工具",
          "en": "Base64 encoder/decoder tools",
          "hi": "Base64 एन्कोडर/डिकोडर उपकरण",
          "ja": "Base64エンコーダー/デコーダーツール",
          "ko": "Base64 인코더/디코더 도구"
        },
        "item3": {
          "zh-TW": "API 測試與監控工具",
          "zh-CN": "API 测试与监控工具",
          "en": "API testing and monitoring tools",
          "hi": "API परीक्षण और निगरानी उपकरण",
          "ja": "APIテストと監視ツール",
          "ko": "API 테스트 및 모니터링 도구"
        }
      }
    },
    "restrictions": {
      "title": {
        "zh-TW": "使用限制",
        "zh-CN": "使用限制",
        "en": "Usage Restrictions",
        "hi": "उपयोग प्रतिबंध",
        "ja": "使用制限",
        "ko": "사용 제한"
      },
      "content": {
        "zh-TW": "為維護服務品質與安全，以下行為是被禁止的：",
        "zh-CN": "为维护服务品质与安全，以下行为是被禁止的：",
        "en": "To maintain service quality and security, the following behaviors are prohibited:",
        "hi": "सेवा की गुणवत्ता और सुरक्षा बनाए रखने के लिए, निम्नलिखित व्यवहार प्रतिबंधित हैं:",
        "ja": "サービス品質とセキュリティを維持するため、以下の行為は禁止されています：",
        "ko": "서비스 품질과 보안을 유지하기 위해 다음 행위는 금지됩니다:"
      },
      "prohibited": {
        "title": {
          "zh-TW": "禁止行為",
          "zh-CN": "禁止行为",
          "en": "Prohibited Activities",
          "hi": "प्रतिबंधित गतिविधियां",
          "ja": "禁止行為",
          "ko": "금지된 활동"
        },
        "item1": {
          "zh-TW": "惡意攻擊或破壞服務",
          "zh-CN": "恶意攻击或破坏服务",
          "en": "Malicious attacks or service disruption",
          "hi": "दुर्भावनापूर्ण हमले या सेवा में व्यवधान",
          "ja": "悪意のある攻撃やサービスの破壊",
          "ko": "악의적인 공격이나 서비스 방해"
        },
        "item2": {
          "zh-TW": "濫用系統資源或過度請求",
          "zh-CN": "滥用系统资源或过度请求",
          "en": "Abuse of system resources or excessive requests",
          "hi": "सिस्टम संसाधनों का दुरुपयोग या अत्यधिक अनुरोध",
          "ja": "システムリソースの乱用や過度のリクエスト",
          "ko": "시스템 리소스 남용이나 과도한 요청"
        },
        "item3": {
          "zh-TW": "傳播非法、有害或不當內容",
          "zh-CN": "传播非法、有害或不当内容",
          "en": "Spreading illegal, harmful or inappropriate content",
          "hi": "अवैध, हानिकारक या अनुचित सामग्री का प्रसार",
          "ja": "違法、有害、または不適切なコンテンツの拡散",
          "ko": "불법적이거나 유해하거나 부적절한 콘텐츠 유포"
        },
        "item4": {
          "zh-TW": "侵犯他人智慧財產權",
          "zh-CN": "侵犯他人智慧财产权",
          "en": "Infringing on others' intellectual property rights",
          "hi": "दूसरों के बौद्धिक संपदा अधिकारों का उल्लंघन",
          "ja": "他者の知的財産権の侵害",
          "ko": "타인의 지적재산권 침해"
        }
      }
    },
    "disclaimer": {
      "title": {
        "zh-TW": "免責聲明",
        "zh-CN": "免责声明",
        "en": "Disclaimer",
        "hi": "अस्वीकरण",
        "ja": "免責事項",
        "ko": "면책조항"
      },
      "content": {
        "zh-TW": "本服務按「現狀」提供，我們不對服務的可用性、準確性或適用性做任何明示或暗示的保證。",
        "zh-CN": "本服务按「现状」提供，我们不对服务的可用性、准确性或适用性做任何明示或暗示的保证。",
        "en": "This service is provided 'as is', and we make no express or implied warranties regarding the service.",
        "hi": "यह सेवा 'जैसी है' के आधार पर प्रदान की जाती है, और हम सेवा के संबंध में कोई स्पष्ट या निहित वारंटी नहीं देते।",
        "ja": "本サービスは「現状のまま」提供され、サービスについて明示的または暗示的な保証は一切いたしません。",
        "ko": "이 서비스는 '현재 상태 그대로' 제공되며, 당사는 서비스에 대해 명시적이거나 묵시적인 보증을 하지 않습니다."
      },
      "important": {
        "zh-TW": "重要提醒",
        "zh-CN": "重要提醒",
        "en": "Important Notice",
        "hi": "महत्वपूर्ण सूचना",
        "ja": "重要なお知らせ",
        "ko": "중요 알림"
      }
    },
    "intellectual": {
      "title": {
        "zh-TW": "智慧財產權",
        "zh-CN": "智慧财产权",
        "en": "Intellectual Property",
        "hi": "बौद्धिक संपदा",
        "ja": "知的財産権",
        "ko": "지적재산권"
      },
      "content": {
        "zh-TW": "本網站及其內容受智慧財產權法保護。未經授權，不得複製、分發或修改任何內容。",
        "zh-CN": "本网站及其内容受智慧财产权法保护。未经授权，不得复制、分发或修改任何内容。",
        "en": "This website and its content are protected by intellectual property laws. Unauthorized reproduction, distribution, or modification is prohibited.",
        "hi": "यह वेबसाइट और इसकी सामग्री बौद्धिक संपदा कानूनों द्वारा संरक्षित है। अनधिकृत प्रजनन, वितरण या संशोधन निषिद्ध है।",
        "ja": "本ウェブサイトとそのコンテンツは知的財産法により保護されています。無許可での複製、配布、修正は禁止されています。",
        "ko": "이 웹사이트와 그 콘텐츠는 지적재산법에 의해 보호됩니다. 무단 복제, 배포 또는 수정은 금지됩니다."
      }
    },
    "changes": {
      "title": {
        "zh-TW": "服務變更",
        "zh-CN": "服务变更",
        "en": "Service Changes",
        "hi": "सेवा परिवर्तन",
        "ja": "サービス変更",
        "ko": "서비스 변경"
      },
      "content": {
        "zh-TW": "我們保留隨時修改或終止服務的權利，恕不另行通知。重大變更將通過網站公告。",
        "zh-CN": "我们保留随时修改或终止服务的权利，恕不另行通知。重大变更将通过网站公告。",
        "en": "We reserve the right to modify or terminate services at any time without notice. Major changes will be announced on the website.",
        "hi": "हम बिना सूचना के किसी भी समय सेवाओं को संशोधित या समाप्त करने का अधिकार रखते हैं। मुख्य परिवर्तनों की घोषणा वेबसाइट पर की जाएगी।",
        "ja": "当社は予告なくサービスを変更または終了する権利を留保します。重要な変更はウェブサイトで発表いたします。",
        "ko": "당사는 예고 없이 언제든지 서비스를 수정하거나 종료할 권리를 보유합니다. 주요 변경 사항은 웹사이트에서 공지됩니다."
      }
    },
    "contact": {
      "title": {
        "zh-TW": "法律問題諮詢",
        "zh-CN": "法律问题咨询",
        "en": "Legal Inquiries",
        "hi": "कानूनी पूछताछ",
        "ja": "法的お問い合わせ",
        "ko": "법적 문의"
      },
      "content": {
        "zh-TW": "如對本條款有任何疑問，請聯絡我們的法務部門。",
        "zh-CN": "如对本条款有任何疑问，请联络我们的法务部门。",
        "en": "If you have any questions about these terms, please contact our legal department.",
        "hi": "यदि आपके पास इन शर्तों के बारे में कोई प्रश्न हैं, तो कृपया हमारे कानूनी विभाग से संपर्क करें।",
        "ja": "これらの条項についてご質問がございましたら、当社の法務部門にお問い合わせください。",
        "ko": "이 약관에 대해 궁금한 점이 있으시면 당사 법무부서에 문의해 주세요."
      }
    }
  },
  "rights": {
    "zh-TW": "版權所有",
    "zh-CN": "版权所有",
    "en": "All rights reserved",
    "hi": "सभी अधिकार सुरक्षित",
    "ja": "すべての権利を保有",
    "ko": "모든 권리 보유"
  },
  "header": {
    "subtitle": {
      "zh-TW": "全自動化API開發工具集，提升開發效率",
      "zh-CN": "全自动化API开发工具集，提升开发效率",
      "en": "Automated API development toolkit to boost development efficiency",
      "hi": "विकास दक्षता बढ़ाने के लिए स्वचालित API विकास टूलकिट",
      "ja": "完全自動化API開発ツールセット、開発効率を向上",
      "ko": "개발 효율성을 높이는 자동화된 API 개발 툴킷"
    },
    "title": {
      "zh-TW": "專業API開發工具",
      "zh-CN": "专业API开发工具",
      "en": "Professional API Development Tools",
      "hi": "पेशेवर API विकास उपकरण",
      "ja": "プロフェッショナルAPI開発ツール",
      "ko": "전문 API 개발 도구"
    }
  },
  "seo": {
    "base64Tool": {
      "description": {
        "zh-TW": "免費的Base64編碼解碼工具，支援文字和二進制數據轉換。快速、安全、免註冊。",
        "zh-CN": "免费的Base64编码解码工具，支持文字和二进制数据转换。快速、安全、免註冊。",
        "en": "Free Base64 encoder decoder tool. Support text and binary data conversion. Fast, secure, no registration required.",
        "hi": "मुफ्त Base64 एन्कोडिंग डिकोडिंग टूल, टेक्स्ट और बाइनरी डेटा रूपांतरण का समर्थन। तेज़, सुरक्षित, पंजीकरण मुक्त।",
        "ja": "無料のBase64エンコード・デコードツール。テキストとバイナリデータの変換をサポート。高速、安全、登録不要。",
        "ko": "무료 온라인 Base64 인코더 및 디코더 도구. 텍스트와 파일을 Base64로 인코딩 및 디코딩합니다."
      },
      "keywords": {
        "zh-TW": "Base64編碼,Base64解碼,編碼工具,數據轉換",
        "zh-CN": "Base64编码,Base64解码,编码工具,数据转换",
        "en": "Base64 encoder,Base64 decoder,encoding tool,data conversion",
        "hi": "Base64 एन्कोडिंग,Base64 डिकोडिंग,एन्कोडिंग टूल,डेटा रूपांतरण",
        "ja": "Base64エンコード,Base64デコード,エンコードツール,データ変換",
        "ko": "Base64 인코더, Base64 디코더, Base64 변환, 인코딩 도구"
      },
      "title": {
        "zh-TW": "Base64編碼工具 - 編碼解碼 | CallMeAPI",
        "zh-CN": "Base64编码工具 - 编码解码 | CallMeAPI",
        "en": "Base64 Encoder Tool - Encode & Decode | CallMeAPI",
        "hi": "Base64 एन्कोडिंग टूल - एन्कोडिंग डिकोडिंग | CallMeAPI",
        "ja": "Base64エンコーダー/デコーダー - テキスト・ファイルエンコード | CallMeAPI.com",
        "ko": "Base64 인코더/디코더 - 텍스트 및 파일 인코딩 | CallMeAPI.com"
      }
    },
    "home": {
      "description": {
        "zh-TW": "提供專業的API測試、文件處理、數據視覺化等開發工具。支援批量處理、即時監控，提升開發效率。",
        "zh-CN": "提供专业的API测试、文件处理、数据视觉化等开发工具。支持批量处理、即时监控，提升开发效率。",
        "en": "Professional API testing, file processing, data visualization tools. Support batch processing, real-time monitoring to boost development efficiency.",
        "hi": "पेशेवर API टेस्टिंग, डेटा प्रसंस्करण, डेटा विज़ुअलाइज़ेशन और अन्य डेवलपमेंट टूल्स प्रदान करता है। बैच प्रसंस्करण, रीयल-टाइम मॉनिटरिंग का समर्थन, विकास दक्षता में सुधार।",
        "ja": "プロフェッショナルなAPIテスト、ファイル処理、データ可視化などの開発ツールを提供。バッチ処理、リアルタイム監視をサポートし、開発効率を向上。",
        "ko": "무료 온라인 API 개발 도구. JSON 포맷터, Base64 인코더, API 테스터 등 다양한 도구. 개발자 필수 도구."
      },
      "keywords": {
        "zh-TW": "API測試,JSON格式化,Base64編碼,開發工具,API工具,線上工具",
        "zh-CN": "API测试,JSON格式化,Base64编码,开发工具,API工具,线上工具",
        "en": "API testing,JSON formatter,Base64 encoder,developer tools,API tools,online tools",
        "hi": "API टेस्टिंग,JSON फॉर्मेटिंग,Base64 एन्कोडिंग,डेवलपमेंट टूल्स,API टूल्स,ऑनलाइन टूल्स",
        "ja": "APIテスト,JSONフォーマット,Base64エンコード,開発ツール,APIツール,オンラインツール",
        "ko": "API 도구, JSON 포맷터, Base64 인코더, API 테스트, 개발 도구, 온라인 도구"
      },
      "title": {
        "zh-TW": "CallMeAPI - 專業API開發工具集 | 免費線上工具",
        "zh-CN": "CallMeAPI - 专业API开发工具集 | 免费线上工具",
        "en": "CallMeAPI - Professional API Development Tools | Free Online Tools",
        "hi": "CallMeAPI - पेशेवर API डेवलपमेंट टूल सेट | मुफ्त ऑनलाइन टूल्स",
        "ja": "CallMeAPI - プロフェッショナルAPI開発ツールセット | 無料オンラインツール",
        "ko": "CallMeAPI.com - 전문 API 개발 도구"
      }
    },
    "jsonFormatter": {
      "description": {
        "zh-TW": "線上JSON格式化和驗證工具，支援大型文件處理、語法檢查、格式轉換。開發者必備工具。",
        "zh-CN": "线上JSON格式化和验证工具，支持大型文件处理、语法检查、格式转换。开发者必备工具。",
        "en": "Online JSON formatter and validator tool. Support large file processing, syntax checking, format conversion. Essential developer tool.",
        "hi": "ऑनलाइन JSON फॉर्मेटिंग और सत्यापन टूल, बड़ी फ़ाइल प्रसंस्करण, सिंटैक्स जांच, फॉर्मेट रूपांतरण का समर्थन। डेवलपर्स के लिए आवश्यक टूल।",
        "ja": "オンラインJSON フォーマット・検証ツール。大型ファイル処理、構文チェック、形式変換をサポート。開発者必須ツール。",
        "ko": "무료 온라인 JSON 포맷터 도구. JSON 데이터를 아름답게 포맷하고, 검증하며, 압축합니다. 대용량 파일 지원."
      },
      "keywords": {
        "zh-TW": "JSON格式化,JSON驗證,JSON美化,JSON工具,格式轉換",
        "zh-CN": "JSON格式化,JSON验证,JSON美化,JSON工具,格式转换",
        "en": "JSON formatter,JSON validator,JSON beautifier,JSON tool,format conversion",
        "hi": "JSON फॉर्मेटिंग,JSON सत्यापन,JSON सुंदरीकरण,JSON टूल,फॉर्मेट रूपांतरण",
        "ja": "JSONフォーマット,JSON検証,JSON美化,JSONツール,形式変換",
        "ko": "JSON 포맷터, JSON 검증, JSON 아름답게, JSON 압축, JSON 도구"
      },
      "title": {
        "zh-TW": "JSON格式化工具 - 美化與驗證 | CallMeAPI",
        "zh-CN": "JSON格式化工具 - 美化与验证 | CallMeAPI",
        "en": "JSON Formatter Tool - Format & Validate | CallMeAPI",
        "hi": "JSON फॉर्मेटिंग टूल - सुंदरीकरण और सत्यापन | CallMeAPI",
        "ja": "JSONフォーマットツール - 美化と検証 | CallMeAPI",
        "ko": "JSON 포맷터 - JSON 아름답게 포맷하고 검증 | CallMeAPI.com"
      }
    }
  },
  "tools": {
    "uuidGenerator": {
      "title": {
        "zh-TW": "UUID 生成器",
        "zh-CN": "UUID 生成器",
        "en": "UUID Generator",
        "hi": "UUID जेनरेटर",
        "ja": "UUID ジェネレーター",
        "ko": "UUID 생성기"
      },
      "description": {
        "zh-TW": "生成和驗證 UUID V1~V8 的所有版本，支援批量生成和格式驗證",
        "zh-CN": "生成和验证 UUID V1~V8 的所有版本，支持批量生成和格式验证",
        "en": "Generate and validate all versions of UUID V1~V8, support batch generation and format validation",
        "hi": "UUID V1~V8 के सभी संस्करणों को उत्पन्न और सत्यापित करें, बैच जेनरेशन और फॉर्मेट सत्यापन का समर्थन करता है",
        "ja": "UUID V1~V8 のすべてのバージョンを生成・検証、バッチ生成とフォーマット検証をサポート",
        "ko": "UUID V1~V8의 모든 버전을 생성 및 검증하며, 배치 생성 및 형식 검증을 지원합니다"
      },
      "generate": {
        "title": {
          "zh-TW": "UUID 生成",
          "zh-CN": "UUID 生成",
          "en": "UUID Generation",
          "hi": "UUID जेनरेशन",
          "ja": "UUID 生成",
          "ko": "UUID 생성"
        },
        "version": {
          "zh-TW": "選擇 UUID 版本",
          "zh-CN": "选择 UUID 版本",
          "en": "Select UUID Version",
          "hi": "UUID संस्करण चुनें",
          "ja": "UUID バージョンを選択",
          "ko": "UUID 버전 선택"
        },
        "namespace": {
          "zh-TW": "命名空間",
          "zh-CN": "命名空间",
          "en": "Namespace",
          "hi": "नेमस्पेस",
          "ja": "ネームスペース",
          "ko": "네임스페이스"
        },
        "customNamespace": {
          "zh-TW": "自定義命名空間",
          "zh-CN": "自定义命名空间",
          "en": "Custom Namespace",
          "hi": "कस्टम नेमस्पेस",
          "ja": "カスタムネームスペース",
          "ko": "사용자 정의 네임스페이스"
        },
        "name": {
          "zh-TW": "名稱",
          "zh-CN": "名称",
          "en": "Name",
          "hi": "नाम",
          "ja": "名前",
          "ko": "이름"
        },
        "namePlaceholder": {
          "zh-TW": "輸入要生成 UUID 的名稱",
          "zh-CN": "输入要生成 UUID 的名称",
          "en": "Enter name to generate UUID",
          "hi": "UUID उत्पन्न करने के लिए नाम दर्ज करें",
          "ja": "UUID を生成する名前を入力",
          "ko": "UUID를 생성할 이름을 입력하세요"
        },
        "customNamespaceUuid": {
          "zh-TW": "自定義命名空間 UUID",
          "zh-CN": "自定义命名空间 UUID",
          "en": "Custom Namespace UUID",
          "hi": "कस्टम नेमस्पेस UUID",
          "ja": "カスタムネームスペース UUID",
          "ko": "사용자 정의 네임스페이스 UUID"
        },
        "quantity": {
          "zh-TW": "生成數量",
          "zh-CN": "生成数量",
          "en": "Quantity",
          "hi": "मात्रा",
          "ja": "生成数",
          "ko": "생성 수량"
        },
        "quantityHint": {
          "zh-TW": "最多可生成 100 個 UUID",
          "zh-CN": "最多可生成 100 个 UUID",
          "en": "Maximum 100 UUIDs can be generated",
          "hi": "अधिकतम 100 UUID उत्पन्न किए जा सकते हैं",
          "ja": "最大 100 個の UUID を生成可能",
          "ko": "최대 100개의 UUID를 생성할 수 있습니다"
        },
        "button": {
          "zh-TW": "生成 UUID",
          "zh-CN": "生成 UUID",
          "en": "Generate UUID",
          "hi": "UUID उत्पन्न करें",
          "ja": "UUID を生成",
          "ko": "UUID 생성"
        },
        "results": {
          "zh-TW": "生成結果",
          "zh-CN": "生成结果",
          "en": "Generated Results",
          "hi": "उत्पन्न परिणाम",
          "ja": "生成結果",
          "ko": "생성 결과"
        }
      },
      "validate": {
        "title": {
          "zh-TW": "UUID 驗證",
          "zh-CN": "UUID 验证",
          "en": "UUID Validation",
          "hi": "UUID सत्यापन",
          "ja": "UUID 検証",
          "ko": "UUID 검증"
        },
        "input": {
          "zh-TW": "輸入 UUID",
          "zh-CN": "输入 UUID",
          "en": "Input UUID",
          "hi": "UUID दर्ज करें",
          "ja": "UUID を入力",
          "ko": "UUID 입력"
        },
        "placeholder": {
          "zh-TW": "輸入一個或多個 UUID（每行一個，或用逗號、分號分隔）",
          "zh-CN": "输入一个或多个 UUID（每行一个，或用逗号、分号分隔）",
          "en": "Enter one or more UUIDs (one per line, or separated by commas/semicolons)",
          "hi": "एक या अधिक UUID दर्ज करें (प्रति पंक्ति एक, या अल्पविराम/अर्धविराम से अलग)",
          "ja": "1つ以上の UUID を入力（1行に1つ、またはカンマ/セミコロンで区切り）",
          "ko": "하나 이상의 UUID를 입력하세요 (한 줄에 하나씩, 또는 쉼표/세미콜론으로 구분)"
        },
        "results": {
          "zh-TW": "驗證結果",
          "zh-CN": "验证结果",
          "en": "Validation Results",
          "hi": "सत्यापन परिणाम",
          "ja": "検証結果",
          "ko": "검증 결과"
        },
        "valid": {
          "zh-TW": "有效",
          "zh-CN": "有效",
          "en": "Valid",
          "hi": "वैध",
          "ja": "有効",
          "ko": "유효"
        },
        "invalid": {
          "zh-TW": "無效",
          "zh-CN": "无效",
          "en": "Invalid",
          "hi": "अवैध",
          "ja": "無効",
          "ko": "무효"
        },
        "version": {
          "zh-TW": "版本",
          "zh-CN": "版本",
          "en": "Version",
          "hi": "संस्करण",
          "ja": "バージョン",
          "ko": "버전"
        },
        "timestamp": {
          "zh-TW": "時間戳",
          "zh-CN": "时间戳",
          "en": "Timestamp",
          "hi": "टाइमस्टैम्प",
          "ja": "タイムスタンプ",
          "ko": "타임스탬프"
        },
        "node": {
          "zh-TW": "節點",
          "zh-CN": "节点",
          "en": "Node",
          "hi": "नोड",
          "ja": "ノード",
          "ko": "노드"
        },
        "clockSequence": {
          "zh-TW": "時鐘序列",
          "zh-CN": "时钟序列",
          "en": "Clock Sequence",
          "hi": "क्लॉक अनुक्रम",
          "ja": "クロックシーケンス",
          "ko": "클록 시퀀스"
        },
        "invalidFormat": {
          "zh-TW": "無效的 UUID 格式",
          "zh-CN": "无效的 UUID 格式",
          "en": "Invalid UUID format",
          "hi": "अवैध UUID प्रारूप",
          "ja": "無効な UUID 形式",
          "ko": "잘못된 UUID 형식"
        }
      },
      "versions": {
        "v1": {
          "zh-TW": "時間戳",
          "zh-CN": "时间戳",
          "en": "Timestamp",
          "hi": "टाइमस्टैम्प",
          "ja": "タイムスタンプ",
          "ko": "타임스탬프"
        },
        "v3": {
          "zh-TW": "MD5 哈希",
          "zh-CN": "MD5 哈希",
          "en": "MD5 Hash",
          "hi": "MD5 हैश",
          "ja": "MD5 ハッシュ",
          "ko": "MD5 해시"
        },
        "v4": {
          "zh-TW": "隨機",
          "zh-CN": "随机",
          "en": "Random",
          "hi": "यादृच्छिक",
          "ja": "ランダム",
          "ko": "랜덤"
        },
        "v5": {
          "zh-TW": "SHA-1 哈希",
          "zh-CN": "SHA-1 哈希",
          "en": "SHA-1 Hash",
          "hi": "SHA-1 हैश",
          "ja": "SHA-1 ハッシュ",
          "ko": "SHA-1 해시"
        },
        "v6": {
          "zh-TW": "重排時間戳",
          "zh-CN": "重排时间戳",
          "en": "Reordered Time",
          "hi": "पुनः क्रमबद्ध समय",
          "ja": "再配列時間",
          "ko": "재정렬 시간"
        },
        "v7": {
          "zh-TW": "Unix 時間戳",
          "zh-CN": "Unix 时间戳",
          "en": "Unix Timestamp",
          "hi": "Unix टाइमस्टैम्प",
          "ja": "Unix タイムスタンプ",
          "ko": "Unix 타임스탬프"
        },
        "v8": {
          "zh-TW": "自定義",
          "zh-CN": "自定义",
          "en": "Custom",
          "hi": "कस्टम",
          "ja": "カスタム",
          "ko": "사용자 정의"
        }
      },
      "usage": {
        "title": {
          "zh-TW": "使用說明",
          "zh-CN": "使用说明",
          "en": "Usage Instructions",
          "hi": "उपयोग निर्देश",
          "ja": "使用方法",
          "ko": "사용 방법"
        },
        "description": {
          "zh-TW": "此工具支援生成和驗證所有 UUID 版本，適用於軟體開發、資料庫設計和系統整合。",
          "zh-CN": "此工具支持生成和验证所有 UUID 版本，适用于软件开发、数据库设计和系统集成。",
          "en": "This tool supports generating and validating all UUID versions, suitable for software development, database design, and system integration.",
          "hi": "यह टूल सभी UUID संस्करणों को उत्पन्न और सत्यापित करने का समर्थन करता है, सॉफ्टवेयर विकास, डेटाबेस डिज़ाइन और सिस्टम एकीकरण के लिए उपयुक्त है।",
          "ja": "このツールはすべての UUID バージョンの生成と検証をサポートし、ソフトウェア開発、データベース設計、システム統合に適しています。",
          "ko": "이 도구는 모든 UUID 버전의 생성 및 검증을 지원하며, 소프트웨어 개발, 데이터베이스 설계 및 시스템 통합에 적합합니다."
        },
        "feature1": {
          "zh-TW": "支援 UUID V1~V8 所有版本的生成",
          "zh-CN": "支持 UUID V1~V8 所有版本的生成",
          "en": "Support generation of all UUID versions V1~V8",
          "hi": "UUID V1~V8 के सभी संस्करणों के जेनरेशन का समर्थन करता है",
          "ja": "UUID V1~V8 のすべてのバージョンの生成をサポート",
          "ko": "UUID V1~V8 모든 버전의 생성을 지원"
        },
        "feature2": {
          "zh-TW": "批量生成最多 100 個 UUID",
          "zh-CN": "批量生成最多 100 个 UUID",
          "en": "Batch generate up to 100 UUIDs",
          "hi": "अधिकतम 100 UUID का बैच जेनरेशन",
          "ja": "最大 100 個の UUID をバッチ生成",
          "ko": "최대 100개의 UUID를 배치 생성"
        },
        "feature3": {
          "zh-TW": "即時驗證 UUID 格式和版本",
          "zh-CN": "即时验证 UUID 格式和版本",
          "en": "Real-time validation of UUID format and version",
          "hi": "UUID प्रारूप और संस्करण का रीयल-टाइम सत्यापन",
          "ja": "UUID フォーマットとバージョンのリアルタイム検証",
          "ko": "UUID 형식 및 버전의 실시간 검증"
        },
        "feature4": {
          "zh-TW": "顯示 UUID 詳細資訊（時間戳、節點等）",
          "zh-CN": "显示 UUID 详细信息（时间戳、节点等）",
          "en": "Display detailed UUID information (timestamp, node, etc.)",
          "hi": "UUID की विस्तृत जानकारी प्रदर्शित करें (टाइमस्टैम्प, नोड, आदि)",
          "ja": "UUID の詳細情報を表示（タイムスタンプ、ノードなど）",
          "ko": "UUID 상세 정보 표시 (타임스탬프, 노드 등)"
        },
        "v1": {
          "zh-TW": "基於時間戳和 MAC 地址生成，包含時間資訊",
          "zh-CN": "基于时间戳和 MAC 地址生成，包含时间信息",
          "en": "Generated based on timestamp and MAC address, contains time information",
          "hi": "टाइमस्टैम्प और MAC एड्रेस के आधार पर उत्पन्न, समय की जानकारी शामिल है",
          "ja": "タイムスタンプと MAC アドレスに基づいて生成、時間情報を含む",
          "ko": "타임스탬프와 MAC 주소를 기반으로 생성하며, 시간 정보를 포함"
        },
        "v3": {
          "zh-TW": "基於命名空間和名稱的 MD5 哈希生成",
          "zh-CN": "基于命名空间和名称的 MD5 哈希生成",
          "en": "Generated using MD5 hash of namespace and name",
          "hi": "नेमस्पेस और नाम केMD5 हैश का उपयोग करके उत्पन्न",
          "ja": "ネームスペースと名前の MD5 ハッシュを使用して生成",
          "ko": "네임스페이스와 이름의 MD5 해시를 사용하여 생성"
        },
        "v4": {
          "zh-TW": "完全隨機生成，最常用的版本",
          "zh-CN": "完全随机生成，最常用的版本",
          "en": "Completely random generation, most commonly used version",
          "hi": "पूर्णतः यादृच्छिक जेनरेशन, सबसे अधिक उपयोग किया जाने वाला संस्करण",
          "ja": "完全にランダムに生成、最もよく使用されるバージョン",
          "ko": "완전 랜덤 생성, 가장 일반적으로 사용되는 버전"
        },
        "v5": {
          "zh-TW": "基於命名空間和名稱的 SHA-1 哈希生成",
          "zh-CN": "基于命名空间和名称的 SHA-1 哈希生成",
          "en": "Generated using SHA-1 hash of namespace and name",
          "hi": "नेमस्पेस और नाम के SHA-1 हैश का उपयोग करके उत्पन्न",
          "ja": "ネームスペースと名前の SHA-1 ハッシュを使用して生成",
          "ko": "네임스페이스와 이름의 SHA-1 해시를 사용하여 생성"
        },
        "v6": {
          "zh-TW": "重新排序的時間基 UUID，改善排序性能",
          "zh-CN": "重新排序的时间基 UUID，改善排序性能",
          "en": "Reordered time-based UUID, improved sorting performance",
          "hi": "पुनः क्रमबद्ध समय-आधारित UUID, बेहतर सॉर्टिंग प्रदर्शन",
          "ja": "再配列された時間ベースの UUID、ソート性能の向上",
          "ko": "재정렬된 시간 기반 UUID, 정렬 성능 향상"
        },
        "v7": {
          "zh-TW": "基於 Unix 時間戳，提供毫秒精度",
          "zh-CN": "基于 Unix 时间戳，提供毫秒精度",
          "en": "Based on Unix timestamp, provides millisecond precision",
          "hi": "Unix टाइमस्टैम्प पर आधारित, मिलीसेकंड परिशुद्धता प्रदान करता है",
          "ja": "Unix タイムスタンプに基づき、ミリ秒精度を提供",
          "ko": "Unix 타임스탬프 기반, 밀리초 정밀도 제공"
        }
      }
    },
    "markdownPreviewer": {
      "title": {
        "zh-TW": "Markdown 預覽器",
        "zh-CN": "Markdown 预览器",
        "en": "Markdown Previewer",
        "hi": "Markdown प्रीव्यूअर",
        "ja": "Markdown プレビューアー",
        "ko": "Markdown 미리보기"
      },
      "description": {
        "zh-TW": "即時預覽 Markdown 文件，支援語法高亮、表格、代碼區塊和響應式佈局",
        "zh-CN": "即时预览 Markdown 文件，支持语法高亮、表格、代码区块和响应式布局",
        "en": "Real-time Markdown preview with syntax highlighting, tables, code blocks, and responsive layout",
        "hi": "सिंटैक्स हाइलाइटिंग, टेबल, कोड ब्लॉक और रिस्पॉन्सिव लेआउट के साथ रीयल-टाइम Markdown पूर्वावलोकन",
        "ja": "シンタックスハイライト、テーブル、コードブロック、レスポンシブレイアウト対応のリアルタイム Markdown プレビュー",
        "ko": "구문 강조, 테이블, 코드 블록 및 반응형 레이아웃을 지원하는 실시간 Markdown 미리보기"
      },
      "keywords": {
        "zh-TW": "Markdown, 預覽器, 編輯器, 文件, HTML, 語法高亮, 即時預覽",
        "zh-CN": "Markdown, 预览器, 编辑器, 文档, HTML, 语法高亮, 即时预览",
        "en": "Markdown, previewer, editor, document, HTML, syntax highlighting, real-time preview",
        "hi": "Markdown, प्रीव्यूअर, एडिटर, दस्तावेज़, HTML, सिंटैक्स हाइलाइटिंग, रीयल-टाइम प्रीव्यू",
        "ja": "Markdown, プレビューアー, エディター, ドキュメント, HTML, シンタックスハイライト, リアルタイムプレビュー",
        "ko": "Markdown, 미리보기, 편집기, 문서, HTML, 구문 강조, 실시간 미리보기"
      },
      "input": {
        "zh-TW": "Markdown 輸入",
        "zh-CN": "Markdown 输入",
        "en": "Markdown Input",
        "hi": "Markdown इनपुट",
        "ja": "Markdown 入力",
        "ko": "Markdown 입력"
      },
      "inputPlaceholder": {
        "zh-TW": "在此輸入您的 Markdown 內容...",
        "zh-CN": "在此输入您的 Markdown 内容...",
        "en": "Enter your Markdown content here...",
        "hi": "यहाँ अपना Markdown कंटेंट दर्ज करें...",
        "ja": "ここに Markdown コンテンツを入力してください...",
        "ko": "여기에 Markdown 콘텐츠를 입력하세요..."
      },
      "preview": {
        "zh-TW": "即時預覽",
        "zh-CN": "即时预览",
        "en": "Live Preview",
        "hi": "लाइव प्रीव्यू",
        "ja": "ライブプレビュー",
        "ko": "실시간 미리보기"
      },
      "emptyPreview": {
        "zh-TW": "輸入 Markdown 內容以查看預覽",
        "zh-CN": "输入 Markdown 内容以查看预览",
        "en": "Enter Markdown content to see preview",
        "hi": "प्रीव्यू देखने के लिए Markdown कंटेंट दर्ज करें",
        "ja": "プレビューを表示するには Markdown コンテンツを入力してください",
        "ko": "미리보기를 보려면 Markdown 콘텐츠를 입력하세요"
      },
      "copyMarkdown": {
        "zh-TW": "複製 Markdown",
        "zh-CN": "复制 Markdown",
        "en": "Copy Markdown",
        "hi": "Markdown कॉपी करें",
        "ja": "Markdown をコピー",
        "ko": "Markdown 복사"
      },
      "copyHtml": {
        "zh-TW": "複製 HTML",
        "zh-CN": "复制 HTML",
        "en": "Copy HTML",
        "hi": "HTML कॉपी करें",
        "ja": "HTML をコピー",
        "ko": "HTML 복사"
      },
      "layout": {
        "zh-TW": "佈局",
        "zh-CN": "布局",
        "en": "Layout",
        "hi": "लेआउट",
        "ja": "レイアウト",
        "ko": "레이아웃"
      },
      "horizontal": {
        "zh-TW": "左右分割",
        "zh-CN": "左右分割",
        "en": "Horizontal",
        "hi": "क्षैतिज",
        "ja": "水平分割",
        "ko": "가로 분할"
      },
      "vertical": {
        "zh-TW": "上下分割",
        "zh-CN": "上下分割",
        "en": "Vertical",
        "hi": "ऊर्ध्वाधर",
        "ja": "垂直分割",
        "ko": "세로 분할"
      },
      "usage": {
        "title": {
          "zh-TW": "使用說明",
          "zh-CN": "使用说明",
          "en": "Usage Instructions",
          "hi": "उपयोग निर्देश",
          "ja": "使用方法",
          "ko": "사용 방법"
        },
        "description": {
          "zh-TW": "此工具提供即時 Markdown 預覽功能，支援完整的 Markdown 語法和擴展功能。",
          "zh-CN": "此工具提供即时 Markdown 预览功能，支持完整的 Markdown 语法和扩展功能。",
          "en": "This tool provides real-time Markdown preview with support for complete Markdown syntax and extended features.",
          "hi": "यह टूल पूर्ण Markdown सिंटैक्स और विस्तारित सुविधाओं के समर्थन के साथ रीयल-टाइम Markdown पूर्वावलोकन प्रदान करता है।",
          "ja": "このツールは完全な Markdown 構文と拡張機能をサポートするリアルタイム Markdown プレビューを提供します。",
          "ko": "이 도구는 완전한 Markdown 구문과 확장 기능을 지원하는 실시간 Markdown 미리보기를 제공합니다."
        },
        "feature1": {
          "zh-TW": "即時預覽：輸入時立即顯示格式化結果",
          "zh-CN": "即时预览：输入时立即显示格式化结果",
          "en": "Real-time preview: Instantly displays formatted results as you type",
          "hi": "रीयल-टाइम प्रीव्यू: टाइप करते समय तुरंत फॉर्मेटेड परिणाम दिखाता है",
          "ja": "リアルタイムプレビュー：入力時に即座にフォーマット結果を表示",
          "ko": "실시간 미리보기: 입력할 때 즉시 서식이 적용된 결과를 표시"
        },
        "feature2": {
          "zh-TW": "語法高亮：支援多種程式語言的代碼高亮",
          "zh-CN": "语法高亮：支持多种编程语言的代码高亮",
          "en": "Syntax highlighting: Supports code highlighting for multiple programming languages",
          "hi": "सिंटैक्स हाइलाइटिंग: कई प्रोग्रामिंग भाषाओं के लिए कोड हाइलाइटिंग का समर्थन करता है",
          "ja": "シンタックスハイライト：複数のプログラミング言語のコードハイライトをサポート",
          "ko": "구문 강조: 여러 프로그래밍 언어의 코드 강조를 지원"
        },
        "feature3": {
          "zh-TW": "響應式佈局：可切換左右或上下分割模式",
          "zh-CN": "响应式布局：可切换左右或上下分割模式",
          "en": "Responsive layout: Switch between horizontal and vertical split modes",
          "hi": "रिस्पॉन्सिव लेआउट: क्षैतिज और ऊर्ध्वाधर स्प्लिट मोड के बीच स्विच करें",
          "ja": "レスポンシブレイアウト：水平分割と垂直分割モードを切り替え可能",
          "ko": "반응형 레이아웃: 가로 및 세로 분할 모드 간 전환 가능"
        },
        "feature4": {
          "zh-TW": "完整功能：支援表格、連結、圖片、代碼區塊等",
          "zh-CN": "完整功能：支持表格、链接、图片、代码区块等",
          "en": "Complete features: Supports tables, links, images, code blocks, and more",
          "hi": "पूर्ण सुविधाएं: टेबल, लिंक, इमेज, कोड ब्लॉक और अधिक का समर्थन करता है",
          "ja": "完全な機能：テーブル、リンク、画像、コードブロックなどをサポート",
          "ko": "완전한 기능: 테이블, 링크, 이미지, 코드 블록 등을 지원"
        },
        "feature5": {
          "zh-TW": "一鍵複製：可複製 Markdown 原文或生成的 HTML",
          "zh-CN": "一键复制：可复制 Markdown 原文或生成的 HTML",
          "en": "One-click copy: Copy original Markdown or generated HTML",
          "hi": "वन-क्लिक कॉपी: मूल Markdown या जेनरेटेड HTML कॉपी करें",
          "ja": "ワンクリックコピー：元の Markdown または生成された HTML をコピー",
          "ko": "원클릭 복사: 원본 Markdown 또는 생성된 HTML 복사"
        }
      }
    },
    "asciiTable": {
      "title": {
        "zh-TW": "ASCII 字元表",
        "zh-CN": "ASCII 字符表",
        "en": "ASCII Character Table",
        "hi": "ASCII वर्ण तालिका",
        "ja": "ASCII文字テーブル",
        "ko": "ASCII 문자 테이블"
      },
      "description": {
        "zh-TW": "完整的 ASCII 字元對照表，包含八進位、十六進位、十進位、字元和 HTML 編碼",
        "zh-CN": "完整的 ASCII 字符对照表，包含八进制、十六进制、十进制、字符和 HTML 编码",
        "en": "Complete ASCII character reference table with octal, hexadecimal, decimal, character and HTML encoding",
        "hi": "अष्टक, हेक्साडेसिमल, दशमलव, वर्ण और HTML एन्कोडिंग के साथ संपूर्ण ASCII वर्ण संदर्भ तालिका",
        "ja": "8進数、16進数、10進数、文字、HTML エンコーディングを含む完全な ASCII 文字参照テーブル",
        "ko": "8진수, 16진수, 10진수, 문자 및 HTML 인코딩을 포함한 완전한 ASCII 문자 참조 테이블"
      },
      "usage": {
        "title": {
          "zh-TW": "使用說明",
          "zh-CN": "使用说明",
          "en": "Usage Instructions",
          "hi": "उपयोग निर्देश",
          "ja": "使用方法",
          "ko": "사용 방법"
        },
        "description": {
          "zh-TW": "此工具提供完整的 ASCII 字元對照表，適用於程式開發、編碼學習和字元查詢。",
          "zh-CN": "此工具提供完整的 ASCII 字符对照表，适用于程序开发、编码学习和字符查询。",
          "en": "This tool provides a complete ASCII character reference table, suitable for programming development, encoding learning and character lookup.",
          "hi": "यह टूल पूर्ण ASCII वर्ण संदर्भ तालिका प्रदान करता है, जो प्रोग्रामिंग विकास, एन्कोडिंग सीखने और वर्ण खोज के लिए उपयुक्त है।",
          "ja": "このツールは完全な ASCII 文字参照テーブルを提供し、プログラム開発、エンコーディング学習、文字検索に適しています。",
          "ko": "이 도구는 완전한 ASCII 문자 참조 테이블을 제공하며, 프로그래밍 개발, 인코딩 학습 및 문자 검색에 적합합니다."
        },
        "feature1": {
          "zh-TW": "顯示 ASCII 0~255 的完整字元表",
          "zh-CN": "显示 ASCII 0~255 的完整字符表",
          "en": "Display complete character table for ASCII 0~255",
          "hi": "ASCII 0~255 की पूर्ण वर्ण तालिका प्रदर्शित करें",
          "ja": "ASCII 0~255 の完全な文字テーブルを表示",
          "ko": "ASCII 0~255의 완전한 문자 테이블 표시"
        },
        "feature2": {
          "zh-TW": "包含八進位、十六進位、十進位編碼",
          "zh-CN": "包含八进制、十六进制、十进制编码",
          "en": "Includes octal, hexadecimal, decimal encoding",
          "hi": "अष्टक, हेक्साडेसिमल, दशमलव एन्कोडिंग शामिल है",
          "ja": "8進数、16進数、10進数エンコーディングを含む",
          "ko": "8진수, 16진수, 10진수 인코딩 포함"
        },
        "feature3": {
          "zh-TW": "提供 HTML 實體編碼參考",
          "zh-CN": "提供 HTML 实体编码参考",
          "en": "Provides HTML entity encoding reference",
          "hi": "HTML इकाई एन्कोडिंग संदर्भ प्रदान करता है",
          "ja": "HTML エンティティエンコーディング参照を提供",
          "ko": "HTML 엔티티 인코딩 참조 제공"
        },
        "feature4": {
          "zh-TW": "控制字元和特殊符號說明",
          "zh-CN": "控制字符和特殊符号说明",
          "en": "Control characters and special symbols explanation",
          "hi": "नियंत्रण वर्ण और विशेष प्रतीक स्पष्टीकरण",
          "ja": "制御文字と特殊記号の説明",
          "ko": "제어 문자 및 특수 기호 설명"
        }
      },
      "headers": {
        "oct": {
          "zh-TW": "八進位",
          "zh-CN": "八进制",
          "en": "Oct",
          "hi": "अष्टक",
          "ja": "8進数",
          "ko": "8진수"
        },
        "hex": {
          "zh-TW": "十六進位",
          "zh-CN": "十六进制",
          "en": "Hex",
          "hi": "हेक्स",
          "ja": "16進数",
          "ko": "16진수"
        },
        "dec": {
          "zh-TW": "十進位",
          "zh-CN": "十进制",
          "en": "Dec",
          "hi": "दशमलव",
          "ja": "10進数",
          "ko": "10진수"
        },
        "char": {
          "zh-TW": "字元",
          "zh-CN": "字符",
          "en": "Char",
          "hi": "वर्ण",
          "ja": "文字",
          "ko": "문자"
        },
        "html": {
          "zh-TW": "HTML",
          "zh-CN": "HTML",
          "en": "HTML",
          "hi": "HTML",
          "ja": "HTML",
          "ko": "HTML"
        },
        "desc": {
          "zh-TW": "說明",
          "zh-CN": "说明",
          "en": "Description",
          "hi": "विवरण",
          "ja": "説明",
          "ko": "설명"
        }
      },
      "controlChar": {
        "zh-TW": "控制字元",
        "zh-CN": "控制字符",
        "en": "Control Char",
        "hi": "नियंत्रण वर्ण",
        "ja": "制御文字",
        "ko": "제어 문자"
      },
      "space": {
        "zh-TW": "Space (空白)",
        "zh-CN": "Space (空格)",
        "en": "Space",
        "hi": "Space (स्थान)",
        "ja": "Space (スペース)",
        "ko": "Space (공백)"
      },
      "visible": {
        "zh-TW": "可見字元",
        "zh-CN": "可见字符",
        "en": "Visible Character",
        "hi": "दृश्य वर्ण",
        "ja": "可視文字",
        "ko": "가시 문자"
      },
      "extended": {
        "zh-TW": "擴展字元",
        "zh-CN": "扩展字符",
        "en": "Extended Character",
        "hi": "विस्तारित वर्ण",
        "ja": "拡張文字",
        "ko": "확장 문자"
      },
      "standardTitle": {
        "zh-TW": "標準 ASCII 字元表",
        "zh-CN": "标准 ASCII 字符表",
        "en": "Standard ASCII Character Table",
        "hi": "मानक ASCII वर्ण तालिका",
        "ja": "標準 ASCII 文字テーブル",
        "ko": "표준 ASCII 문자 테이블"
      },
      "extendedTitle": {
        "zh-TW": "擴展 ASCII 字元表",
        "zh-CN": "扩展 ASCII 字符表",
        "en": "Extended ASCII Character Table",
        "hi": "विस्तारित ASCII वर्ण तालिका",
        "ja": "拡張 ASCII 文字テーブル",
        "ko": "확장 ASCII 문자 테이블"
      },
      "cp437": {
        "latinLetters": {
          "zh-TW": "拉丁字母（帶重音符號）",
          "zh-CN": "拉丁字母（带重音符号）",
          "en": "Latin Letters (with accents)",
          "hi": "लैटिन अक्षर (उच्चारण के साथ)",
          "ja": "ラテン文字（アクセント付き）",
          "ko": "라틴 문자 (악센트 포함)"
        },
        "accentedLetters": {
          "zh-TW": "重音字母和特殊符號",
          "zh-CN": "重音字母和特殊符号",
          "en": "Accented Letters and Special Symbols",
          "hi": "उच्चारण अक्षर और विशेष प्रतीक",
          "ja": "アクセント文字と特殊記号",
          "ko": "악센트 문자 및 특수 기호"
        },
        "boxDrawing": {
          "zh-TW": "框線繪製字元",
          "zh-CN": "框线绘制字符",
          "en": "Box Drawing Characters",
          "hi": "बॉक्स ड्रॉइंग वर्ण",
          "ja": "罫線文字",
          "ko": "상자 그리기 문자"
        },
        "greekMath": {
          "zh-TW": "希臘字母和數學符號",
          "zh-CN": "希腊字母和数学符号",
          "en": "Greek Letters and Math Symbols",
          "hi": "ग्रीक अक्षर और गणित प्रतीक",
          "ja": "ギリシャ文字と数学記号",
          "ko": "그리스 문자 및 수학 기호"
        },
        "mathSymbols": {
          "zh-TW": "數學符號和特殊字元",
          "zh-CN": "数学符号和特殊字符",
          "en": "Math Symbols and Special Characters",
          "hi": "गणित प्रतीक और विशेष वर्ण",
          "ja": "数学記号と特殊文字",
          "ko": "수학 기호 및 특수 문자"
        }
      },
      "controls": {
        "NUL": {
          "zh-TW": "NUL (空字元)",
          "zh-CN": "NUL (空字符)",
          "en": "NUL (Null)",
          "hi": "NUL (शून्य)",
          "ja": "NUL (ヌル)",
          "ko": "NUL (널)"
        },
        "SOH": {
          "zh-TW": "SOH (標題開始)",
          "zh-CN": "SOH (标题开始)",
          "en": "SOH (Start of Heading)",
          "hi": "SOH (शीर्षक प्रारंभ)",
          "ja": "SOH (ヘッダー開始)",
          "ko": "SOH (헤딩 시작)"
        },
        "STX": {
          "zh-TW": "STX (正文開始)",
          "zh-CN": "STX (正文开始)",
          "en": "STX (Start of Text)",
          "hi": "STX (पाठ प्रारंभ)",
          "ja": "STX (テキスト開始)",
          "ko": "STX (텍스트 시작)"
        },
        "ETX": {
          "zh-TW": "ETX (正文結束)",
          "zh-CN": "ETX (正文结束)",
          "en": "ETX (End of Text)",
          "hi": "ETX (पाठ समाप्त)",
          "ja": "ETX (テキスト終了)",
          "ko": "ETX (텍스트 종료)"
        },
        "EOT": {
          "zh-TW": "EOT (傳輸結束)",
          "zh-CN": "EOT (传输结束)",
          "en": "EOT (End of Transmission)",
          "hi": "EOT (प्रसारण समाप्त)",
          "ja": "EOT (送信終了)",
          "ko": "EOT (전송 종료)"
        },
        "ENQ": {
          "zh-TW": "ENQ (詢問)",
          "zh-CN": "ENQ (询问)",
          "en": "ENQ (Enquiry)",
          "hi": "ENQ (पूछताछ)",
          "ja": "ENQ (問い合わせ)",
          "ko": "ENQ (조회)"
        },
        "ACK": {
          "zh-TW": "ACK (確認)",
          "zh-CN": "ACK (确认)",
          "en": "ACK (Acknowledge)",
          "hi": "ACK (स्वीकार)",
          "ja": "ACK (確認)",
          "ko": "ACK (확인)"
        },
        "BEL": {
          "zh-TW": "BEL (響鈴)",
          "zh-CN": "BEL (响铃)",
          "en": "BEL (Bell)",
          "hi": "BEL (घंटी)",
          "ja": "BEL (ベル)",
          "ko": "BEL (벨)"
        },
        "BS": {
          "zh-TW": "BS (退格)",
          "zh-CN": "BS (退格)",
          "en": "BS (Backspace)",
          "hi": "BS (बैकस्पेस)",
          "ja": "BS (バックスペース)",
          "ko": "BS (백스페이스)"
        },
        "TAB": {
          "zh-TW": "TAB (水平定位)",
          "zh-CN": "TAB (水平定位)",
          "en": "TAB (Horizontal Tab)",
          "hi": "TAB (क्षैतिज टैब)",
          "ja": "TAB (水平タブ)",
          "ko": "TAB (수평 탭)"
        },
        "LF": {
          "zh-TW": "LF (換行)",
          "zh-CN": "LF (换行)",
          "en": "LF (Line Feed)",
          "hi": "LF (लाइन फीड)",
          "ja": "LF (ラインフィード)",
          "ko": "LF (라인 피드)"
        },
        "VT": {
          "zh-TW": "VT (垂直定位)",
          "zh-CN": "VT (垂直定位)",
          "en": "VT (Vertical Tab)",
          "hi": "VT (लंबवत टैब)",
          "ja": "VT (垂直タブ)",
          "ko": "VT (수직 탭)"
        },
        "FF": {
          "zh-TW": "FF (換頁)",
          "zh-CN": "FF (换页)",
          "en": "FF (Form Feed)",
          "hi": "FF (फॉर्म फीड)",
          "ja": "FF (フォームフィード)",
          "ko": "FF (폼 피드)"
        },
        "CR": {
          "zh-TW": "CR (歸位)",
          "zh-CN": "CR (归位)",
          "en": "CR (Carriage Return)",
          "hi": "CR (कैरिज रिटर्न)",
          "ja": "CR (キャリッジリターン)",
          "ko": "CR (캐리지 리턴)"
        },
        "SO": {
          "zh-TW": "SO (移出)",
          "zh-CN": "SO (移出)",
          "en": "SO (Shift Out)",
          "hi": "SO (शिफ्ट आउट)",
          "ja": "SO (シフトアウト)",
          "ko": "SO (시프트 아웃)"
        },
        "SI": {
          "zh-TW": "SI (移入)",
          "zh-CN": "SI (移入)",
          "en": "SI (Shift In)",
          "hi": "SI (शिफ्ट इन)",
          "ja": "SI (シフトイン)",
          "ko": "SI (시프트 인)"
        },
        "DLE": {
          "zh-TW": "DLE (資料連結逸出)",
          "zh-CN": "DLE (数据连结逸出)",
          "en": "DLE (Data Link Escape)",
          "hi": "DLE (डेटा लिंक एस्केप)",
          "ja": "DLE (データリンクエスケープ)",
          "ko": "DLE (데이터 링크 이스케이프)"
        },
        "DC1": {
          "zh-TW": "DC1 (裝置控制1)",
          "zh-CN": "DC1 (设备控制1)",
          "en": "DC1 (Device Control 1)",
          "hi": "DC1 (डिवाइस कंट्रोल 1)",
          "ja": "DC1 (デバイス制御1)",
          "ko": "DC1 (장치 제어 1)"
        },
        "DC2": {
          "zh-TW": "DC2 (裝置控制2)",
          "zh-CN": "DC2 (设备控制2)",
          "en": "DC2 (Device Control 2)",
          "hi": "DC2 (डिवाइस कंट्रोल 2)",
          "ja": "DC2 (デバイス制御2)",
          "ko": "DC2 (장치 제어 2)"
        },
        "DC3": {
          "zh-TW": "DC3 (裝置控制3)",
          "zh-CN": "DC3 (设备控制3)",
          "en": "DC3 (Device Control 3)",
          "hi": "DC3 (डिवाइस कंट्रोल 3)",
          "ja": "DC3 (デバイス制御3)",
          "ko": "DC3 (장치 제어 3)"
        },
        "DC4": {
          "zh-TW": "DC4 (裝置控制4)",
          "zh-CN": "DC4 (设备控制4)",
          "en": "DC4 (Device Control 4)",
          "hi": "DC4 (डिवाइस कंट्रोल 4)",
          "ja": "DC4 (デバイス制御4)",
          "ko": "DC4 (장치 제어 4)"
        },
        "NAK": {
          "zh-TW": "NAK (否認)",
          "zh-CN": "NAK (否认)",
          "en": "NAK (Negative Acknowledge)",
          "hi": "NAK (नकारात्मक स्वीकार)",
          "ja": "NAK (否定応答)",
          "ko": "NAK (부정 확인)"
        },
        "SYN": {
          "zh-TW": "SYN (同步)",
          "zh-CN": "SYN (同步)",
          "en": "SYN (Synchronous)",
          "hi": "SYN (सिंक्रोनस)",
          "ja": "SYN (同期)",
          "ko": "SYN (동기)"
        },
        "ETB": {
          "zh-TW": "ETB (區塊傳輸結束)",
          "zh-CN": "ETB (区块传输结束)",
          "en": "ETB (End of Transmission Block)",
          "hi": "ETB (प्रसारण ब्लॉक समाप्त)",
          "ja": "ETB (送信ブロック終了)",
          "ko": "ETB (전송 블록 종료)"
        },
        "CAN": {
          "zh-TW": "CAN (取消)",
          "zh-CN": "CAN (取消)",
          "en": "CAN (Cancel)",
          "hi": "CAN (रद्द करें)",
          "ja": "CAN (キャンセル)",
          "ko": "CAN (취소)"
        },
        "EM": {
          "zh-TW": "EM (媒體結束)",
          "zh-CN": "EM (媒体结束)",
          "en": "EM (End of Medium)",
          "hi": "EM (माध्यम समाप्त)",
          "ja": "EM (媒体終了)",
          "ko": "EM (매체 종료)"
        },
        "SUB": {
          "zh-TW": "SUB (替換)",
          "zh-CN": "SUB (替换)",
          "en": "SUB (Substitute)",
          "hi": "SUB (प्रतिस्थापन)",
          "ja": "SUB (置換)",
          "ko": "SUB (대체)"
        },
        "ESC": {
          "zh-TW": "ESC (跳脫)",
          "zh-CN": "ESC (跳脱)",
          "en": "ESC (Escape)",
          "hi": "ESC (एस्केप)",
          "ja": "ESC (エスケープ)",
          "ko": "ESC (이스케이프)"
        },
        "FS": {
          "zh-TW": "FS (檔案分隔)",
          "zh-CN": "FS (文件分隔)",
          "en": "FS (File Separator)",
          "hi": "FS (फाइल विभाजक)",
          "ja": "FS (ファイル区切り)",
          "ko": "FS (파일 구분자)"
        },
        "GS": {
          "zh-TW": "GS (群組分隔)",
          "zh-CN": "GS (群组分隔)",
          "en": "GS (Group Separator)",
          "hi": "GS (समूह विभाजक)",
          "ja": "GS (グループ区切り)",
          "ko": "GS (그룹 구분자)"
        },
        "RS": {
          "zh-TW": "RS (記錄分隔)",
          "zh-CN": "RS (记录分隔)",
          "en": "RS (Record Separator)",
          "hi": "RS (रिकॉर्ड विभाजक)",
          "ja": "RS (レコード区切り)",
          "ko": "RS (레코드 구분자)"
        },
        "US": {
          "zh-TW": "US (單元分隔)",
          "zh-CN": "US (单元分隔)",
          "en": "US (Unit Separator)",
          "hi": "US (इकाई विभाजक)",
          "ja": "US (ユニット区切り)",
          "ko": "US (단위 구분자)"
        },
        "DEL": {
          "zh-TW": "DEL (刪除)",
          "zh-CN": "DEL (删除)",
          "en": "DEL (Delete)",
          "hi": "DEL (हटाएं)",
          "ja": "DEL (削除)",
          "ko": "DEL (삭제)"
        }
      }
    },
    "apiTester": {
      "basicInfo": {
        "zh-TW": "基本資訊",
        "zh-CN": "基本信息",
        "en": "Basic Info",
        "hi": "बुनियादी जानकारी",
        "ja": "基本情報",
        "ko": "기본 정보"
      },
      "addHeader": {
        "zh-TW": "新增標頭",
        "zh-CN": "新增标头",
        "en": "Add Header",
        "hi": "हेडर जोड़ें",
        "ja": "ヘッダーを追加",
        "ko": "헤더 추가"
      },
      "avgResponse": {
        "zh-TW": "平均響應",
        "zh-CN": "平均响应",
        "en": "Avg Response",
        "hi": "औसत प्रतिक्रिया",
        "ja": "平均応答時間",
        "ko": "평균 응답"
      },
      "batchTest": {
        "zh-TW": "批量測試",
        "zh-CN": "批量测试",
        "en": "Batch Testing",
        "hi": "बैच टेस्ट",
        "ja": "バッチテスト",
        "ko": "배치 테스트"
      },
      "bodyPlaceholder": {
        "zh-TW": "輸入請求主體 (JSON, XML 等)...",
        "zh-CN": "输入請求主体 (JSON, XML 等)...",
        "en": "Enter request body (JSON, XML, etc.)...",
        "hi": "रिक्वेस्ट बॉडी दर्ज करें (JSON, XML आदि)...",
        "ja": "リクエストボディを入力 (JSON, XML など)...",
        "ko": "요청 본문을 입력하세요 (JSON, XML 등)..."
      },
      "concurrent": {
        "zh-TW": "並發數",
        "zh-CN": "并发数",
        "en": "Concurrent",
        "hi": "समानांतर संख्या",
        "ja": "同時実行数",
        "ko": "동시 실행 수"
      },
      "description": {
        "zh-TW": "專業的 API 測試工具，支援批量測試、效能分析和即時監控",
        "zh-CN": "专业的 API 测试工具，支持批量测试、效能分析和即时监控",
        "en": "Professional API testing tool with batch testing, performance analysis and real-time monitoring",
        "hi": "पेशेवर API टेस्ट टूल, बैच टेस्टिंग, प्रदर्शन विश्लेषण और तत्काल निगरानी का समर्थन",
        "ja": "プロフェッショナルなAPIテストツール。バッチテスト、パフォーマンス分析、リアルタイム監視をサポート",
        "ko": "전문적인 API 테스트 도구로, 배치 테스트, 성능 분석, 실시간 모니터링을 지원합니다"
      },
      "exportCsv": {
        "zh-TW": "匯出 CSV",
        "zh-CN": "匯出 CSV",
        "en": "Export CSV",
        "hi": "CSV निर्यात करें",
        "ja": "CSV出力",
        "ko": "CSV 내보내기"
      },
      "exportJson": {
        "zh-TW": "匯出 JSON",
        "zh-CN": "匯出 JSON",
        "en": "Export JSON",
        "hi": "JSON निर्यात करें",
        "ja": "JSON出力",
        "ko": "JSON 내보내기"
      },
      "failed": {
        "zh-TW": "失敗",
        "zh-CN": "失败",
        "en": "Failed",
        "hi": "असफल",
        "ja": "失敗",
        "ko": "실패"
      },
      "headerKey": {
        "zh-TW": "標頭名稱",
        "zh-CN": "标头名稱",
        "en": "Header Name",
        "hi": "हेडर नाम",
        "ja": "ヘッダー名",
        "ko": "헤더 이름"
      },
      "headerValue": {
        "zh-TW": "標頭值",
        "zh-CN": "标头值",
        "en": "Header Value",
        "hi": "हेडर वैल्यू",
        "ja": "ヘッダー値",
        "ko": "헤더 값"
      },
      "headers": {
        "zh-TW": "請求標頭",
        "zh-CN": "請求标头",
        "en": "Request Headers",
        "hi": "रिक्वेस्ट हेडर",
        "ja": "リクエストヘッダー",
        "ko": "요청 헤더"
      },
      "history": {
        "zh-TW": "歷史記錄",
        "zh-CN": "历史记录",
        "en": "History",
        "hi": "इतिहास रिकॉर्ड",
        "ja": "履歴",
        "ko": "기록"
      },
      "method": {
        "zh-TW": "方法",
        "zh-CN": "方法",
        "en": "Method",
        "hi": "विधि",
        "ja": "メソッド",
        "ko": "메서드"
      },
      "quickPresets": {
        "zh-TW": "快速預設",
        "zh-CN": "快速预设",
        "en": "Quick Presets",
        "hi": "त्वरित प्रीसेट",
        "ja": "クイックプリセット",
        "ko": "빠른 프리셋"
      },
      "requestBody": {
        "zh-TW": "請求主體",
        "zh-CN": "請求主体",
        "en": "Request Body",
        "hi": "रिक्वेस्ट बॉडी",
        "ja": "リクエストボディ",
        "ko": "요청 본문"
      },
      "responseBody": {
        "zh-TW": "響應主體",
        "zh-CN": "响应主体",
        "en": "Response Body",
        "hi": "प्रतिक्रिया बॉडी",
        "ja": "レスポンスボディ",
        "ko": "응답 본문"
      },
      "responseHeaders": {
        "zh-TW": "響應標頭",
        "zh-CN": "响应标头",
        "en": "Response Headers",
        "hi": "प्रतिक्रिया हेडर",
        "ja": "レスポンスヘッダー",
        "ko": "응답 헤더"
      },
      "responseTime": {
        "zh-TW": "響應時間",
        "zh-CN": "响应时间",
        "en": "Response Time",
        "hi": "प्रतिक्रिया समय",
        "ja": "応答時間",
        "ko": "응답 시간"
      },
      "resultDetails": {
        "zh-TW": "結果詳情",
        "zh-CN": "结果詳情",
        "en": "Result Details",
        "hi": "परिणाम विवरण",
        "ja": "結果詳細",
        "ko": "결과 세부사항"
      },
      "results": {
        "zh-TW": "測試結果",
        "zh-CN": "测试结果",
        "en": "Test Results",
        "hi": "टेस्ट परिणाम",
        "ja": "テスト結果",
        "ko": "테스트 결과"
      },
      "singleTest": {
        "zh-TW": "單一 API 測試",
        "zh-CN": "单一 API 测试",
        "en": "Single API Test",
        "hi": "एकल API टेस्ट",
        "ja": "単一APIテスト",
        "ko": "단일 API 테스트"
      },
      "size": {
        "zh-TW": "大小",
        "zh-CN": "大小",
        "en": "Size",
        "hi": "आकार",
        "ja": "サイズ",
        "ko": "크기"
      },
      "startBatchTest": {
        "zh-TW": "開始批量測試",
        "zh-CN": "开始批量测试",
        "en": "Start Batch Test",
        "hi": "बैच टेस्ट शुरू करें",
        "ja": "開始",
        "ko": "배치 테스트 시작"
      },
      "status": {
        "zh-TW": "狀態",
        "zh-CN": "狀態",
        "en": "Status",
        "hi": "स्थिति",
        "ja": "ステータス",
        "ko": "상태"
      },
      "successful": {
        "zh-TW": "成功",
        "zh-CN": "成功",
        "en": "Successful",
        "hi": "सफल",
        "ja": "成功",
        "ko": "성공"
      },
      "timeout": {
        "zh-TW": "超時時間",
        "zh-CN": "超时时间",
        "en": "Timeout",
        "hi": "टाइमआउट समय",
        "ja": "タイムアウト時間",
        "ko": "타임아웃 시간"
      },
      "tip1": {
        "zh-TW": "支援批量測試多個 API 端點，自動統計成功率",
        "zh-CN": "支持批量测试多个 API 端点，自动统计成功率",
        "en": "Support batch testing of multiple API endpoints with automatic success rate statistics",
        "hi": "कई API एंडपॉइंट्स के बैच टेस्टिंग का समर्थन, स्वचालित सफलता दर आंकड़े",
        "ja": "複数のAPIエンドポイントのバッチテストをサポート、成功率を自動統計",
        "ko": "여러 API 엔드포인트의 배치 테스트를 지원하며, 성공률을 자동으로 통계냅니다"
      },
      "tip2": {
        "zh-TW": "可控制並發數量和超時時間，避免伺服器過載",
        "zh-CN": "可控制并发数量和超时时间，避免伺服器过载",
        "en": "Control concurrency and timeout to avoid server overload",
        "hi": "समानांतर संख्या और टाइमआउट समय को नियंत्रित कर सकते हैं, सर्वर ओवरलोड से बचने के लिए",
        "ja": "同時実行数とタイムアウト時間を制御、サーバー過負荷を回避",
        "ko": "동시 실행 수와 타임아웃 시간을 제어할 수 있어 서버 과부하를 방지합니다"
      },
      "tip3": {
        "zh-TW": "提供詳細的響應分析和效能統計",
        "zh-CN": "提供詳細的响应分析和效能统计",
        "en": "Provide detailed response analysis and performance statistics",
        "hi": "विस्तृत प्रतिक्रिया विश्लेषण और प्रदर्शन आंकड़े प्रदान करता है",
        "ja": "詳細な応答分析とパフォーマンス統計を提供",
        "ko": "상세한 응답 분석과 성능 통계를 제공합니다"
      },
      "tips": {
        "zh-TW": "使用技巧",
        "zh-CN": "使用技巧",
        "en": "Usage Tips",
        "hi": "उपयोग टिप्स",
        "ja": "使用のコツ",
        "ko": "사용 팁"
      },
      "title": {
        "zh-TW": "API 測試工具",
        "zh-CN": "API 测试工具",
        "en": "API Testing Tool",
        "hi": "API टेस्ट टूल",
        "ja": "APIテストツール",
        "ko": "API 테스트 도구"
      },
      "totalTime": {
        "zh-TW": "總時間",
        "zh-CN": "總时间",
        "en": "Total Time",
        "hi": "कुल समय",
        "ja": "合計時間",
        "ko": "총 시간"
      },
      "url": {
        "zh-TW": "URL",
        "zh-CN": "URL",
        "en": "URL",
        "hi": "URL",
        "ja": "URL",
        "ko": "URL"
      },
      "urlList": {
        "zh-TW": "URL 清單",
        "zh-CN": "URL 清单",
        "en": "URL List",
        "hi": "URL सूची",
        "ja": "URLリスト",
        "ko": "URL 목록"
      },
      "urlListPlaceholder": {
        "zh-TW": "輸入要測試的 URL，每行一個:\nhttps://api.example.com/v1/users\nhttps://api.example.com/v1/posts\nhttps://jsonplaceholder.typicode.com/posts/1",
        "zh-CN": "输入要测试的 URL，每行一个:\nhttps://api.example.com/v1/users\nhttps://api.example.com/v1/posts\nhttps://jsonplaceholder.typicode.com/posts/1",
        "en": "Enter URLs to test, one per line:\nhttps://api.example.com/v1/users\nhttps://api.example.com/v1/posts\nhttps://jsonplaceholder.typicode.com/posts/1",
        "hi": "टेस्ट करने के लिए URL दर्ज करें, प्रत्येक लाइन में एक:\nhttps://api.example.com/v1/users\nhttps://api.example.com/v1/posts\nhttps://jsonplaceholder.typicode.com/posts/1",
        "ja": "テストするURLを1行に1つずつ入力:\nhttps://api.example.com/v1/users\nhttps://api.example.com/v1/posts\nhttps://jsonplaceholder.typicode.com/posts/1",
        "ko": "테스트할 URL을 입력하세요, 한 줄에 하나씩:\nhttps://api.example.com/v1/users\nhttps://api.example.com/v1/posts\nhttps://jsonplaceholder.typicode.com/posts/1"
      },
      "urlPlaceholder": {
        "zh-TW": "輸入 API URL...",
        "zh-CN": "输入 API URL...",
        "en": "Enter API URL...",
        "hi": "API URL दर्ज करें...",
        "ja": "API URLを入力...",
        "ko": "API URL을 입력하세요..."
      }
    },
    "graphqlValidator": {
      "addDepthLimit": {
        "zh-TW": "添加深度限制",
        "zh-CN": "添加深度限制",
        "en": "Add Depth Limit",
        "hi": "गहराई सीमा जोड़ें",
        "ja": "深度制限を追加",
        "ko": "깊이 제한 추가"
      },
      "addDepthLimitDesc": {
        "zh-TW": "建議將查詢深度限制在 10 層以內",
        "zh-CN": "建议将查询深度限制在 10 层以内",
        "en": "Recommend limiting query depth to within 10 levels",
        "hi": "क्वेरी की गहराई को 10 स्तरों तक सीमित करने की सिफारिश की जाती है",
        "ja": "クエリの深度を10レベル以内に制限することを推奨",
        "ko": "쿼리 깊이를 10단계 이내로 제한하는 것을 권장합니다"
      },
      "complexity": {
        "zh-TW": "複雜度",
        "zh-CN": "复杂度",
        "en": "Complexity",
        "hi": "जटिलता",
        "ja": "複雑度",
        "ko": "복잡도"
      },
      "depth": {
        "zh-TW": "深度",
        "zh-CN": "深度",
        "en": "Depth",
        "hi": "गहराई",
        "ja": "深度",
        "ko": "깊이"
      },
      "description": {
        "zh-TW": "驗證 GraphQL Schema，分析查詢複雜度並提供最佳化建議",
        "zh-CN": "验证 GraphQL Schema，分析查询复杂度并提供最佳化建议",
        "en": "Validate GraphQL schemas, analyze query complexity and provide optimization suggestions",
        "hi": "GraphQL स्कीमा का सत्यापन करें, क्वेरी जटिलता का विश्लेषण करें और अनुकूलन सुझाव प्राप्त करें",
        "ja": "GraphQLスキーマの検証、クエリ複雑度分析、最適化提案を提供",
        "ko": "GraphQL 스키마 검증, 쿼리 복잡도 분석 및 최적화 제안을 제공합니다"
      },
      "errors": {
        "zh-TW": "錯誤",
        "zh-CN": "错误",
        "en": "Errors",
        "hi": "त्रुटियाँ",
        "ja": "エラー",
        "ko": "오류"
      },
      "fields": {
        "zh-TW": "欄位",
        "zh-CN": "字段",
        "en": "Fields",
        "hi": "फ़ील्ड",
        "ja": "フィールド",
        "ko": "필드"
      },
      "formatSchema": {
        "zh-TW": "格式化 Schema",
        "zh-CN": "格式化 Schema",
        "en": "Format Schema",
        "hi": "स्कीमा फॉर्मेट करें",
        "ja": "スキーマをフォーマット",
        "ko": "스키마 포맷"
      },
      "implementCaching": {
        "zh-TW": "實施快取",
        "zh-CN": "实施缓存",
        "en": "Implement Caching",
        "hi": "कैशिंग लागू करें",
        "ja": "キャッシュを実装",
        "ko": "캐싱 구현"
      },
      "implementCachingDesc": {
        "zh-TW": "添加 Redis 或記憶體快取以提升性能",
        "zh-CN": "添加 Redis 或内存缓存以提升性能",
        "en": "Add Redis or memory caching for performance improvement",
        "hi": "प्रदर्शन सुधार के लिए Redis या मेमोरी कैशिंग जोड़ें",
        "ja": "パフォーマンス向上のためRedisまたはメモリキャッシュを追加",
        "ko": "성능 향상을 위해 Redis 또는 메모리 캐싱을 추가하세요"
      },
      "loadExample": {
        "zh-TW": "載入範例",
        "zh-CN": "载入范例",
        "en": "Load Example",
        "hi": "उदाहरण लोड करें",
        "ja": "例をロード",
        "ko": "예제 로드"
      },
      "mutations": {
        "zh-TW": "變異",
        "zh-CN": "变异",
        "en": "Mutations",
        "hi": "म्यूटेशन",
        "ja": "ミューテーション",
        "ko": "뮤테이션"
      },
      "noSchemaProvided": {
        "zh-TW": "未提供 Schema",
        "zh-CN": "未提供 Schema",
        "en": "No Schema Provided",
        "hi": "कोई स्कीमा प्रदान नहीं किया गया",
        "ja": "スキーマが提供されていません",
        "ko": "제공된 스키마가 없습니다"
      },
      "optimization": {
        "zh-TW": "最佳化建議",
        "zh-CN": "最佳化建议",
        "en": "Optimization Suggestions",
        "hi": "अनुकूलन सुझाव",
        "ja": "最適化提案",
        "ko": "최적화 제안"
      },
      "queries": {
        "zh-TW": "查詢",
        "zh-CN": "查询",
        "en": "Queries",
        "hi": "क्वेरी",
        "ja": "クエリ",
        "ko": "쿼리"
      },
      "queryAnalysis": {
        "zh-TW": "查詢分析",
        "zh-CN": "查询分析",
        "en": "Query Analysis",
        "hi": "क्वेरी विश्लेषण",
        "ja": "クエリ分析",
        "ko": "쿼리 분석"
      },
      "queryFields": {
        "zh-TW": "查詢欄位",
        "zh-CN": "查询字段",
        "en": "Query Fields",
        "hi": "क्वेरी फ़ील्ड",
        "ja": "クエリフィールド",
        "ko": "쿼리 필드"
      },
      "queryPlaceholder": {
        "zh-TW": "輸入要測試的 GraphQL 查詢...",
        "zh-CN": "输入要测试的 GraphQL 查询...",
        "en": "Enter GraphQL query to test...",
        "hi": "टेस्ट करने के लिए GraphQL क्वेरी दर्ज करें...",
        "ja": "テスト用GraphQLクエリを入力...",
        "ko": "테스트할 GraphQL 쿼리를 입력하세요..."
      },
      "queryTest": {
        "zh-TW": "查詢測試",
        "zh-CN": "查询测试",
        "en": "Query Test",
        "hi": "क्वेरी टेस्ट",
        "ja": "クエリテスト",
        "ko": "쿼리 테스트"
      },
      "schema": {
        "zh-TW": "GraphQL Schema",
        "zh-CN": "GraphQL Schema",
        "en": "GraphQL Schema",
        "hi": "GraphQL स्कीमा",
        "ja": "GraphQLスキーマ",
        "ko": "GraphQL 스키마"
      },
      "schemaInput": {
        "zh-TW": "Schema 輸入",
        "zh-CN": "Schema 输入",
        "en": "Schema Input",
        "hi": "स्कीमा इनपुट",
        "ja": "スキーマ入力",
        "ko": "스키마 입력"
      },
      "schemaInvalid": {
        "zh-TW": "無效的 Schema",
        "zh-CN": "无效的 Schema",
        "en": "Invalid Schema",
        "hi": "अमान्य स्कीमा",
        "ja": "無効なスキーマ",
        "ko": "잘못된 스키마"
      },
      "schemaPlaceholder": {
        "zh-TW": "在此貼上您的 GraphQL Schema...",
        "zh-CN": "在此贴上您的 GraphQL Schema...",
        "en": "Paste your GraphQL schema here...",
        "hi": "अपना GraphQL स्कीमा यहाँ पेस्ट करें...",
        "ja": "GraphQLスキーマをここに貼り付け...",
        "ko": "GraphQL 스키마를 여기에 붙여넣으세요..."
      },
      "schemaValid": {
        "zh-TW": "有效的 Schema",
        "zh-CN": "有效的 Schema",
        "en": "Valid Schema",
        "hi": "वैध स्कीमा",
        "ja": "有効なスキーマ",
        "ko": "유효한 스키마"
      },
      "suggestions": {
        "zh-TW": "建議",
        "zh-CN": "建议",
        "en": "Suggestions",
        "hi": "सुझाव",
        "ja": "提案",
        "ko": "제안"
      },
      "testQuery": {
        "zh-TW": "測試查詢",
        "zh-CN": "测试查询",
        "en": "Test Query",
        "hi": "टेस्ट क्वेरी",
        "ja": "テストクエリ",
        "ko": "테스트 쿼리"
      },
      "title": {
        "zh-TW": "GraphQL Schema 驗證器",
        "zh-CN": "GraphQL Schema 验证器",
        "en": "GraphQL Schema Validator",
        "hi": "GraphQL स्कीमा वैलिडेटर",
        "ja": "GraphQLスキーマバリデーター",
        "ko": "GraphQL 스키마 검증기"
      },
      "types": {
        "zh-TW": "類型",
        "zh-CN": "类型",
        "en": "Types",
        "hi": "प्रकार",
        "ja": "タイプ",
        "ko": "타입"
      },
      "useDataloader": {
        "zh-TW": "使用 DataLoader",
        "zh-CN": "使用 DataLoader",
        "en": "Use DataLoader",
        "hi": "DataLoader का उपयोग करें",
        "ja": "DataLoaderを使用",
        "ko": "DataLoader 사용"
      },
      "useDataloaderDesc": {
        "zh-TW": "使用 DataLoader 模式以避免 N+1 查詢問題",
        "zh-CN": "使用 DataLoader 模式以避免 N+1 查询问题",
        "en": "Use DataLoader pattern to avoid N+1 query issues",
        "hi": "N+1 क्वेरी समस्या से बचने के लिए DataLoader पैटर्न का उपयोग करें",
        "ja": "N+1クエリ問題を避けるためDataLoaderパターンを使用",
        "ko": "N+1 쿼리 문제를 피하기 위해 DataLoader 패턴을 사용하세요"
      },
      "validateQuery": {
        "zh-TW": "驗證查詢",
        "zh-CN": "验证查询",
        "en": "Validate Query",
        "hi": "क्वेरी सत्यापित करें",
        "ja": "クエリを検証",
        "ko": "쿼리 검증"
      },
      "validationResults": {
        "zh-TW": "驗證結果",
        "zh-CN": "验证结果",
        "en": "Validation Results",
        "hi": "सत्यापन परिणाम",
        "ja": "検証結果",
        "ko": "검증 결과"
      }
    },
    "swaggerGenerator": {
      "apiOverview": {
        "zh-TW": "API 概覽",
        "zh-CN": "API 概览",
        "en": "API Overview",
        "hi": "API अवलोकन",
        "ja": "API概要",
        "ko": "API 개요"
      },
      "apiSpec": {
        "zh-TW": "API 規格",
        "zh-CN": "API 规格",
        "en": "API Specification",
        "hi": "API स्पेसिफिकेशन",
        "ja": "API仕様",
        "ko": "API 명세"
      },
      "apiTitle": {
        "zh-TW": "API 標題",
        "zh-CN": "API 标题",
        "en": "API Title",
        "hi": "API शीर्षक",
        "ja": "APIタイトル",
        "ko": "API 제목"
      },
      "description": {
        "zh-TW": "從 JSON/YAML 生成互動式 API 文檔，支援 OpenAPI 3.0 規範驗證",
        "zh-CN": "从 JSON/YAML 生成互动式 API 文档，支持 OpenAPI 3.0 规范验证",
        "en": "Generate interactive API documentation from JSON/YAML with OpenAPI 3.0 specification validation support",
        "hi": "JSON/YAML से इंटरैक्टिव API डॉक्यूमेंटेशन जेनरेट करें, OpenAPI 3.0 सत्यापन समर्थन",
        "ja": "JSON/YAMLからインタラクティブAPIドキュメントを生成、OpenAPI 3.0検証対応",
        "ko": "JSON/YAML에서 인터랙티브 API 문서를 생성하며, OpenAPI 3.0 검증을 지원합니다"
      },
      "docGenerator": {
        "zh-TW": "文檔生成器",
        "zh-CN": "文档生成器",
        "en": "Documentation Generator",
        "hi": "डॉक्स जेनरेटर",
        "ja": "ドキュメントジェネレーター",
        "ko": "문서 생성기"
      },
      "download": {
        "zh-TW": "下載",
        "zh-CN": "下载",
        "en": "Download",
        "hi": "डाउनलोड",
        "ja": "ダウンロード",
        "ko": "다운로드"
      },
      "downloadHtml": {
        "zh-TW": "下載 HTML",
        "zh-CN": "下载 HTML",
        "en": "Download HTML",
        "hi": "HTML डाउनलोड करें",
        "ja": "HTMLダウンロード",
        "ko": "HTML 다운로드"
      },
      "downloadJson": {
        "zh-TW": "下載 JSON",
        "zh-CN": "下载 JSON",
        "en": "Download JSON",
        "hi": "JSON डाउनलोड करें",
        "ja": "JSONダウンロード",
        "ko": "JSON 다운로드"
      },
      "downloadMarkdown": {
        "zh-TW": "下載 Markdown",
        "zh-CN": "下载 Markdown",
        "en": "Download Markdown",
        "hi": "Markdown डाउनलोड करें",
        "ja": "Markdownダウンロード",
        "ko": "Markdown 다운로드"
      },
      "endpoints": {
        "zh-TW": "端點",
        "zh-CN": "端点",
        "en": "Endpoints",
        "hi": "एंडपॉइंट्स",
        "ja": "エンドポイント",
        "ko": "엔드포인트"
      },
      "errors": {
        "zh-TW": "錯誤",
        "zh-CN": "错误",
        "en": "Errors",
        "hi": "त्रुटियाँ",
        "ja": "エラー",
        "ko": "오류"
      },
      "formatSpec": {
        "zh-TW": "格式化規格",
        "zh-CN": "格式化规格",
        "en": "Format Specification",
        "hi": "स्पेसिफिकेशन फॉर्मेट करें",
        "ja": "仕様をフォーマット",
        "ko": "명세 포맷"
      },
      "generateDocs": {
        "zh-TW": "生成文檔",
        "zh-CN": "生成文档",
        "en": "Generate Documentation",
        "hi": "डॉक्यूमेंटेशन जेनरेट करें",
        "ja": "ドキュメントを生成",
        "ko": "문서 생성"
      },
      "generationOptions": {
        "zh-TW": "生成選項",
        "zh-CN": "生成选项",
        "en": "Generation Options",
        "hi": "जेनरेशन विकल्प",
        "ja": "生成オプション",
        "ko": "생성 옵션"
      },
      "includeAuth": {
        "zh-TW": "包含認證",
        "zh-CN": "包含认证",
        "en": "Include Authentication",
        "hi": "प्राधिकरण शामिल करें",
        "ja": "認証を含める",
        "ko": "인증 포함"
      },
      "includeExamples": {
        "zh-TW": "包含範例",
        "zh-CN": "包含范例",
        "en": "Include Examples",
        "hi": "उदाहरण शामिल करें",
        "ja": "例を含める",
        "ko": "예제 포함"
      },
      "includeSchemas": {
        "zh-TW": "包含 Schema",
        "zh-CN": "包含 Schema",
        "en": "Include Schemas",
        "hi": "स्कीमा शामिल करें",
        "ja": "スキーマを含める",
        "ko": "스키마 포함"
      },
      "loadExample": {
        "zh-TW": "載入範例",
        "zh-CN": "载入范例",
        "en": "Load Example",
        "hi": "उदाहरण लोड करें",
        "ja": "例をロード",
        "ko": "예제 로드"
      },
      "openApiSpec": {
        "zh-TW": "OpenAPI 規格",
        "zh-CN": "OpenAPI 规格",
        "en": "OpenAPI Specification",
        "hi": "OpenAPI स्पेसिफिकेशन",
        "ja": "OpenAPI仕様",
        "ko": "OpenAPI 명세"
      },
      "pasteSpec": {
        "zh-TW": "貼上規格",
        "zh-CN": "贴上规格",
        "en": "Paste Specification",
        "hi": "स्पेसिफिकेशन पेस्ट करें",
        "ja": "仕様を貼り付け",
        "ko": "명세 붙여넣기"
      },
      "prettifyOutput": {
        "zh-TW": "美化輸出",
        "zh-CN": "美化输出",
        "en": "Prettify Output",
        "hi": "आउटपुट को सुंदर बनाएं",
        "ja": "出力を美化",
        "ko": "출력 아름답게"
      },
      "schemas": {
        "zh-TW": "Schema",
        "zh-CN": "Schema",
        "en": "Schemas",
        "hi": "स्कीमा",
        "ja": "スキーマ",
        "ko": "스키마"
      },
      "specInvalid": {
        "zh-TW": "無效的規格",
        "zh-CN": "无效的规格",
        "en": "Invalid Specification",
        "hi": "अमान्य स्पेसिफिकेशन",
        "ja": "無効な仕様",
        "ko": "잘못된 명세"
      },
      "specPlaceholder": {
        "zh-TW": "在此貼上您的 OpenAPI/Swagger 規格...",
        "zh-CN": "在此贴上您的 OpenAPI/Swagger 规格...",
        "en": "Paste your OpenAPI/Swagger specification here...",
        "hi": "अपना OpenAPI/Swagger स्पेसिफिकेशन यहाँ पेस्ट करें...",
        "ja": "OpenAPI/Swagger仕様をここに貼り付け...",
        "ko": "OpenAPI/Swagger 명세를 여기에 붙여넣으세요..."
      },
      "specValid": {
        "zh-TW": "有效的規格",
        "zh-CN": "有效的规格",
        "en": "Valid Specification",
        "hi": "वैध स्पेसिफिकेशन",
        "ja": "有効な仕様",
        "ko": "유효한 명세"
      },
      "specValidator": {
        "zh-TW": "規格驗證器",
        "zh-CN": "规格验证器",
        "en": "Specification Validator",
        "hi": "स्पेक वैलिडेटर",
        "ja": "仕様バリデーター",
        "ko": "명세 검증기"
      },
      "specValidation": {
        "zh-TW": "規格驗證",
        "zh-CN": "规格验证",
        "en": "Specification Validation",
        "hi": "स्पेसिफिकेशन सत्यापन",
        "ja": "仕様検証",
        "ko": "명세 검증"
      },
      "title": {
        "zh-TW": "OpenAPI/Swagger 文檔生成器",
        "zh-CN": "OpenAPI/Swagger 文档生成器",
        "en": "OpenAPI/Swagger Documentation Generator",
        "hi": "OpenAPI/Swagger डॉक्स जेनरेटर",
        "ja": "OpenAPI/Swaggerドキュメントジェネレーター",
        "ko": "OpenAPI/Swagger 문서 생성기"
      },
      "validateSpec": {
        "zh-TW": "驗證規格",
        "zh-CN": "验证规格",
        "en": "Validate Specification",
        "hi": "स्पेसिफिकेशन सत्यापित करें",
        "ja": "仕様を検証",
        "ko": "명세 검증"
      },
      "validationPlaceholder": {
        "zh-TW": "貼上要驗證的 OpenAPI 規格...",
        "zh-CN": "贴上要验证的 OpenAPI 规格...",
        "en": "Paste OpenAPI specification to validate...",
        "hi": "सत्यापन के लिए OpenAPI स्पेसिफिकेशन पेस्ट करें...",
        "ja": "検証用OpenAPI仕様を貼り付け...",
        "ko": "검증할 OpenAPI 명세를 붙여넣으세요..."
      },
      "validationResults": {
        "zh-TW": "驗證結果",
        "zh-CN": "验证结果",
        "en": "Validation Results",
        "hi": "सत्यापन परिणाम",
        "ja": "検証結果",
        "ko": "검증 결과"
      },
      "version": {
        "zh-TW": "版本",
        "zh-CN": "版本",
        "en": "Version",
        "hi": "संस्करण",
        "ja": "バージョン",
        "ko": "버전"
      },
      "warnings": {
        "zh-TW": "警告",
        "zh-CN": "警告",
        "en": "Warnings",
        "hi": "चेतावनियाँ",
        "ja": "警告",
        "ko": "경고"
      }
    },
    "base64": {
      "decode_btn": {
        "zh-TW": "解碼",
        "zh-CN": "解码",
        "en": "Decode",
        "hi": "डिकोड",
        "ja": "デコード",
        "ko": "디코드"
      },
      "decode_tab": {
        "zh-TW": "解碼",
        "zh-CN": "解码",
        "en": "Decode",
        "hi": "डिकोड",
        "ja": "デコード",
        "ko": "디코드"
      },
      "description": {
        "zh-TW": "編碼和解碼 Base64 字符串，支援文字和檔案處理",
        "zh-CN": "编码和解码 Base64 字符串，支持文字和档案处理",
        "en": "Encode and decode Base64 strings with text and file support",
        "hi": "Base64 स्ट्रिंग्स को एन्कोड और डिकोड करें, टेक्स्ट और फ़ाइल प्रोसेसिंग का समर्थन करता है",
        "ja": "Base64文字列のエンコードとデコード、テキストとファイル処理をサポート",
        "ko": "Base64 문자열 인코딩 및 디코딩, 텍스트 및 파일 처리 지원"
      },
      "encode_btn": {
        "zh-TW": "編碼",
        "zh-CN": "编码",
        "en": "Encode",
        "hi": "एन्कोड",
        "ja": "エンコード",
        "ko": "인코드"
      },
      "encode_tab": {
        "zh-TW": "編碼",
        "zh-CN": "编码",
        "en": "Encode",
        "hi": "एन्कोड",
        "ja": "エンコード",
        "ko": "인코드"
      },
      "encoded_placeholder": {
        "zh-TW": "請貼上 Base64 編碼字串...",
        "zh-CN": "請贴上 Base64 编码字串...",
        "en": "Paste Base64 encoded string...",
        "hi": "कृपया Base64 एन्कोडेड स्ट्रिंग पेस्ट करें...",
        "ja": "Base64エンコード文字列を貼り付けてください...",
        "ko": "Base64 인코딩된 문자열을 붙여넣으세요..."
      },
      "features": {
        "decode": {
          "description": {
            "zh-TW": "解碼 Base64 字串還原原始文字內容",
            "zh-CN": "解码 Base64 字串还原原始文字內容",
            "en": "Decode Base64 strings to restore original text content",
            "hi": "Base64 स्ट्रिंग को डिकोड करके मूल टेक्स्ट सामग्री पुनर्स्थापित करें",
            "ja": "Base64文字列をデコードして元のテキスト内容を復元",
            "ko": "Base64 문자열을 디코딩하여 원본 텍스트 콘텐츠 복원"
          },
          "title": {
            "zh-TW": "快速解碼",
            "zh-CN": "快速解码",
            "en": "Quick Decoding",
            "hi": "त्वरित डिकोड",
            "ja": "高速デコード",
            "ko": "빠른 디코딩"
          }
        },
        "encode": {
          "description": {
            "zh-TW": "將任意文字轉換為 Base64 編碼格式",
            "zh-CN": "將任意文字转换為 Base64 编码格式",
            "en": "Convert any text to Base64 encoded format",
            "hi": "किसी भी टेक्स्ट को Base64 एन्कोडिंग प्रारूप में परिवर्तित करें",
            "ja": "任意のテキストをBase64エンコード形式に変換",
            "ko": "임의의 텍스트를 Base64 인코딩 형식으로 변환"
          },
          "title": {
            "zh-TW": "文字編碼",
            "zh-CN": "文字编码",
            "en": "Text Encoding",
            "hi": "टेक्स्ट एन्कोडिंग",
            "ja": "テキストエンコード",
            "ko": "텍스트 인코딩"
          }
        },
        "file": {
          "description": {
            "zh-TW": "支援圖片、文檔等二進制檔案編碼",
            "zh-CN": "支持图片、文档等二进制档案编码",
            "en": "Support encoding images, documents and other binary files",
            "hi": "छवियों, दस्तावेजों और अन्य बाइनरी फ़ाइलों की एन्कोडिंग का समर्थन करता है",
            "ja": "画像、文書などのバイナリファイルエンコードをサポート",
            "ko": "이미지, 문서 및 기타 바이너리 파일 인코딩 지원"
          },
          "title": {
            "zh-TW": "檔案支援",
            "zh-CN": "档案支持",
            "en": "File Support",
            "hi": "फ़ाइल समर्थन",
            "ja": "ファイルサポート",
            "ko": "파일 지원"
          }
        },
        "security": {
          "description": {
            "zh-TW": "本地處理，保護您的數據隱私安全",
            "zh-CN": "本地处理，保护您的数据隐私安全",
            "en": "Local processing to protect your data privacy",
            "hi": "स्थानीय प्रसंस्करण, आपकी डेटा गोपनीयता और सुरक्षा की सुरक्षा करता है",
            "ja": "ローカル処理で、データプライバシーとセキュリティを保護",
            "ko": "로컬 처리로 데이터 개인정보 보안을 보호합니다"
          },
          "title": {
            "zh-TW": "安全可靠",
            "zh-CN": "安全可靠",
            "en": "Secure & Reliable",
            "hi": "सुरक्षित और विश्वसनीय",
            "ja": "安全で信頼性が高い",
            "ko": "안전하고 신뢰할 수 있음"
          }
        },
        "title": {
          "zh-TW": "功能特色",
          "zh-CN": "功能特色",
          "en": "Features",
          "hi": "विशेषताएं",
          "ja": "機能の特徴",
          "ko": "주요 기능"
        }
      },
      "text_placeholder": {
        "zh-TW": "請輸入要編碼的文字...",
        "zh-CN": "請输入要编码的文字...",
        "en": "Enter text to encode...",
        "hi": "कृपया एन्कोड करने के लिए टेक्स्ट दर्ज करें...",
        "ja": "エンコードするテキストを入力してください...",
        "ko": "인코딩할 텍스트를 입력하세요..."
      },
      "title": {
        "zh-TW": "Base64 編碼解碼工具",
        "zh-CN": "Base64 编码解码工具",
        "en": "Base64 Encoder/Decoder Tool",
        "hi": "Base64 एन्कोडर/डिकोडर टूल",
        "ja": "Base64エンコーダー/デコーダーツール",
        "ko": "Base64 인코더/디코더 도구"
      },
      "usage": {
        "step1": {
          "zh-TW": "在編碼標籤頁輸入要編碼的文字",
          "zh-CN": "在编码标签页输入要编码的文字",
          "en": "Enter text to encode in the Encode tab",
          "hi": "एन्कोड टैब में एन्कोड करने के लिए टेक्स्ट दर्ज करें",
          "ja": "エンコードタブでエンコードするテキストを入力",
          "ko": "인코드 탭에서 인코딩할 텍스트를 입력하세요"
        },
        "step2": {
          "zh-TW": "點擊「編碼」按鈕產生 Base64 字串",
          "zh-CN": "点击「编码」按鈕产生 Base64 字串",
          "en": "Click 'Encode' button to generate Base64 string",
          "hi": "Base64 स्ट्रिंग उत्पन्न करने के लिए 'एन्कोड' बटन पर क्लिक करें",
          "ja": "「エンコード」ボタンをクリックしてBase64文字列を生成",
          "ko": "Base64 문자열을 생성하려면 '인코드' 버튼을 클릭하세요"
        },
        "step3": {
          "zh-TW": "在解碼標籤頁貼上 Base64 字串",
          "zh-CN": "在解码标签页贴上 Base64 字串",
          "en": "Paste Base64 string in the Decode tab",
          "hi": "डिकोड टैब में Base64 स्ट्रिंग पेस्ट करें",
          "ja": "デコードタブでBase64文字列を貼り付け",
          "ko": "디코드 탭에서 Base64 문자열을 붙여넣으세요"
        },
        "step4": {
          "zh-TW": "點擊「解碼」按鈕還原原始文字",
          "zh-CN": "点击「解码」按鈕还原原始文字",
          "en": "Click 'Decode' button to restore original text",
          "hi": "मूल टेक्स्ट को पुनर्स्थापित करने के लिए 'डिकोड' बटन पर क्लिक करें",
          "ja": "「デコード」ボタンをクリックして元のテキストを復元",
          "ko": "원본 텍스트를 복원하려면 '디코드' 버튼을 클릭하세요"
        },
        "title": {
          "zh-TW": "使用說明",
          "zh-CN": "使用說明",
          "en": "Usage Instructions",
          "hi": "उपयोग निर्देश",
          "ja": "使用方法",
          "ko": "사용 방법"
        }
      }
    },
    "base64Encoder": {
      "description": {
        "zh-TW": "編碼和解碼 Base64 字符串，支援文字和檔案處理",
        "zh-CN": "编码和解码 Base64 字符串，支持文字和档案处理",
        "en": "Encode and decode Base64 strings with text and file support",
        "hi": "Base64 स्ट्रिंग्स को एन्कोड और डिकोड करें, टेक्स्ट और फ़ाइल समर्थन के साथ",
        "ja": "Base64文字列のエンコードとデコード、テキストとファイル処理をサポート",
        "ko": "Base64 문자열을 인코딩 및 디코딩하며, 텍스트와 파일을 지원합니다"
      },
      "title": {
        "zh-TW": "Base64 編碼解碼工具",
        "zh-CN": "Base64 编码解码工具",
        "en": "Base64 Encoder/Decoder Tool",
        "hi": "Base64 एन्कोडर/डिकोडर टूल",
        "ja": "Base64エンコーダー/デコーダー",
        "ko": "Base64 인코더/디코더 도구"
      },
      "sampleText": {
        "zh-TW": "Hello, CallMeAPI! 這是一個多語言的 Base64 編碼工具。支持繁體中文、簡體中文和英文等語言。Perfect for developers! 🚀",
        "zh-CN": "Hello, CallMeAPI! 这是一个多语言的 Base64 编码工具。支持繁体中文、简体中文和英文等语言。Perfect for developers! 🚀",
        "en": "Hello, CallMeAPI! This is a multilingual Base64 encoding tool. Supports Traditional Chinese, Simplified Chinese, English and more languages. Perfect for developers! 🚀",
        "hi": "नमस्ते, CallMeAPI! यह एक बहुभाषी Base64 एन्कोडिंग टूल है। पारंपरिक चीनी, सरलीकृत चीनी, अंग्रेजी और अधिक भाषाओं का समर्थन करता है। डेवलपर्स के लिए बिल्कुल सही! 🚀",
        "ja": "こんにちは、CallMeAPI！これは多言語Base64エンコーディングツールです。繁体字中国語、簡体字中国語、英語などの言語をサポートしています。開発者に最適！🚀",
        "ko": "안녕하세요, CallMeAPI! 이것은 다국어 Base64 인코딩 도구입니다. 번체 중국어, 간체 중국어, 영어 및 기타 언어를 지원합니다. 개발자에게 완벽! 🚀"
      },
      "decodeError": {
        "zh-TW": "解碼錯誤：輸入的文字不是有效的 Base64 格式",
        "zh-CN": "解码错误：输入的文字不是有效的 Base64 格式",
        "en": "Decode error: The input text is not valid Base64 format",
        "hi": "डिकोड त्रुटि: इनपुट टेक्स्ट वैध Base64 प्रारूप नहीं है",
        "ja": "デコードエラー：入力テキストは有効なBase64形式ではありません",
        "ko": "디코딩 오류: 입력 텍스트가 유효한 Base64 형식이 아닙니다"
      }
    },
    "csvProcessor": {
      "addColumn": {
        "zh-TW": "新增列",
        "zh-CN": "新增列",
        "en": "Add Column",
        "hi": "कॉलम जोड़ें",
        "ja": "列を追加",
        "ko": "열 추가"
      },
      "addRow": {
        "zh-TW": "新增行",
        "zh-CN": "新增行",
        "en": "Add Row",
        "hi": "पंक्ति जोड़ें",
        "ja": "行を追加",
        "ko": "행 추가"
      },
      "comma": {
        "zh-TW": "逗號 (,)",
        "zh-CN": "逗号 (,)",
        "en": "Comma (,)",
        "hi": "कॉमा (,)",
        "ja": "カンマ (,)",
        "ko": "쉼표 (,)"
      },
      "dataPreview": {
        "zh-TW": "數據預覽",
        "zh-CN": "数据预览",
        "en": "Data Preview",
        "hi": "डेटा पूर्वावलोकन",
        "ja": "データプレビュー",
        "ko": "데이터 미리보기"
      },
      "dataTools": {
        "zh-TW": "數據處理",
        "zh-CN": "数据处理",
        "en": "Data Tools",
        "hi": "डेटा प्रसंस्करण",
        "ja": "データ処理",
        "ko": "데이터 처리"
      },
      "delimiter": {
        "zh-TW": "分隔符",
        "zh-CN": "分隔符",
        "en": "Delimiter",
        "hi": "डिलिमिटर",
        "ja": "区切り文字",
        "ko": "구분자"
      },
      "description": {
        "zh-TW": "解析、編輯和轉換 CSV 檔案，支援數據清理和格式轉換",
        "zh-CN": "解析、编辑和转换 CSV 档案，支持数据清理和格式转换",
        "en": "Parse, edit and convert CSV files with data cleaning and format conversion support",
        "hi": "CSV फ़ाइलों को फॉर्मेट, सत्यापित और कन्वर्ट करें, JSON, XML में कन्वर्ट करने का समर्थन",
        "ja": "CSVファイルの解析、編集、変換。データクリーニングと形式変換をサポート",
        "ko": "CSV 파일을 포맷, 검증, 변환하며, JSON, XML로의 변환을 지원합니다"
      },
      "downloadFile": {
        "zh-TW": "下載檔案",
        "zh-CN": "下载档案",
        "en": "Download File",
        "hi": "फ़ाइल डाउनलोड करें",
        "ja": "ファイルをダウンロード",
        "ko": "파일 다운로드"
      },
      "dragDrop": {
        "zh-TW": "拖放 CSV 檔案到此處",
        "zh-CN": "拖放 CSV 档案到此处",
        "en": "Drag and drop CSV file here",
        "hi": "CSV फ़ाइल को यहाँ ड्रैग और ड्रॉप करें",
        "ja": "CSVファイルをここにドラッグ&ドロップ",
        "ko": "여기에 CSV 파일을 드래그 앤 드롭하세요"
      },
      "duplicateRows": {
        "zh-TW": "重複行數",
        "zh-CN": "重复行数",
        "en": "Duplicate Rows",
        "hi": "डुप्लिकेट पंक्तियों की संख्या",
        "ja": "重複行数",
        "ko": "중복 행 수"
      },
      "editTab": {
        "zh-TW": "編輯模式",
        "zh-CN": "编辑模式",
        "en": "Edit Mode",
        "hi": "संपादन मोड",
        "ja": "編集モード",
        "ko": "편집 모드"
      },
      "emptyRows": {
        "zh-TW": "空行數",
        "zh-CN": "空行数",
        "en": "Empty Rows",
        "hi": "खाली पंक्तियाँ हटाएं",
        "ja": "空行数",
        "ko": "빈 행 수"
      },
      "encoding": {
        "zh-TW": "編碼",
        "zh-CN": "编码",
        "en": "Encoding",
        "hi": "एन्कोडिंग",
        "ja": "エンコーディング",
        "ko": "인코딩"
      },
      "export": {
        "zh-TW": "導出",
        "zh-CN": "导出",
        "en": "Export",
        "hi": "निर्यात",
        "ja": "エクスポート",
        "ko": "내보내기"
      },
      "exportDelimiter": {
        "zh-TW": "導出分隔符",
        "zh-CN": "导出分隔符",
        "en": "Export Delimiter",
        "hi": "निर्यात विभाजक",
        "ja": "エクスポート区切り文字",
        "ko": "내보내기 구분자"
      },
      "exportFormat": {
        "zh-TW": "導出格式",
        "zh-CN": "导出格式",
        "en": "Export Format",
        "hi": "निर्यात प्रारूप",
        "ja": "エクスポート形式",
        "ko": "내보내기 형식"
      },
      "filterData": {
        "zh-TW": "過濾數據",
        "zh-CN": "过濾数据",
        "en": "Filter Data",
        "hi": "डेटा फ़िल्टर करें",
        "ja": "データフィルター",
        "ko": "데이터 필터링"
      },
      "hasHeader": {
        "zh-TW": "包含標題行",
        "zh-CN": "包含标题行",
        "en": "Has Header Row",
        "hi": "हेडर पंक्ति है",
        "ja": "ヘッダー行を含む",
        "ko": "헤더 행 있음"
      },
      "next": {
        "zh-TW": "下一頁",
        "zh-CN": "下一页",
        "en": "Next",
        "hi": "अगला पृष्ठ",
        "ja": "次のページ",
        "ko": "다음 페이지"
      },
      "of": {
        "zh-TW": "共",
        "zh-CN": "共",
        "en": "of",
        "hi": "कुल",
        "ja": "合計",
        "ko": "총"
      },
      "parse": {
        "zh-TW": "解析",
        "zh-CN": "解析",
        "en": "Parse",
        "hi": "पार्स करें",
        "ja": "解析",
        "ko": "파싱"
      },
      "pasteData": {
        "zh-TW": "貼上數據",
        "zh-CN": "贴上数据",
        "en": "Paste Data",
        "hi": "डेटा पेस्ट करें",
        "ja": "データを貼り付け",
        "ko": "데이터 붙여넣기"
      },
      "pipe": {
        "zh-TW": "管道符 (|)",
        "zh-CN": "管道符 (|)",
        "en": "Pipe (|)",
        "hi": "पाइप (|)",
        "ja": "パイプ (|)",
        "ko": "파이프 (|)"
      },
      "placeholder": {
        "zh-TW": "請貼上您的 CSV 數據...\n例如：\n姓名,年齡,城市\n張三,25,台北\n李四,30,高雄",
        "zh-CN": "請贴上您的 CSV 数据...\n例如：\n姓名,年齡,城市\n張三,25,台北\n李四,30,高雄",
        "en": "Paste your CSV data here...\nExample:\nName,Age,City\nJohn,25,New York\nJane,30,Los Angeles",
        "hi": "कृपया अपना CSV डेटा पेस्ट करें...\nउदाहरण:\nनाम,आयु,शहर\nराम,25,दिल्ली\nश्याम,30,मुंबई",
        "ja": "CSVデータを貼り付けてください...\n例：\n名前,年齢,都市\n田中,25,東京\n佐藤,30,大阪",
        "ko": "CSV 데이터를 붙여넣으세요...\n예:\n이름,나이,도시\n홍길동,25,서울\n김철수,30,부산"
      },
      "previous": {
        "zh-TW": "上一頁",
        "zh-CN": "上一页",
        "en": "Previous",
        "hi": "पिछला पृष्ठ",
        "ja": "前のページ",
        "ko": "이전 페이지"
      },
      "removeDuplicates": {
        "zh-TW": "移除重複",
        "zh-CN": "移除重复",
        "en": "Remove Duplicates",
        "hi": "डुप्लिकेट हटाएं",
        "ja": "重複を削除",
        "ko": "중복 제거"
      },
      "removeEmpty": {
        "zh-TW": "移除空行",
        "zh-CN": "移除空行",
        "en": "Remove Empty Rows",
        "hi": "खाली पंक्तियाँ हटाएं",
        "ja": "空行を削除",
        "ko": "빈 행 제거"
      },
      "selectFile": {
        "zh-TW": "選擇檔案",
        "zh-CN": "选择档案",
        "en": "Select File",
        "hi": "फ़ाइल चुनें",
        "ja": "ファイルを選択",
        "ko": "파일 선택"
      },
      "semicolon": {
        "zh-TW": "分號 (;)",
        "zh-CN": "分号 (;)",
        "en": "Semicolon (;)",
        "hi": "सेमीकोलन (;)",
        "ja": "セミコロン (;)",
        "ko": "세미콜론 (;)"
      },
      "showing": {
        "zh-TW": "顯示",
        "zh-CN": "显示",
        "en": "Showing",
        "hi": "दिखाएं",
        "ja": "表示",
        "ko": "표시"
      },
      "sortData": {
        "zh-TW": "排序數據",
        "zh-CN": "排序数据",
        "en": "Sort Data",
        "hi": "डेटा सॉर्ट करें",
        "ja": "データを並び替え",
        "ko": "데이터 정렬"
      },
      "tab": {
        "zh-TW": "Tab",
        "zh-CN": "Tab",
        "en": "Tab",
        "hi": "टैब",
        "ja": "タブ",
        "ko": "탭"
      },
      "title": {
        "zh-TW": "CSV 處理工具",
        "zh-CN": "CSV 处理工具",
        "en": "CSV Processor Tool",
        "hi": "CSV प्रोसेसर टूल",
        "ja": "CSVプロセッサー",
        "ko": "CSV 프로세서 도구"
      },
      "totalColumns": {
        "zh-TW": "總列數",
        "zh-CN": "總列数",
        "en": "Total Columns",
        "hi": "कुल कॉलम",
        "ja": "総列数",
        "ko": "총 열 수"
      },
      "totalRows": {
        "zh-TW": "總行數",
        "zh-CN": "總行数",
        "en": "Total Rows",
        "hi": "कुल पंक्तियाँ",
        "ja": "総行数",
        "ko": "총 행 수"
      },
      "uploadFile": {
        "zh-TW": "上傳檔案",
        "zh-CN": "上传档案",
        "en": "Upload File",
        "hi": "CSV फ़ाइल अपलोड करें",
        "ja": "CSVファイルをアップロード",
        "ko": "CSV 파일 업로드"
      },
      "uploadTab": {
        "zh-TW": "上傳模式",
        "zh-CN": "上传模式",
        "en": "Upload Mode",
        "hi": "अपलोड मोड",
        "ja": "アップロードモード",
        "ko": "업로드 모드"
      },
      "batchImport": {
        "zh-TW": "批量匯入多個 CSV 檔案",
        "zh-CN": "批量导入多个 CSV 文件",
        "en": "Batch import multiple CSV files",
        "hi": "एकाधिक CSV फ़ाइलें बैच आयात करें",
        "ja": "複数のCSVファイルを一括インポート",
        "ko": "여러 CSV 파일 일괄 가져오기"
      },
      "realTimeEdit": {
        "zh-TW": "即時編輯和預覽變更",
        "zh-CN": "实时编辑和预览更改",
        "en": "Real-time editing and preview changes",
        "hi": "रीयल-टाइम संपादन और पूर्वावलोकन परिवर्तन",
        "ja": "リアルタイム編集とプレビュー変更",
        "ko": "실시간 편집 및 미리보기 변경"
      },
      "customDelimiters": {
        "zh-TW": "自訂分隔符號支援",
        "zh-CN": "自定义分隔符支持",
        "en": "Custom delimiter support",
        "hi": "कस्टम डिलीमिटर समर्थन",
        "ja": "カスタム区切り文字サポート",
        "ko": "사용자 정의 구분 기호 지원"
      },
      "addRemoveRows": {
        "zh-TW": "新增/刪除行",
        "zh-CN": "添加/删除行",
        "en": "Add/Remove rows",
        "hi": "पंक्तियाँ जोड़ें/हटाएं",
        "ja": "行の追加/削除",
        "ko": "행 추가/제거"
      },
      "addRemoveColumns": {
        "zh-TW": "新增/刪除列",
        "zh-CN": "添加/删除列",
        "en": "Add/Remove columns",
        "hi": "कॉलम जोड़ें/हटाएं",
        "ja": "列の追加/削除",
        "ko": "열 추가/제거"
      },
      "sortFilter": {
        "zh-TW": "排序和篩選功能",
        "zh-CN": "排序和筛选功能",
        "en": "Sort and filter functionality",
        "hi": "सॉर्ट और फ़िल्टर कार्यक्षमता",
        "ja": "ソートとフィルター機能",
        "ko": "정렬 및 필터 기능"
      },
      "exportFormats": {
        "zh-TW": "多種匯出格式 (CSV, TSV, JSON, Excel)",
        "zh-CN": "多种导出格式 (CSV, TSV, JSON, Excel)",
        "en": "Multiple export formats (CSV, TSV, JSON, Excel)",
        "hi": "कई निर्यात प्रारूप (CSV, TSV, JSON, Excel)",
        "ja": "複数のエクスポート形式 (CSV, TSV, JSON, Excel)",
        "ko": "다양한 내보내기 형식 (CSV, TSV, JSON, Excel)"
      },
      "aboutTitle": {
        "zh-TW": "關於 CSV 處理",
        "zh-CN": "关于 CSV 处理",
        "en": "About CSV Processing",
        "hi": "CSV प्रसंस्करण के बारे में",
        "ja": "CSV処理について",
        "ko": "CSV 처리에 대해"
      },
      "features": {
        "zh-TW": "功能特色",
        "zh-CN": "功能特色",
        "en": "Features",
        "hi": "विशेषताएं",
        "ja": "機能",
        "ko": "기능"
      },
      "supportedOperations": {
        "zh-TW": "支援操作",
        "zh-CN": "支持操作",
        "en": "Supported Operations",
        "hi": "समर्थित संचालन",
        "ja": "サポート操作",
        "ko": "지원 작업"
      },
      "multipleFormats": {
        "zh-TW": "多格式支援 (CSV, TSV, PSV)",
        "zh-CN": "多格式支持 (CSV, TSV, PSV)",
        "en": "Multiple format support (CSV, TSV, PSV)",
        "hi": "बहु प्रारूप समर्थन (CSV, TSV, PSV)",
        "ja": "複数形式サポート (CSV, TSV, PSV)",
        "ko": "다중 형식 지원 (CSV, TSV, PSV)"
      },
      "dataValidation": {
        "zh-TW": "資料驗證與清理",
        "zh-CN": "数据验证与清理",
        "en": "Data validation and cleaning",
        "hi": "डेटा सत्यापन और सफाई",
        "ja": "データ検証とクリーニング",
        "ko": "데이터 검증 및 정리"
      },
      "editSupport": {
        "zh-TW": "即時編輯支援",
        "zh-CN": "即时编辑支持",
        "en": "Real-time edit support",
        "hi": "वास्तविक समय संपादन समर्थन",
        "ja": "リアルタイム編集サポート",
        "ko": "실시간 편집 지원"
      },
      "exportOptions": {
        "zh-TW": "多種匯出選項",
        "zh-CN": "多种导出选项",
        "en": "Multiple export options",
        "hi": "कई निर्यात विकल्प",
        "ja": "複数エクスポートオプション",
        "ko": "다중 내보내기 옵션"
      },
      "largeFiles": {
        "zh-TW": "大檔案處理能力",
        "zh-CN": "大文件处理能力",
        "en": "Large file processing capability",
        "hi": "बड़ी फ़ाइल प्रसंस्करण क्षमता",
        "ja": "大型ファイル処理能力",
        "ko": "대용량 파일 처리 능력"
      },
      "duplicateRemoval": {
        "zh-TW": "重複資料移除",
        "zh-CN": "重复数据移除",
        "en": "Duplicate data removal",
        "hi": "डुप्लिकेट डेटा हटाना",
        "ja": "重複データ削除",
        "ko": "중복 데이터 제거"
      },
      "emptyRowRemoval": {
        "zh-TW": "空行清理",
        "zh-CN": "空行清理",
        "en": "Empty row cleanup",
        "hi": "खाली पंक्ति सफाई",
        "ja": "空行クリーンアップ",
        "ko": "빈 행 정리"
      },
      "dataSort": {
        "zh-TW": "資料排序",
        "zh-CN": "数据排序",
        "en": "Data sorting",
        "hi": "डेटा सॉर्टिंग",
        "ja": "データソート",
        "ko": "데이터 정렬"
      },
      "dataFilter": {
        "zh-TW": "資料篩選",
        "zh-CN": "数据筛选",
        "en": "Data filtering",
        "hi": "डेटा फ़िल्टरिंग",
        "ja": "データフィルタリング",
        "ko": "데이터 필터링"
      },
      "columnManagement": {
        "zh-TW": "欄位管理",
        "zh-CN": "列管理",
        "en": "Column management",
        "hi": "कॉलम प्रबंधन",
        "ja": "列管理",
        "ko": "열 관리"
      },
      "usage": {
        "zh-TW": "支援拖拽上傳 CSV 檔案或直接貼上資料，提供完整的編輯和轉換功能。",
        "zh-CN": "支持拖拽上传 CSV 文件或直接粘贴数据，提供完整的编辑和转换功能。",
        "en": "Supports drag-and-drop CSV file upload or direct data pasting with complete editing and conversion features.",
        "hi": "CSV फ़ाइल अपलोड के लिए ड्रैग-एंड-ड्रॉप या डेटा पेस्ट करने का समर्थन करता है, पूर्ण संपादन और रूपांतरण सुविधाएं प्रदान करता है।",
        "ja": "CSV ファイルのドラッグアンドドロップアップロードまたはデータの直接貼り付けをサポート、完全な編集と変換機能を提供。",
        "ko": "CSV 파일의 드래그 앤 드롭 업로드 또는 데이터 직접 붙여넣기를 지원하며, 완전한 편집 및 변환 기능을 제공합니다."
      },
      "encodingUtf8": {
        "zh-TW": "UTF-8",
        "zh-CN": "UTF-8",
        "en": "UTF-8",
        "hi": "UTF-8",
        "ja": "UTF-8",
        "ko": "UTF-8"
      },
      "encodingBig5": {
        "zh-TW": "Big5 (繁體中文)",
        "zh-CN": "Big5 (繁体中文)",
        "en": "Big5 (Traditional Chinese)",
        "hi": "Big5 (पारंपरिक चीनी)",
        "ja": "Big5 (繁体字中国語)",
        "ko": "Big5 (번체 중국어)"
      },
      "encodingGb2312": {
        "zh-TW": "GB2312 (簡體中文)",
        "zh-CN": "GB2312 (简体中文)",
        "en": "GB2312 (Simplified Chinese)",
        "hi": "GB2312 (सरलीकृत चीनी)",
        "ja": "GB2312 (簡体字中国語)",
        "ko": "GB2312 (간체 중국어)"
      },
      "formatCsv": {
        "zh-TW": "CSV",
        "zh-CN": "CSV",
        "en": "CSV",
        "hi": "CSV",
        "ja": "CSV",
        "ko": "CSV"
      },
      "formatJson": {
        "zh-TW": "JSON",
        "zh-CN": "JSON",
        "en": "JSON",
        "hi": "JSON",
        "ja": "JSON",
        "ko": "JSON"
      },
      "formatExcel": {
        "zh-TW": "Excel (XLSX)",
        "zh-CN": "Excel (XLSX)",
        "en": "Excel (XLSX)",
        "hi": "Excel (XLSX)",
        "ja": "Excel (XLSX)",
        "ko": "Excel (XLSX)"
      }
    },
    "description": {
      "zh-TW": "專業的 API 開發工具集，提升開發者的工作效率",
      "zh-CN": "专业的 API 开发工具集，提升开发者的工作效率",
      "en": "Professional API development toolkit to boost your productivity",
      "hi": "पेशेवर API विकास उपकरण सेट, डेवलपर्स की कार्य दक्षता में सुधार",
      "ja": "プロフェッショナルなAPI開発ツールセット、開発者の作業効率を向上",
      "ko": "전문 API 개발 도구 세트로 개발자의 작업 효율성 향상"
    },
    "hashGenerator": {
      "aboutTitle": {
        "zh-TW": "關於雜湊演算法",
        "zh-CN": "关于杂凑算法",
        "en": "About Hash Algorithms",
        "hi": "हैश एल्गोरिदम के बारे में",
        "ja": "ハッシュアルゴリズムについて",
        "ko": "해시 알고리즘에 대해"
      },
      "algorithm": {
        "zh-TW": "雜湊算法",
        "zh-CN": "杂湊算法",
        "en": "Hash Algorithm",
        "hi": "हैश एल्गोरिदम",
        "ja": "ハッシュアルゴリズム",
        "ko": "해시 알고리즘"
      },
      "characters": {
        "zh-TW": "字符",
        "zh-CN": "字符",
        "en": "Characters",
        "hi": "वर्ण",
        "ja": "文字数",
        "ko": "문자 수"
      },
      "compare": {
        "zh-TW": "雜湊比較",
        "zh-CN": "杂湊比較",
        "en": "Hash Comparison",
        "hi": "हैश तुलना",
        "ja": "ハッシュ比較",
        "ko": "해시 비교"
      },
      "compareAction": {
        "zh-TW": "比較",
        "zh-CN": "比較",
        "en": "Compare",
        "hi": "तुलना करें",
        "ja": "比較",
        "ko": "비교"
      },
      "comparePlaceholder": {
        "zh-TW": "輸入要比較的雜湊值...",
        "zh-CN": "输入要比較的杂湊值...",
        "en": "Enter hash value to compare...",
        "hi": "तुलना करने के लिए हैश मान दर्ज करें...",
        "ja": "比較するハッシュ値を入力...",
        "ko": "비교할 해시 값을 입력하세요..."
      },
      "description": {
        "zh-TW": "產生各種雜湊值，支援 MD5、SHA1、SHA256 等算法",
        "zh-CN": "产生各种杂湊值，支持 MD5、SHA1、SHA256 等算法",
        "en": "Generate various hash values, support MD5, SHA1, SHA256 algorithms",
        "hi": "विभिन्न हैश वैल्यू जेनरेट करें, MD5, SHA1, SHA256 आदि एल्गोरिदम का समर्थन",
        "ja": "各種ハッシュ値を生成、MD5、SHA1、SHA256などのアルゴリズムをサポート",
        "ko": "다양한 해시 값을 생성하며, MD5, SHA1, SHA256 등의 알고리즘을 지원합니다"
      },
      "generate": {
        "zh-TW": "產生雜湊",
        "zh-CN": "产生杂湊",
        "en": "Generate Hash",
        "hi": "हैश जेनरेट करें",
        "ja": "ハッシュ生成",
        "ko": "해시 생성"
      },
      "inputPlaceholder": {
        "zh-TW": "請輸入要產生雜湊的文字...",
        "zh-CN": "請输入要产生杂湊的文字...",
        "en": "Enter text to generate hash...",
        "hi": "इनपुट",
        "ja": "入力",
        "ko": "입력"
      },
      "length": {
        "zh-TW": "長度",
        "zh-CN": "长度",
        "en": "Length",
        "hi": "लंबाई",
        "ja": "長さ",
        "ko": "길이"
      },
      "match": {
        "zh-TW": "雜湊值相符",
        "zh-CN": "杂湊值相符",
        "en": "Hash values match",
        "hi": "हैश मान मेल खाते हैं",
        "ja": "ハッシュ値が一致",
        "ko": "해시 값 일치"
      },
      "noMatch": {
        "zh-TW": "雜湊值不符",
        "zh-CN": "杂湊值不符",
        "en": "Hash values do not match",
        "hi": "हैश मान मेल नहीं खाते",
        "ja": "ハッシュ値が不一致",
        "ko": "해시 값 불일치"
      },
      "title": {
        "zh-TW": "雜湊產生器",
        "zh-CN": "杂湊产生器",
        "en": "Hash Generator",
        "hi": "हैश जेनरेटर",
        "ja": "ハッシュジェネレーター",
        "ko": "해시 생성기"
      },
      "selectAlgorithm": {
        "zh-TW": "選擇演算法",
        "zh-CN": "选择算法",
        "en": "Select Algorithm",
        "hi": "एल्गोरिदम चुनें",
        "ja": "アルゴリズム選択",
        "ko": "알고리즘 선택"
      },
      "recommended": {
        "zh-TW": "推薦",
        "zh-CN": "推荐",
        "en": "Recommended",
        "hi": "अनुशंसित",
        "ja": "推奨",
        "ko": "권장"
      },
      "deprecated": {
        "zh-TW": "已棄用",
        "zh-CN": "已弃用",
        "en": "Deprecated",
        "hi": "अप्रचलित",
        "ja": "非推奨",
        "ko": "사용 중단"
      },
      "hashLength": {
        "zh-TW": "雜湊長度",
        "zh-CN": "杂凑长度",
        "en": "Hash Length",
        "hi": "हैश लंबाई",
        "ja": "ハッシュ長",
        "ko": "해시 길이"
      },
      "security": {
        "zh-TW": "安全性",
        "zh-CN": "安全性",
        "en": "Security",
        "hi": "सुरक्षा",
        "ja": "セキュリティ",
        "ko": "보안"
      },
      "useCase": {
        "zh-TW": "適用場景",
        "zh-CN": "适用场景",
        "en": "Use Case",
        "hi": "उपयोग मामला",
        "ja": "使用例",
        "ko": "사용 사례"
      },
      "securityTip": {
        "zh-TW": "安全性建議",
        "zh-CN": "安全性建议",
        "en": "Security Recommendation",
        "hi": "सुरक्षा सुझाव",
        "ja": "セキュリティ推奨",
        "ko": "보안 권장"
      },
      "securityTipDesc": {
        "zh-TW": "對於安全性要求較高的應用，建議使用 SHA-256 或 SHA-512。SHA-1 已不推薦用於新的安全應用。",
        "zh-CN": "对于安全性要求较高的应用，建议使用 SHA-256 或 SHA-512。SHA-1 已不推荐用于新的安全应用。",
        "en": "For security-critical applications, it is recommended to use SHA-256 or SHA-512. SHA-1 is no longer recommended for new security applications.",
        "hi": "सुरक्षा-महत्वपूर्ण अनुप्रयोगों के लिए, SHA-256 या SHA-512 का उपयोग करने की सिफारिश की जाती है। SHA-1 अब नए सुरक्षा अनुप्रयोगों के लिए अनुशंसित नहीं है।",
        "ja": "セキュリティが重要なアプリケーションでは、SHA-256またはSHA-512の使用を推奨します。SHA-1は新しいセキュリティアプリケーションには推奨されません。",
        "ko": "보안이 중요한 애플리케이션의 경우 SHA-256 또는 SHA-512 사용을 권장합니다. SHA-1은 새로운 보안 애플리케이션에 더 이상 권장되지 않습니다."
      },
      "sha1Description": {
        "zh-TW": "160位元雜湊值，已不推薦用於安全性需求高的應用",
        "zh-CN": "160位元杂凑值，已不推荐用于安全性需求高的应用",
        "en": "160-bit hash value, not recommended for high-security applications",
        "hi": "160-बिट हैश वैल्यू, उच्च सुरक्षा अनुप्रयोगों के लिए अनुशंसित नहीं",
        "ja": "160ビットハッシュ値、高セキュリティアプリケーションには推奨されません",
        "ko": "160비트 해시 값, 높은 보안이 필요한 애플리케이션에는 권장되지 않음"
      },
      "sha1UseCase": {
        "zh-TW": "舊系統相容、檔案完整性檢查",
        "zh-CN": "旧系统兼容、文件完整性检查",
        "en": "Legacy system compatibility, file integrity checks",
        "hi": "लीगेसी सिस्टम संगतता, फ़ाइल अखंडता जांच",
        "ja": "レガシーシステム互換、ファイル整合性チェック",
        "ko": "레거시 시스템 호환성, 파일 무결성 검사"
      },
      "sha256Description": {
        "zh-TW": "256位元雜湊值，安全性高，廣泛使用於現代應用",
        "zh-CN": "256位元杂凑值，安全性高，广泛使用于现代应用",
        "en": "256-bit hash value, high security, widely used in modern applications",
        "hi": "256-बिट हैश वैल्यू, उच्च सुरक्षा, आधुनिक अनुप्रयोगों में व्यापक रूप से उपयोग",
        "ja": "256ビットハッシュ値、高セキュリティ、現代アプリケーションで広く使用",
        "ko": "256비트 해시 값, 높은 보안성, 현대 애플리케이션에서 광범위하게 사용"
      },
      "sha256UseCase": {
        "zh-TW": "密碼儲存、區塊鏈、數位簽章",
        "zh-CN": "密码储存、区块链、数字签名",
        "en": "Password storage, blockchain, digital signatures",
        "hi": "पासवर्ड स्टोरेज, ब्लॉकचेन, डिजिटल हस्ताक्षर",
        "ja": "パスワード保存、ブロックチェーン、デジタル署名",
        "ko": "비밀번호 저장, 블록체인, 디지털 서명"
      },
      "sha384Description": {
        "zh-TW": "384位元雜湊值，提供更高層級的安全性",
        "zh-CN": "384位元杂凑值，提供更高层级的安全性",
        "en": "384-bit hash value, provides higher level of security",
        "hi": "384-बिट हैश वैल्यू, उच्च स्तर की सुरक्षा प्रदान करता है",
        "ja": "384ビットハッシュ値、より高いレベルのセキュリティを提供",
        "ko": "384비트 해시 값, 더 높은 수준의 보안 제공"
      },
      "sha384UseCase": {
        "zh-TW": "企業級應用、高級加密協議",
        "zh-CN": "企业级应用、高级加密协议",
        "en": "Enterprise applications, advanced encryption protocols",
        "hi": "एंटरप्राइज़ एप्लिकेशन, उन्नत एन्क्रिप्शन प्रोटोकॉल",
        "ja": "エンタープライズアプリケーション、高度暗号化プロトコル",
        "ko": "엔터프라이즈 애플리케이션, 고급 암호화 프로토콜"
      },
      "sha512Description": {
        "zh-TW": "512位元雜湊值，提供最高層級的安全性",
        "zh-CN": "512位元杂凑值，提供最高层级的安全性",
        "en": "512-bit hash value, provides the highest level of security",
        "hi": "512-बिट हैश वैल्यू, सर्वोच्च स्तर की सुरक्षा प्रदान करता है",
        "ja": "512ビットハッシュ值、最高レベルのセキュリティを提供",
        "ko": "512비트 해시 값, 최고 수준의 보안 제공"
      },
      "sha512UseCase": {
        "zh-TW": "軍用級安全、關鍵基礎設施",
        "zh-CN": "军用级安全、关键基础设施",
        "en": "Military-grade security, critical infrastructure",
        "hi": "सैन्य-ग्रेड सुरक्षा, महत्वपूर्ण अवसंरचना",
        "ja": "軍用レベルセキュリティ、重要インフラ",
        "ko": "군용급 보안, 중요 인프라"
      },
      "showRecommended": {
        "zh-TW": "僅顯示推薦",
        "zh-CN": "仅显示推荐",
        "en": "Show Recommended Only",
        "hi": "केवल अनुशंसित दिखाएं",
        "ja": "推奨のみ表示",
        "ko": "권장만 표시"
      },
      "showDeprecated": {
        "zh-TW": "顯示已棄用",
        "zh-CN": "显示已弃用",
        "en": "Show Deprecated",
        "hi": "अप्रचलित दिखाएं",
        "ja": "非推奨を表示",
        "ko": "사용 중단된 것 표시"
      }
    },
    "xmlFormatter": {
      "title": {
        "zh-TW": "XML 格式化工具",
        "zh-CN": "XML 格式化工具",
        "en": "XML Formatter",
        "hi": "XML फॉर्मेटर",
        "ja": "XMLフォーマッター",
        "ko": "XML 포맷터"
      },
      "description": {
        "zh-TW": "格式化、驗證和美化 XML 文檔，支援語法檢查和結構分析",
        "zh-CN": "格式化、验证和美化 XML 文档，支持语法检查和结构分析",
        "en": "Format, validate and beautify XML documents with syntax checking and structure analysis",
        "hi": "सिंटैक्स जांच और संरचना विश्लेषण के साथ XML दस्तावेजों को फॉर्मेट, सत्यापित और सुंदर बनाएं",
        "ja": "XMLドキュメントのフォーマット、検証、美化を構文チェックと構造解析で行います",
        "ko": "구문 검사 및 구조 분석을 통한 XML 문서 형식 지정, 검증 및 미화"
      },
      "inputXml": {
        "zh-TW": "輸入 XML",
        "zh-CN": "输入 XML",
        "en": "Input XML",
        "hi": "XML इनपुट",
        "ja": "XML入力",
        "ko": "XML 입력"
      },
      "uploadFile": {
        "zh-TW": "上傳檔案",
        "zh-CN": "上传文件",
        "en": "Upload File",
        "hi": "फ़ाइल अपलोड करें",
        "ja": "ファイルアップロード",
        "ko": "파일 업로드"
      },
      "operations": {
        "zh-TW": "操作功能",
        "zh-CN": "操作功能",
        "en": "Operations",
        "hi": "संचालन",
        "ja": "操作",
        "ko": "작업"
      },
      "beautify": {
        "zh-TW": "美化格式",
        "zh-CN": "美化格式",
        "en": "Beautify",
        "hi": "सुंदर बनाएं",
        "ja": "美化",
        "ko": "미화"
      },
      "minify": {
        "zh-TW": "壓縮格式",
        "zh-CN": "压缩格式",
        "en": "Minify",
        "hi": "संक्षिप्त करें",
        "ja": "圧縮",
        "ko": "압축"
      },
      "validate": {
        "zh-TW": "驗證語法",
        "zh-CN": "验证语法",
        "en": "Validate",
        "hi": "सत्यापित करें",
        "ja": "検証",
        "ko": "검증"
      },
      "extractSchema": {
        "zh-TW": "提取結構",
        "zh-CN": "提取结构",
        "en": "Extract Schema",
        "hi": "स्कीमा निकालें",
        "ja": "スキーマ抽出",
        "ko": "스키마 추출"
      },
      "aboutTitle": {
        "zh-TW": "關於 XML 格式化",
        "zh-CN": "关于 XML 格式化",
        "en": "About XML Formatting",
        "hi": "XML फॉर्मेटिंग के बारे में",
        "ja": "XMLフォーマットについて",
        "ko": "XML 포맷에 대해"
      },
      "beautifyDesc": {
        "zh-TW": "將 XML 格式化為易讀的縮排結構",
        "zh-CN": "将 XML 格式化为易读的缩进结构",
        "en": "Format XML into readable indented structure",
        "hi": "XML को पढ़ने योग्य इंडेंटेड संरचना में फॉर्मेट करें",
        "ja": "XMLを読みやすいインデント構造にフォーマット",
        "ko": "XML을 읽기 쉬운 들여쓰기 구조로 포맷"
      },
      "minifyDesc": {
        "zh-TW": "移除不必要的空白和換行，減少檔案大小",
        "zh-CN": "移除不必要的空白和换行，减少文件大小",
        "en": "Remove unnecessary whitespace and line breaks to reduce file size",
        "hi": "फ़ाइल का आकार कम करने के लिए अनावश्यक व्हाइटस्पेस और लाइन ब्रेक हटाएं",
        "ja": "不要な空白と改行を削除してファイルサイズを縮小",
        "ko": "불필요한 공백과 줄 바꿈을 제거하여 파일 크기 축소"
      },
      "validateDesc": {
        "zh-TW": "檢查 XML 語法是否正確並報告錯誤",
        "zh-CN": "检查 XML 语法是否正确并报告错误",
        "en": "Check XML syntax correctness and report errors",
        "hi": "XML सिंटैक्स की शुद्धता जांचें और त्रुटियों की रिपोर्ट करें",
        "ja": "XML構文の正確性をチェックしてエラーを報告",
        "ko": "XML 구문의 정확성을 확인하고 오류 보고"
      },
      "extractSchemaDesc": {
        "zh-TW": "分析 XML 結構並生成元素統計",
        "zh-CN": "分析 XML 结构并生成元素统计",
        "en": "Analyze XML structure and generate element statistics",
        "hi": "XML संरचना का विश्लेषण करें और तत्व आंकड़े बनाएं",
        "ja": "XML構造を分析して要素統計を生成",
        "ko": "XML 구조를 분석하고 요소 통계 생성"
      },
      "supportedFormats": {
        "zh-TW": "支援 XML、XSD、XSLT 和其他 XML 相關格式檔案",
        "zh-CN": "支持 XML、XSD、XSLT 和其他 XML 相关格式文件",
        "en": "Supports XML, XSD, XSLT and other XML-related format files",
        "hi": "XML, XSD, XSLT और अन्य XML-संबंधित प्रारूप फ़ाइलों का समर्थन करता है",
        "ja": "XML、XSD、XSLTおよびその他のXML関連形式ファイルをサポート",
        "ko": "XML, XSD, XSLT 및 기타 XML 관련 형식 파일 지원"
      },
      "xmlPlaceholder": {
        "zh-TW": "請輸入或貼上 XML 內容...",
        "zh-CN": "请输入或粘贴 XML 内容...",
        "en": "Enter or paste XML content...",
        "hi": "XML सामग्री दर्ज करें या पेस्ट करें...",
        "ja": "XMLコンテンツを入力または貼り付け...",
        "ko": "XML 내용을 입력하거나 붙여넣기..."
      },
      "clickOrDrop": {
        "zh-TW": "點擊選擇檔案或拖拽到此處",
        "zh-CN": "点击选择文件或拖拽到此处",
        "en": "Click to select file or drag here",
        "hi": "फ़ाइल चुनने के लिए क्लिक करें या यहाँ खींचें",
        "ja": "ファイルを選択するかここにドラッグ",
        "ko": "파일을 선택하려면 클릭하거나 여기로 드래그"
      },
      "validXml": {
        "zh-TW": "有效的 XML",
        "zh-CN": "有效的 XML",
        "en": "Valid XML",
        "hi": "वैध XML",
        "ja": "有効なXML",
        "ko": "유효한 XML"
      },
      "invalidXml": {
        "zh-TW": "無效的 XML",
        "zh-CN": "无效的 XML",
        "en": "Invalid XML",
        "hi": "अमान्य XML",
        "ja": "無効なXML",
        "ko": "유효하지 않은 XML"
      },
      "parseError": {
        "zh-TW": "解析錯誤",
        "zh-CN": "解析错误",
        "en": "Parse Error",
        "hi": "पार्स त्रुटि",
        "ja": "解析エラー",
        "ko": "구문 분석 오류"
      }
    },
    "imageConverter": {
      "convert": {
        "zh-TW": "開始轉換",
        "zh-CN": "开始转换",
        "en": "Start Conversion",
        "hi": "कन्वर्ट करें",
        "ja": "変換開始",
        "ko": "변환"
      },
      "converted": {
        "zh-TW": "轉換完成",
        "zh-CN": "转换完成",
        "en": "Converted",
        "hi": "रूपांतरण पूर्ण",
        "ja": "変換完了",
        "ko": "변환 완료"
      },
      "description": {
        "zh-TW": "轉換圖片格式，支援 JPEG、PNG、WebP 等格式，可調整品質和尺寸",
        "zh-CN": "转换图片格式，支持 JPEG、PNG、WebP 等格式，可調整品质和尺寸",
        "en": "Convert image formats, support JPEG, PNG, WebP formats with quality and size adjustment",
        "hi": "विभिन्न इमेज फॉर्मेट के बीच कन्वर्ट करें, आकार बदलें और गुणवत्ता समायोजित करें",
        "ja": "画像形式を変換、JPEG、PNG、WebPなどの形式をサポート、品質とサイズを調整可能",
        "ko": "다양한 이미지 포맷 간 변환을 지원하며, 크기 조정과 품질 조정이 가능합니다"
      },
      "downloadAll": {
        "zh-TW": "下載全部",
        "zh-CN": "下载全部",
        "en": "Download All",
        "hi": "सभी डाउनलोड करें",
        "ja": "すべてダウンロード",
        "ko": "모두 다운로드"
      },
      "dragDrop": {
        "zh-TW": "拖放圖片到此處或點擊選擇",
        "zh-CN": "拖放图片到此处或点击选择",
        "en": "Drag and drop images here or click to select",
        "hi": "या इमेज को यहाँ ड्रैग और ड्रॉप करें",
        "ja": "画像をここにドラッグ&ドロップまたはクリックして選択",
        "ko": "또는 이미지를 여기에 드래그 앤 드롭"
      },
      "filesSelected": {
        "zh-TW": "已選擇 {count} 個檔案",
        "zh-CN": "已选择 {count} 个档案",
        "en": "{count} files selected",
        "hi": "{count} फ़ाइलें चयनित",
        "ja": "{count}個のファイルが選択されました",
        "ko": "{count}개 파일 선택됨"
      },
      "maintainRatio": {
        "zh-TW": "保持長寬比",
        "zh-CN": "保持长寬比",
        "en": "Maintain Aspect Ratio",
        "hi": "पहलू अनुपात बनाए रखें",
        "ja": "アスペクト比を維持",
        "ko": "가로세로 비율 유지"
      },
      "outputFormat": {
        "zh-TW": "輸出格式",
        "zh-CN": "输出格式",
        "en": "Output Format",
        "hi": "आउटपुट फॉर्मेट",
        "ja": "出力形式",
        "ko": "출력 포맷"
      },
      "preview": {
        "zh-TW": "預覽",
        "zh-CN": "预览",
        "en": "Preview",
        "hi": "पूर्वावलोकन",
        "ja": "プレビュー",
        "ko": "미리보기"
      },
      "quality": {
        "zh-TW": "品質",
        "zh-CN": "品质",
        "en": "Quality",
        "hi": "गुणवत्ता",
        "ja": "品質",
        "ko": "품질"
      },
      "resize": {
        "zh-TW": "調整尺寸",
        "zh-CN": "調整尺寸",
        "en": "Resize",
        "hi": "आकार बदलें",
        "ja": "サイズ調整",
        "ko": "크기 조정"
      },
      "selectFiles": {
        "zh-TW": "選擇檔案",
        "zh-CN": "选择档案",
        "en": "Select Files",
        "hi": "फ़ाइल चुनें",
        "ja": "ファイルを選択",
        "ko": "파일 선택"
      },
      "settings": {
        "zh-TW": "轉換設定",
        "zh-CN": "转换设定",
        "en": "Conversion Settings",
        "hi": "रूपांतरण सेटिंग्स",
        "ja": "変換設定",
        "ko": "변환 설정"
      },
      "title": {
        "zh-TW": "圖片格式轉換工具",
        "zh-CN": "图片格式转换工具",
        "en": "Image Format Converter",
        "hi": "इमेज फॉर्मेट कन्वर्टर",
        "ja": "画像形式変換ツール",
        "ko": "이미지 포맷 변환기"
      },
      "upload": {
        "zh-TW": "上傳圖片",
        "zh-CN": "上传图片",
        "en": "Upload Images",
        "hi": "छवि अपलोड करें",
        "ja": "画像をアップロード",
        "ko": "이미지 업로드"
      },
      "aboutTitle": {
        "zh-TW": "關於圖片格式轉換",
        "zh-CN": "关于图片格式转换",
        "en": "About Image Format Conversion",
        "hi": "छवि प्रारूप रूपांतरण के बारे में",
        "ja": "画像形式変換について",
        "ko": "이미지 형식 변환에 대해"
      },
      "supportedFormats": {
        "zh-TW": "支援格式",
        "zh-CN": "支持格式",
        "en": "Supported Formats",
        "hi": "समर्थित प्रारूप",
        "ja": "サポート形式",
        "ko": "지원 형식"
      },
      "features": {
        "zh-TW": "功能特色",
        "zh-CN": "功能特色",
        "en": "Features",
        "hi": "विशेषताएं",
        "ja": "機能",
        "ko": "기능"
      },
      "jpegDesc": {
        "zh-TW": "有損壓縮，適合照片",
        "zh-CN": "有损压缩，适合照片",
        "en": "Lossy compression, ideal for photos",
        "hi": "हानिकारक संपीड़न, तस्वीरों के लिए आदर्श",
        "ja": "非可逆圧縮、写真に最適",
        "ko": "손실 압축, 사진에 이상적"
      },
      "pngDesc": {
        "zh-TW": "無損壓縮，支援透明背景",
        "zh-CN": "无损压缩，支持透明背景",
        "en": "Lossless compression, supports transparency",
        "hi": "हानिरहित संपीड़न, पारदर्शिता का समर्थन",
        "ja": "可逆圧縮、透明度サポート",
        "ko": "무손실 압축, 투명도 지원"
      },
      "webpDesc": {
        "zh-TW": "現代格式，檔案更小",
        "zh-CN": "现代格式，文件更小",
        "en": "Modern format, smaller file sizes",
        "hi": "आधुनिक प्रारूप, छोटी फ़ाइल आकार",
        "ja": "モダン形式、ファイルサイズ小",
        "ko": "현대적 형식, 더 작은 파일 크기"
      },
      "batchProcessing": {
        "zh-TW": "批量處理多個檔案",
        "zh-CN": "批量处理多个文件",
        "en": "Batch process multiple files",
        "hi": "कई फ़ाइलों का बैच प्रसंस्करण",
        "ja": "複数ファイルの一括処理",
        "ko": "여러 파일 일괄 처리"
      },
      "qualityControl": {
        "zh-TW": "品質控制和壓縮",
        "zh-CN": "品质控制和压缩",
        "en": "Quality control and compression",
        "hi": "गुणवत्ता नियंत्रण और संपीड़न",
        "ja": "品質制御と圧縮",
        "ko": "품질 제어 및 압축"
      },
      "resizeOptions": {
        "zh-TW": "尺寸調整選項",
        "zh-CN": "尺寸调整选项",
        "en": "Resize options",
        "hi": "आकार समायोजन विकल्प",
        "ja": "サイズ調整オプション",
        "ko": "크기 조정 옵션"
      },
      "previewSupport": {
        "zh-TW": "即時預覽支援",
        "zh-CN": "即时预览支持",
        "en": "Real-time preview support",
        "hi": "वास्तविक समय पूर्वावलोकन समर्थन",
        "ja": "リアルタイムプレビューサポート",
        "ko": "실시간 미리보기 지원"
      },
      "usage": {
        "zh-TW": "支援拖拽上傳或點擊選擇檔案，調整品質和尺寸設定後進行轉換。",
        "zh-CN": "支持拖拽上传或点击选择文件，调整品质和尺寸设置后进行转换。",
        "en": "Supports drag-and-drop upload or click to select files, adjust quality and size settings before conversion.",
        "hi": "ड्रैग-एंड-ड्रॉप अपलोड या फ़ाइलों का चयन करने के लिए क्लिक का समर्थन करता है, रूपांतरण से पहले गुणवत्ता और आकार सेटिंग्स समायोजित करें।",
        "ja": "ドラッグアンドドロップアップロードまたはクリックでファイル選択をサポート、変換前に品質とサイズ設定を調整します。",
        "ko": "드래그 앤 드롭 업로드 또는 클릭하여 파일 선택을 지원하며, 변환 전 품질 및 크기 설정을 조정합니다."
      }
    },
    "json": {
      "arrays": {
        "zh-TW": "陣列數量",
        "zh-CN": "陣列数量",
        "en": "Arrays",
        "hi": "ऐरे की संख्या",
        "ja": "配列数",
        "ko": "배열 수"
      },
      "copy": {
        "zh-TW": "複製結果",
        "zh-CN": "复制结果",
        "en": "Copy Result",
        "hi": "कॉपी करेंपरिणाम",
        "ja": "コピー",
        "ko": "복사결과"
      },
      "description": {
        "zh-TW": "美化、驗證和格式化 JSON 資料，支援大型檔案處理",
        "zh-CN": "美化、验证和格式化 JSON 资料，支持大型档案处理",
        "en": "Beautify, validate and format JSON data with large file support",
        "hi": "JSON डेटा को सुंदर बनाएं, सत्यापित करें और प्रारूपित करें, बड़ी फ़ाइल प्रसंस्करण का समर्थन करता है",
        "ja": "JSONデータの美化、検証、フォーマット、大型ファイル処理をサポート",
        "ko": "JSON 데이터 미화, 검증 및 포맷, 대용량 파일 처리 지원"
      },
      "features": {
        "format": {
          "description": {
            "zh-TW": "自動美化 JSON 格式，讓代碼更易讀",
            "zh-CN": "自动美化 JSON 格式，讓代码更易读",
            "en": "Automatically beautify JSON format for better readability",
            "hi": "JSON प्रारूप को स्वचालित रूप से सुंदर बनाएं, कोड को अधिक पठनीय बनाएं",
            "ja": "JSON形式を自動的に美化し、コードをより読みやすくします",
            "ko": "JSON 형식을 자동으로 미화하여 코드를 더 읽기 쉽게 만듭니다"
          },
          "title": {
            "zh-TW": "JSON 格式化",
            "zh-CN": "JSON 格式化",
            "en": "JSON Formatting",
            "hi": "JSON प्रारूप",
            "ja": "JSON フォーマット",
            "ko": "JSON 포맷"
          }
        },
        "large": {
          "description": {
            "zh-TW": "支援處理大型 JSON 檔案，無檔案大小限制",
            "zh-CN": "支持处理大型 JSON 档案，无档案大小限制",
            "en": "Support processing large JSON files without size limitations",
            "hi": "बड़ी JSON फ़ाइलों के प्रसंस्करण का समर्थन करता है, कोई फ़ाइल आकार सीमा नहीं",
            "ja": "大型JSONファイルの処理をサポート、ファイルサイズ制限なし",
            "ko": "대용량 JSON 파일 처리 지원, 파일 크기 제한 없음"
          },
          "title": {
            "zh-TW": "大檔案支援",
            "zh-CN": "大档案支持",
            "en": "Large File Support",
            "hi": "बड़ी फ़ाइल समर्थन",
            "ja": "大型ファイルサポート",
            "ko": "대용량 파일 지원"
          }
        },
        "minify": {
          "description": {
            "zh-TW": "移除多餘空格和換行，減少檔案大小",
            "zh-CN": "移除多餘空格和换行，减少档案大小",
            "en": "Remove unnecessary spaces and line breaks to reduce file size",
            "hi": "अतिरिक्त स्थान और लाइन ब्रेक हटाएं, फ़ाइल का आकार कम करें",
            "ja": "余分なスペースと改行を削除し、ファイルサイズを削減",
            "ko": "불필요한 공백과 줄바꿈을 제거하여 파일 크기 감소"
          },
          "title": {
            "zh-TW": "壓縮優化",
            "zh-CN": "压缩优化",
            "en": "Compression",
            "hi": "संपीड़न अनुकूलन",
            "ja": "圧縮最適化",
            "ko": "압축 최적화"
          }
        },
        "title": {
          "zh-TW": "功能特色",
          "zh-CN": "功能特色",
          "en": "Features",
          "hi": "विशेषताएं",
          "ja": "機能の特徴",
          "ko": "주요 기능"
        },
        "validate": {
          "description": {
            "zh-TW": "即時檢查 JSON 語法錯誤並提供修正建議",
            "zh-CN": "即时检查 JSON 语法错误并提供修正建议",
            "en": "Real-time JSON syntax error checking with correction suggestions",
            "hi": "JSON सिंटैक्स त्रुटियों की वास्तविक समय जांच और सुधार सुझाव प्रदान करता है",
            "ja": "JSON構文エラーをリアルタイムでチェックし、修正提案を提供",
            "ko": "JSON 구문 오류를 실시간으로 확인하고 수정 제안 제공"
          },
          "title": {
            "zh-TW": "語法驗證",
            "zh-CN": "语法验证",
            "en": "Syntax Validation",
            "hi": "सिंटैक्स सत्यापन",
            "ja": "構文検証",
            "ko": "구문 검증"
          }
        }
      },
      "input": {
        "zh-TW": "輸入 JSON",
        "zh-CN": "输入 JSON",
        "en": "Input JSON",
        "hi": "इनपुट JSON",
        "ja": "入力",
        "ko": "입력 JSON"
      },
      "keys": {
        "zh-TW": "總鍵數",
        "zh-CN": "總键数",
        "en": "Total Keys",
        "hi": "कुल कीज़",
        "ja": "総キー数",
        "ko": "총 키 수"
      },
      "minify": {
        "zh-TW": "壓縮",
        "zh-CN": "压缩",
        "en": "Minify",
        "hi": "संपीड़न",
        "ja": "圧縮",
        "ko": "압축"
      },
      "objects": {
        "zh-TW": "物件數量",
        "zh-CN": "物件数量",
        "en": "Objects",
        "hi": "ऑब्जेक्ट की संख्या",
        "ja": "オブジェクト数",
        "ko": "객체 수"
      },
      "output": {
        "zh-TW": "格式化結果",
        "zh-CN": "格式化结果",
        "en": "Formatted Result",
        "hi": "प्रारूपपरिणाम",
        "ja": "フォーマット結果",
        "ko": "포맷결과"
      },
      "outputPlaceholder": {
        "zh-TW": "格式化後的 JSON 將在這裡顯示...",
        "zh-CN": "格式化後的 JSON 將在這裡显示...",
        "en": "Formatted JSON will appear here...",
        "hi": "प्रारूपित JSON यहाँ दिखाया जाएगा...",
        "ja": "フォーマット済みのJSONがここに表示されます...",
        "ko": "포맷된 JSON이 여기에 표시됩니다..."
      },
      "placeholder": {
        "zh-TW": "請貼上您的 JSON 資料...",
        "zh-CN": "請贴上您的 JSON 资料...",
        "en": "Paste your JSON data here...",
        "hi": "कृपया अपना JSON डेटा पेस्ट करें...",
        "ja": "JSONデータを貼り付けてください...",
        "ko": "JSON 데이터를 붙여넣으세요..."
      },
      "sample": {
        "zh-TW": "載入範例",
        "zh-CN": "载入范例",
        "en": "Load Sample",
        "hi": "नमूना लोड करें",
        "ja": "サンプル読み込み",
        "ko": "샘플 로드"
      },
      "size": {
        "zh-TW": "大小 (字節)",
        "zh-CN": "大小 (字节)",
        "en": "Size (bytes)",
        "hi": "आकार (बाइट्स)",
        "ja": "サイズ (バイト)",
        "ko": "크기 (바이트)"
      },
      "statistics": {
        "zh-TW": "JSON 統計",
        "zh-CN": "JSON 统计",
        "en": "JSON Statistics",
        "hi": "JSON आंकड़े",
        "ja": "JSON統計",
        "ko": "JSON 통계"
      },
      "title": {
        "zh-TW": "JSON 格式化工具",
        "zh-CN": "JSON 格式化工具",
        "en": "JSON Formatter Tool",
        "hi": "JSON फॉर्मेटर टूल",
        "ja": "JSONフォーマッターツール",
        "ko": "JSON 포맷터 도구"
      }
    },
    "jsonFormatter": {
      "category": {
        "zh-TW": "JSON 處理工具",
        "zh-CN": "JSON 处理工具",
        "en": "JSON ProcessTools",
        "hi": "JSON प्रसंस्करण उपकरण",
        "ja": "JSON処理ツール",
        "ko": "JSON 처리 도구"
      },
      "description": {
        "zh-TW": "美化、驗證和格式化 JSON 資料，支援大型檔案處理",
        "zh-CN": "美化、验证和格式化 JSON 资料，支持大型档案处理",
        "en": "Beautify, validate and format JSON data with large file support",
        "hi": "JSON डेटा को सुंदर बनाएं, सत्यापित करें और फॉर्मेट करें, बड़ी फ़ाइल समर्थन के साथ",
        "ja": "JSONデータの美化、検証、フォーマット、大型ファイル処理をサポート",
        "ko": "JSON 데이터를 아름답게 포맷하고 검증하며, 대용량 파일을 지원합니다"
      },
      "inputPlaceholder": {
        "zh-TW": "輸入 JSON 數據...",
        "zh-CN": "输入 JSON 数据...",
        "en": "Enter JSON data...",
        "hi": "JSON डेटा दर्ज करें...",
        "ja": "入力",
        "ko": "JSON 데이터를 입력하세요..."
      },
      "minify": {
        "zh-TW": "壓縮",
        "zh-CN": "压缩",
        "en": "Minify",
        "hi": "संपीड़ित करें",
        "ja": "圧縮",
        "ko": "압축"
      },
      "featuresTitle": {
        "zh-TW": "功能特色",
        "zh-CN": "功能特色",
        "en": "Features",
        "hi": "विशेषताएं",
        "ja": "機能の特徴",
        "ko": "기능"
      },
      "feature1Title": {
        "zh-TW": "即時格式化",
        "zh-CN": "即时格式化",
        "en": "Real-time Formatting",
        "hi": "रियल-टाइम फॉर्मेटिंग",
        "ja": "リアルタイムフォーマット",
        "ko": "실시간 포맷팅"
      },
      "feature1Description": {
        "zh-TW": "輸入 JSON 資料後立即美化格式",
        "zh-CN": "输入 JSON 资料後立即美化格式",
        "en": "Instantly beautify JSON format after input",
        "hi": "इनपुट के बाद तुरंत JSON फॉर्मेट को सुन्दर बनाएं",
        "ja": "JSONデータを入力すると即座に形式を美化",
        "ko": "입력 후 즉시 JSON 포맷을 아름답게 만듭니다"
      },
      "feature2Title": {
        "zh-TW": "語法驗證",
        "zh-CN": "语法验证",
        "en": "Syntax Validation",
        "hi": "सिंटैक्स सत्यापन",
        "ja": "構文検証",
        "ko": "구문 검증"
      },
      "feature2Description": {
        "zh-TW": "自動檢測並提示 JSON 語法錯誤",
        "zh-CN": "自动检测并提示 JSON 语法错误",
        "en": "Automatically detect and highlight JSON syntax errors",
        "hi": "स्वचालित रूप से JSON सिंटैक्स त्रुटियों का पता लगाएं",
        "ja": "JSON構文エラーを自動検出して警告",
        "ko": "JSON 구문 오류를 자동으로 감지하고 표시합니다"
      },
      "feature3Title": {
        "zh-TW": "壓縮優化",
        "zh-CN": "压缩优化",
        "en": "Compression",
        "hi": "संपीड़न",
        "ja": "圧縮最適化",
        "ko": "압축"
      },
      "feature3Description": {
        "zh-TW": "移除多餘空格減少檔案大小",
        "zh-CN": "移除多餘空格减少档案大小",
        "en": "Remove unnecessary spaces to reduce file size",
        "hi": "फ़ाइल का आकार कम करने के लिए अनावश्यक स्थान हटाएं",
        "ja": "余分なスペースを削除してファイルサイズを削減",
        "ko": "불필요한 공백을 제거하여 파일 크기를 줄입니다"
      },
      "format": {
        "zh-TW": "格式化",
        "zh-CN": "格式化",
        "en": "Format",
        "hi": "फॉर्मेट करें",
        "ja": "フォーマット",
        "ko": "포맷"
      },
      "formatError": {
        "zh-TW": "格式化錯誤",
        "zh-CN": "格式化错误",
        "en": "Format Error",
        "hi": "फॉर्मेट त्रुटि",
        "ja": "フォーマットエラー",
        "ko": "포맷 오류"
      },
      "title": {
        "zh-TW": "JSON 格式化工具",
        "zh-CN": "JSON 格式化工具",
        "en": "JSON Formatter Tool",
        "hi": "JSON फॉर्मेटर टूल",
        "ja": "JSONフォーマッター",
        "ko": "JSON 포맷터 도구"
      },
      "validate": {
        "zh-TW": "驗證",
        "zh-CN": "验证",
        "en": "Validate",
        "hi": "सत्यापित करें",
        "ja": "検証",
        "ko": "검증"
      },
      "valid": {
        "zh-TW": "有效",
        "zh-CN": "有效",
        "en": "Valid",
        "hi": "मान्य",
        "ja": "有効",
        "ko": "유효"
      }
    },
    "jwtDecoder": {
      "description": {
        "zh-TW": "解析和驗證 JWT Token，查看 Header、Payload 和簽名信息",
        "zh-CN": "解析和验证 JWT Token，查看 Header、Payload 和签名信息",
        "en": "Decode and validate JWT tokens, view Header, Payload and signature information",
        "hi": "JWT टोकन को डिकोड और सत्यापित करें, हेडर, पेलोड और सिग्नेचर का विश्लेषण करें",
        "ja": "JWT Tokenを解析・検証し、Header、Payload、署名情報を表示",
        "ko": "JWT 토큰을 디코딩하고 검증하며, 헤더, 페이로드, 서명을 분석합니다"
      },
      "instruction1": {
        "zh-TW": "貼上您的 JWT Token 到上方輸入框，系統會自動解析並顯示結構化信息",
        "zh-CN": "粘贴您的 JWT Token 到上方输入框，系统会自动解析并显示结构化信息",
        "en": "Paste your JWT Token into the input field above, the system will automatically parse and display structured information",
        "hi": "ऊपर के इनपुट फ़ील्ड में अपना JWT टोकन पेस्ट करें, सिस्टम स्वचालित रूप से विश्लेषण करेगा और संरचित जानकारी प्रदर्शित करेगा",
        "ja": "JWT Tokenを上の入力フィールドに貼り付けると、システムが自動的に解析して構造化された情報を表示します",
        "ko": "JWT 토큰을 위의 입력 필드에 붙여넣으면, 시스템이 자동으로 분석하여 구조화된 정보를 표시합니다"
      },
      "instruction2": {
        "zh-TW": "Header 區域顯示 JWT 的算法信息和令牌類型",
        "zh-CN": "Header 区域显示 JWT 的算法信息和令牌类型",
        "en": "The Header section displays JWT algorithm information and token type",
        "hi": "हेडर सेक्शन JWT एल्गोरिदम जानकारी और टोकन प्रकार प्रदर्शित करता है",
        "ja": "Headerセクションは JWT のアルゴリズム情報とトークンタイプを表示します",
        "ko": "헤더 섹션은 JWT 알고리즘 정보와 토큰 유형을 표시합니다"
      },
      "instruction3": {
        "zh-TW": "Payload 區域包含 JWT 的聲明信息，如發行者、主題、過期時間等",
        "zh-CN": "Payload 区域包含 JWT 的声明信息，如发行者、主题、过期时间等",
        "en": "The Payload section contains JWT claim information such as issuer, subject, expiration time, etc.",
        "hi": "पेलोड सेक्शन में JWT क्लेम जानकारी होती है जैसे जारीकर्ता, विषय, समाप्ति समय आदि",
        "ja": "Payloadセクションには、発行者、件名、有効期限などのJWTクレーム情報が含まれています",
        "ko": "페이로드 섹션은 발급자, 주제, 만료 시간 등의 JWT 클레임 정보를 포함합니다"
      },
      "instruction4": {
        "zh-TW": "Signature 區域用於驗證 JWT 的完整性，可輸入密鑰進行簽名驗證",
        "zh-CN": "Signature 区域用于验证 JWT 的完整性，可输入密钥进行签名验证",
        "en": "The Signature section is used to verify JWT integrity, you can input a secret key for signature verification",
        "hi": "सिग्नेचर सेक्शन JWT की अखंडता को सत्यापित करने के लिए उपयोग किया जाता है, आप सिग्नेचर सत्यापन के लिए गुप्त कुंजी इनपुट कर सकते हैं",
        "ja": "Signatureセクションは JWT の整合性を検証するために使用され、署名検証のためにシークレットキーを入力できます",
        "ko": "서명 섹션은 JWT 무결성을 검증하는 데 사용되며, 서명 검증을 위해 비밀 키를 입력할 수 있습니다"
      },
      "signatureInvalid": {
        "zh-TW": "簽名無效",
        "zh-CN": "签名无效",
        "en": "Signature Invalid",
        "hi": "अमान्य हस्ताक्षर",
        "ja": "署名が無効",
        "ko": "서명이 유효하지 않습니다"
      },
      "signatureValid": {
        "zh-TW": "簽名有效",
        "zh-CN": "签名有效",
        "en": "Signature Valid",
        "hi": "मान्य हस्ताक्षर",
        "ja": "署名が有効",
        "ko": "서명이 유효합니다"
      },
      "statusExpired": {
        "zh-TW": "JWT 已過期",
        "zh-CN": "JWT 已过期",
        "en": "JWT Expired",
        "hi": "JWT समाप्त हो गया",
        "ja": "JWT の有効期限が切れています",
        "ko": "JWT가 만료되었습니다"
      },
      "statusInvalid": {
        "zh-TW": "JWT 格式無效",
        "zh-CN": "JWT 格式无效",
        "en": "Invalid JWT Format",
        "hi": "अमान्य JWT प्रारूप",
        "ja": "JWT フォーマットが無効",
        "ko": "JWT 형식이 유효하지 않습니다"
      },
      "statusNotYetValid": {
        "zh-TW": "JWT 尚未生效",
        "zh-CN": "JWT 尚未生效",
        "en": "JWT Not Yet Valid",
        "hi": "JWT अभी तक मान्य नहीं",
        "ja": "JWT はまだ有効ではありません",
        "ko": "JWT가 아직 유효하지 않습니다"
      },
      "statusValid": {
        "zh-TW": "JWT 有效",
        "zh-CN": "JWT 有效",
        "en": "JWT Valid",
        "hi": "JWT मान्य",
        "ja": "JWT が有効",
        "ko": "JWT가 유효합니다"
      },
      "title": {
        "zh-TW": "JWT 解析工具",
        "zh-CN": "JWT 解析工具",
        "en": "JWT Decoder Tool",
        "hi": "JWT डिकोडर टूल",
        "ja": "JWTデコーダー",
        "ko": "JWT 디코더 도구"
      },
      "usageInstructions": {
        "zh-TW": "使用說明",
        "zh-CN": "使用说明",
        "en": "Usage Instructions",
        "hi": "उपयोग निर्देश",
        "ja": "使用方法",
        "ko": "사용 방법"
      },
      "verifySignature": {
        "zh-TW": "驗證簽名",
        "zh-CN": "验证签名",
        "en": "Verify Signature",
        "hi": "हस्ताक्षर सत्यापित करें",
        "ja": "署名を検証",
        "ko": "서명 검증"
      }
    },
    "qrGenerator": {
      "description": {
        "zh-TW": "生成各種內容的 QR 碼，支援自定義樣式和下載",
        "zh-CN": "生成各种內容的 QR 码，支持自定义样式和下载",
        "en": "Generate QR codes for various content with custom styles and download support",
        "hi": "कस्टम स्टाइल के साथ QR कोड जेनरेट करें, विभिन्न प्रकार और आकार का समर्थन",
        "ja": "各種コンテンツのQRコードを生成、カスタムスタイルとダウンロードをサポート",
        "ko": "커스텀 스타일로 QR 코드를 생성하며, 다양한 타입과 크기를 지원합니다"
      },
      "downloadQR": {
        "zh-TW": "下載 QR 碼",
        "zh-CN": "下载 QR 码",
        "en": "Download QR Code",
        "hi": "QR कोड डाउनलोड करें",
        "ja": "QRコードをダウンロード",
        "ko": "QR 코드 다운로드"
      },
      "title": {
        "zh-TW": "QR 碼生成器",
        "zh-CN": "QR 码生成器",
        "en": "QR Code Generator",
        "hi": "QR कोड जेनरेटर",
        "ja": "QRコードジェネレーター",
        "ko": "QR 코드 생성기"
      }
    },
    "svgViewer": {
      "title": {
        "zh-TW": "SVG 圖片預覽器與格式轉換工具",
        "zh-CN": "SVG 图片预览器与格式转换工具",
        "en": "SVG Image Viewer & Converter",
        "hi": "SVG इमेज व्यूअर और कन्वर्टर",
        "ja": "SVGイメージビューアー＆コンバーター",
        "ko": "SVG 이미지 뷰어 및 컨버터"
      },
      "description": {
        "zh-TW": "預覽 SVG 向量圖形，轉換為 PNG、JPEG、WebP、PDF 格式",
        "zh-CN": "预览 SVG 矢量图形，转换为 PNG、JPEG、WebP、PDF 格式",
        "en": "Preview SVG vector graphics, convert to PNG, JPEG, WebP, PDF formats",
        "hi": "SVG और XML ग्राफिक्स का पूर्वावलोकन करें, PNG, JPEG, WebP, PDF फॉर्मेट में कन्वर्ट करें",
        "ja": "SVGベクターグラフィックをプレビューし、PNG、JPEG、WebP、PDFフォーマットに変換",
        "ko": "SVG 벡터 그래픽을 미리보고 PNG, JPEG, WebP, PDF 형식으로 변환"
      },
      "upload": {
        "zh-TW": "上傳 SVG 檔案",
        "zh-CN": "上传 SVG 文件",
        "en": "Upload SVG Files",
        "hi": "SVG फ़ाइलें अपलोड करें",
        "ja": "SVGファイルアップロード",
        "ko": "SVG 파일 업로드"
      },
      "dragDrop": {
        "zh-TW": "將 SVG 檔案拖放到此處或點擊選擇",
        "zh-CN": "将 SVG 文件拖放到此处或点击选择",
        "en": "Drag & drop SVG files here or click to select",
        "hi": "SVG फ़ाइलों को यहाँ ड्रैग और ड्रॉप करें या चुनने के लिए क्लिक करें",
        "ja": "SVGファイルをここにドラッグ&ドロップまたはクリックして選択",
        "ko": "SVG 파일을 여기에 끌어다 놓거나 클릭하여 선택"
      },
      "supportedFormats": {
        "zh-TW": "支援格式：.svg 檔案",
        "zh-CN": "支持格式：.svg 文件",
        "en": "Supported formats: .svg files",
        "hi": "समर्थित फॉर्मेट: .svg फ़ाइलें",
        "ja": "対応フォーマット: .svgファイル",
        "ko": "지원 형식: .svg 파일"
      },
      "selectFiles": {
        "zh-TW": "選擇檔案",
        "zh-CN": "选择文件",
        "en": "Select Files",
        "hi": "फ़ाइलें चुनें",
        "ja": "ファイル選択",
        "ko": "파일 선택"
      },
      "inputArea": {
        "zh-TW": "輸入區域",
        "zh-CN": "输入区域",
        "en": "Input Area",
        "hi": "इनपुट क्षेत्र",
        "ja": "入力エリア",
        "ko": "입력 영역"
      },
      "fileMode": {
        "zh-TW": "檔案上傳",
        "zh-CN": "文件上传",
        "en": "File Upload",
        "hi": "फ़ाइल अपलोड",
        "ja": "ファイルアップロード",
        "ko": "파일 업로드"
      },
      "pasteMode": {
        "zh-TW": "貼上內容",
        "zh-CN": "粘贴内容",
        "en": "Paste Content",
        "hi": "सामग्री पेस्ट करें",
        "ja": "コンテンツ貼り付け",
        "ko": "콘텐츠 붙여넣기"
      },
      "dragDropFiles": {
        "zh-TW": "拖放檔案到此處或點擊選擇",
        "zh-CN": "拖放文件到此处或点击选择",
        "en": "Drag & drop files here or click to select",
        "hi": "फ़ाइलों को यहाँ ड्रैग और ड्रॉप करें या चुनने के लिए क्लिक करें",
        "ja": "ファイルをここにドラッグ&ドロップまたはクリックして選択",
        "ko": "파일을 여기에 끌어다 놓거나 클릭하여 선택"
      },
      "pasteHint": {
        "zh-TW": "支援 SVG 格式的內容",
        "zh-CN": "支持 SVG 格式的内容",
        "en": "Supports SVG format content",
        "hi": "SVG प्रारूप की सामग्री का समर्थन करता है",
        "ja": "SVG形式のコンテンツをサポート",
        "ko": "SVG 형식 콘텐츠 지원"
      },
      "processContent": {
        "zh-TW": "處理內容",
        "zh-CN": "处理内容",
        "en": "Process Content",
        "hi": "सामग्री प्रोसेस करें",
        "ja": "コンテンツ処理",
        "ko": "콘텐츠 처리"
      },
      "filesSelected": {
        "zh-TW": "已選擇 {count} 個檔案",
        "zh-CN": "已选择 {count} 个文件",
        "en": "Selected {count} file(s)",
        "hi": "{count} फ़ाइल चुनी गई",
        "ja": "{count}個のファイルが選択されました",
        "ko": "{count}개 파일이 선택되었습니다"
      },
      "settings": {
        "zh-TW": "轉換設定",
        "zh-CN": "转换设置",
        "en": "Conversion Settings",
        "hi": "कन्वर्जन सेटिंग्स",
        "ja": "変換設定",
        "ko": "변환 설정"
      },
      "outputFormat": {
        "zh-TW": "輸出格式",
        "zh-CN": "输出格式",
        "en": "Output Format",
        "hi": "आउटपुट फॉर्मेट",
        "ja": "出力フォーマット",
        "ko": "출력 형식"
      },
      "outputSize": {
        "zh-TW": "輸出尺寸",
        "zh-CN": "输出尺寸",
        "en": "Output Size",
        "hi": "आउटपुट साइज़",
        "ja": "出力サイズ",
        "ko": "출력 크기"
      },
      "originalSize": {
        "zh-TW": "原始尺寸",
        "zh-CN": "原始尺寸",
        "en": "Original Size",
        "hi": "मूल साइज़",
        "ja": "元のサイズ",
        "ko": "원본 크기"
      },
      "customSize": {
        "zh-TW": "自訂尺寸",
        "zh-CN": "自定义尺寸",
        "en": "Custom Size",
        "hi": "कस्टम साइज़",
        "ja": "カスタムサイズ",
        "ko": "사용자 정의 크기"
      },
      "customDimensions": {
        "zh-TW": "自訂寬高",
        "zh-CN": "自定义宽高",
        "en": "Custom Dimensions",
        "hi": "कस्टम आयाम",
        "ja": "カスタム寸法",
        "ko": "사용자 정의 치수"
      },
      "quality": {
        "zh-TW": "品質",
        "zh-CN": "质量",
        "en": "Quality",
        "hi": "गुणवत्ता",
        "ja": "品質",
        "ko": "품질"
      },
      "convert": {
        "zh-TW": "轉換",
        "zh-CN": "转换",
        "en": "Convert",
        "hi": "कन्वर्ट करें",
        "ja": "変換",
        "ko": "변환"
      },
      "convertAll": {
        "zh-TW": "全部轉換",
        "zh-CN": "全部转换",
        "en": "Convert All",
        "hi": "सभी कन्वर्ट करें",
        "ja": "すべて変換",
        "ko": "모두 변환"
      },
      "downloadAllAsZip": {
        "zh-TW": "下載全部為 ZIP",
        "zh-CN": "下载全部为 ZIP",
        "en": "Download All as ZIP",
        "hi": "सभी को ZIP के रूप में डाउनलोड करें",
        "ja": "すべてZIPでダウンロード",
        "ko": "모두 ZIP으로 다운로드"
      },
      "preview": {
        "zh-TW": "預覽與結果",
        "zh-CN": "预览与结果",
        "en": "Preview & Results",
        "hi": "पूर्वावलोकन और परिणाम",
        "ja": "プレビュー＆結果",
        "ko": "미리보기 및 결과"
      },
      "converted": {
        "zh-TW": "轉換完成",
        "zh-CN": "转换完成",
        "en": "Converted",
        "hi": "कन्वर्ट हो गया",
        "ja": "変換完了",
        "ko": "변환 완료"
      },
      "processing": {
        "zh-TW": "處理中...",
        "zh-CN": "处理中...",
        "en": "Processing...",
        "hi": "प्रसंस्करण...",
        "ja": "処理中...",
        "ko": "처리 중..."
      },
      "invalidSvg": {
        "zh-TW": "無效的 SVG",
        "zh-CN": "无效的 SVG",
        "en": "Invalid SVG",
        "hi": "अमान्य SVG",
        "ja": "無効なSVG",
        "ko": "유효하지 않은 SVG"
      },
      "pasteArea": {
        "zh-TW": "貼上 SVG 內容",
        "zh-CN": "粘贴 SVG 内容",
        "en": "Paste SVG Content",
        "hi": "SVG सामग्री पेस्ट करें",
        "ja": "SVGコンテンツを貼り付け",
        "ko": "SVG 콘텐츠 붙여넣기"
      },
      "pasteInstructions": {
        "zh-TW": "在此處貼上 SVG 代碼或 XML 內容",
        "zh-CN": "在此处粘贴 SVG 代码或 XML 内容",
        "en": "Paste SVG code or XML content here",
        "hi": "यहाँ SVG कोड या XML सामग्री पेस्ट करें",
        "ja": "SVGコードまたはXMLコンテンツをここに貼り付け",
        "ko": "SVG 코드 또는 XML 내용을 여기에 붙여넣기"
      },
      "processPastedContent": {
        "zh-TW": "處理貼上的內容",
        "zh-CN": "处理粘贴的内容",
        "en": "Process Pasted Content",
        "hi": "पेस्ट की गई सामग्री प्रोसेस करें",
        "ja": "貼り付けたコンテンツを処理",
        "ko": "붙여넣은 내용 처리"
      }
    },
    "networkPing": {
      "title": {
        "zh-TW": "網路 Ping 工具",
        "zh-CN": "网络 Ping 工具",
        "en": "Network Ping Tool",
        "hi": "नेटवर्क पिंग टूल",
        "ja": "ネットワークPingツール",
        "ko": "네트워크 핑 도구"
      },
      "description": {
        "zh-TW": "檢測網路連通性，測量延遲和封包丟失率",
        "zh-CN": "检测网络连通性，测量延迟和数据包丢失率",
        "en": "Test network connectivity, measure latency and packet loss",
        "hi": "नेटवर्क कनेक्टिविटी का परीक्षण करें, विलंबता और पैकेट लॉस को मापें",
        "ja": "ネットワーク接続をテストし、遅延とパケットロスを測定",
        "ko": "네트워크 연결성을 테스트하고 지연 시간과 패킷 손실을 측정합니다"
      },
      "singlePing": {
        "zh-TW": "單主機 Ping 測試",
        "zh-CN": "单主机 Ping 测试",
        "en": "Single Host Ping Test",
        "hi": "एकल होस्ट पिंग टेस्ट",
        "ja": "単一ホストPingテスト",
        "ko": "단일 호스트 핑 테스트"
      },
      "hostPlaceholder": {
        "zh-TW": "輸入域名或IP地址，例如：google.com 或 8.8.8.8",
        "zh-CN": "输入域名或IP地址，例如：google.com 或 8.8.8.8",
        "en": "Enter domain or IP address, e.g.: google.com or 8.8.8.8",
        "hi": "डोमेन या IP पता दर्ज करें, जैसे: google.com या 8.8.8.8",
        "ja": "ドメインまたはIPアドレスを入力、例：google.com または 8.8.8.8",
        "ko": "도메인 또는 IP 주소를 입력하세요. 예: google.com 또는 8.8.8.8"
      },
      "packetCount": {
        "zh-TW": "封包數量",
        "zh-CN": "数据包数量",
        "en": "Packet Count",
        "hi": "पैकेट संख्या",
        "ja": "パケット数",
        "ko": "패킷 수"
      },
      "timeout": {
        "zh-TW": "超時時間",
        "zh-CN": "超时时间",
        "en": "Timeout",
        "hi": "टाइमआउट",
        "ja": "タイムアウト",
        "ko": "타임아웃"
      },
      "interval": {
        "zh-TW": "間隔時間",
        "zh-CN": "间隔时间",
        "en": "Interval",
        "hi": "अंतराल",
        "ja": "間隔",
        "ko": "간격"
      },
      "startPing": {
        "zh-TW": "開始 Ping",
        "zh-CN": "开始 Ping",
        "en": "Start Ping",
        "hi": "पिंग शुरू करें",
        "ja": "Ping開始",
        "ko": "핑 시작"
      },
      "results": {
        "zh-TW": "測試結果",
        "zh-CN": "测试结果",
        "en": "Test Results",
        "hi": "परीक्षण परिणाम",
        "ja": "テスト結果",
        "ko": "테스트 결과"
      },
      "transmitted": {
        "zh-TW": "已傳送",
        "zh-CN": "已传送",
        "en": "Transmitted",
        "hi": "भेजा गया",
        "ja": "送信",
        "ko": "전송됨"
      },
      "received": {
        "zh-TW": "已接收",
        "zh-CN": "已接收",
        "en": "Received",
        "hi": "प्राप्त",
        "ja": "受信",
        "ko": "수신됨"
      },
      "lost": {
        "zh-TW": "丟失",
        "zh-CN": "丢失",
        "en": "Lost",
        "hi": "खो गया",
        "ja": "損失",
        "ko": "손실"
      },
      "avgTime": {
        "zh-TW": "平均時間",
        "zh-CN": "平均时间",
        "en": "Avg Time",
        "hi": "औसत समय",
        "ja": "平均時間",
        "ko": "평균 시간"
      },
      "host": {
        "zh-TW": "主機",
        "zh-CN": "主机",
        "en": "Host",
        "hi": "होस्ट",
        "ja": "ホスト",
        "ko": "호스트"
      },
      "sequence": {
        "zh-TW": "序號",
        "zh-CN": "序号",
        "en": "Sequence",
        "hi": "अनुक्रम",
        "ja": "シーケンス",
        "ko": "시퀀스"
      },
      "time": {
        "zh-TW": "時間",
        "zh-CN": "时间",
        "en": "Time",
        "hi": "समय",
        "ja": "時間",
        "ko": "시간"
      },
      "status": {
        "zh-TW": "狀態",
        "zh-CN": "状态",
        "en": "Status",
        "hi": "स्थिति",
        "ja": "ステータス",
        "ko": "상태"
      },
      "exportCsv": {
        "zh-TW": "匯出 CSV",
        "zh-CN": "导出 CSV",
        "en": "Export CSV",
        "hi": "CSV निर्यात करें",
        "ja": "CSV出力",
        "ko": "CSV 내보내기"
      },
      "about": {
        "zh-TW": "關於此工具",
        "zh-CN": "关于此工具",
        "en": "About This Tool",
        "hi": "इस टूल के बारे में",
        "ja": "このツールについて",
        "ko": "이 도구에 대해"
      },
      "aboutDescription": {
        "zh-TW": "網路 Ping 工具可以幫助您快速檢測網路連通性和品質。",
        "zh-CN": "网络 Ping 工具可以帮助您快速检测网络连通性和质量。",
        "en": "Network Ping tool helps you quickly test network connectivity and quality.",
        "hi": "नेटवर्क पिंग टूल आपको नेटवर्क कनेक्टिविटी और गुणवत्ता का त्वरित परीक्षण करने में मदद करता है।",
        "ja": "ネットワークPingツールは、ネットワーク接続と品質を迅速にテストするのに役立ちます。",
        "ko": "네트워크 핑 도구는 네트워크 연결성과 품질을 빠르게 테스트하는 데 도움이 됩니다."
      },
      "feature1": {
        "zh-TW": "實時網路延遲測試",
        "zh-CN": "实时网络延迟测试",
        "en": "Real-time latency testing",
        "hi": "वास्तविक समय विलंबता परीक्षण",
        "ja": "リアルタイム遅延テスト",
        "ko": "실시간 지연 시간 테스트"
      },
      "feature2": {
        "zh-TW": "封包丟失率統計",
        "zh-CN": "数据包丢失率统计",
        "en": "Packet loss statistics",
        "hi": "पैकेट लॉस आंकड़े",
        "ja": "パケットロス統計",
        "ko": "패킷 손실 통계"
      },
      "feature3": {
        "zh-TW": "多主機批量測試",
        "zh-CN": "多主机批量测试",
        "en": "Multi-host batch testing",
        "hi": "मल्टी-होस्ट बैच परीक्षण",
        "ja": "マルチホストバッチテスト",
        "ko": "멀티 호스트 배치 테스트"
      },
      "feature4": {
        "zh-TW": "結果匯出和分析",
        "zh-CN": "结果导出和分析",
        "en": "Result export and analysis",
        "hi": "परिणाम निर्यात और विश्लेषण",
        "ja": "結果の出力と分析",
        "ko": "결과 내보내기 및 분석"
      },
      "commonHosts": {
        "zh-TW": "常用主機",
        "zh-CN": "常用主机",
        "en": "Common Hosts",
        "hi": "सामान्य होस्ट",
        "ja": "一般的なホスト",
        "ko": "일반적인 호스트"
      }
    },
    "dnsLookup": {
      "title": {
        "zh-TW": "DNS 查詢工具",
        "zh-CN": "DNS 查询工具",
        "en": "DNS Lookup Tool",
        "hi": "DNS लुकअप टूल",
        "ja": "DNS検索ツール",
        "ko": "DNS 조회 도구"
      },
      "description": {
        "zh-TW": "查詢域名的 DNS 記錄，包括 A、AAAA、MX、TXT、CNAME 等記錄類型",
        "zh-CN": "查询域名的 DNS 记录，包括 A、AAAA、MX、TXT、CNAME 等记录类型",
        "en": "Lookup DNS records for domains, including A, AAAA, MX, TXT, CNAME and other record types",
        "hi": "डोमेन के लिए DNS रिकॉर्ड देखें, A, AAAA, MX, TXT, CNAME और अन्य रिकॉर्ड प्रकार शामिल हैं",
        "ja": "ドメインのDNSレコードを検索、A、AAAA、MX、TXT、CNAMEなどのレコードタイプを含む",
        "ko": "도메인의 DNS 레코드를 조회하며, A, AAAA, MX, TXT, CNAME 등 레코드 유형을 포함합니다"
      },
      "domainPlaceholder": {
        "zh-TW": "輸入域名，例如：google.com",
        "zh-CN": "输入域名，例如：google.com",
        "en": "Enter domain, e.g.: google.com",
        "hi": "डोमेन दर्ज करें, जैसे: google.com",
        "ja": "ドメインを入力、例：google.com",
        "ko": "도메인을 입력하세요. 예: google.com"
      },
      "recordType": {
        "zh-TW": "記錄類型",
        "zh-CN": "记录类型",
        "en": "Record Type",
        "hi": "रिकॉर्ड प्रकार",
        "ja": "レコードタイプ",
        "ko": "레코드 유형"
      },
      "startLookup": {
        "zh-TW": "開始查詢",
        "zh-CN": "开始查询",
        "en": "Start Lookup",
        "hi": "लुकअप शुरू करें",
        "ja": "検索開始",
        "ko": "조회 시작"
      },
      "results": {
        "zh-TW": "查詢結果",
        "zh-CN": "查询结果",
        "en": "Lookup Results",
        "hi": "लुकअप परिणाम",
        "ja": "検索結果",
        "ko": "조회 결과"
      },
      "recordName": {
        "zh-TW": "記錄名稱",
        "zh-CN": "记录名称",
        "en": "Record Name",
        "hi": "रिकॉर्ड नाम",
        "ja": "レコード名",
        "ko": "레코드 이름"
      },
      "recordValue": {
        "zh-TW": "記錄值",
        "zh-CN": "记录值",
        "en": "Record Value",
        "hi": "रिकॉर्ड मान",
        "ja": "レコード値",
        "ko": "레코드 값"
      },
      "ttl": {
        "zh-TW": "TTL",
        "zh-CN": "TTL",
        "en": "TTL",
        "hi": "TTL",
        "ja": "TTL",
        "ko": "TTL"
      },
      "priority": {
        "zh-TW": "優先級",
        "zh-CN": "优先级",
        "en": "Priority",
        "hi": "प्राथमिकता",
        "ja": "優先度",
        "ko": "우선순위"
      },
      "noRecords": {
        "zh-TW": "未找到記錄",
        "zh-CN": "未找到记录",
        "en": "No records found",
        "hi": "कोई रिकॉर्ड नहीं मिला",
        "ja": "レコードが見つかりません",
        "ko": "레코드를 찾을 수 없습니다"
      },
      "error": {
        "zh-TW": "查詢錯誤",
        "zh-CN": "查询错误",
        "en": "Lookup Error",
        "hi": "लुकअप त्रुटि",
        "ja": "検索エラー",
        "ko": "조회 오류"
      },
      "about": {
        "zh-TW": "關於此工具",
        "zh-CN": "关于此工具",
        "en": "About This Tool",
        "hi": "इस टूल के बारे में",
        "ja": "このツールについて",
        "ko": "이 도구에 대해"
      },
      "aboutDescription": {
        "zh-TW": "DNS 查詢工具可以幫助您快速獲取域名的各種 DNS 記錄信息。",
        "zh-CN": "DNS 查询工具可以帮助您快速获取域名的各种 DNS 记录信息。",
        "en": "DNS Lookup tool helps you quickly retrieve various DNS record information for domains.",
        "hi": "DNS लुकअप टूल आपको डोमेन के लिए विभिन्न DNS रिकॉर्ड जानकारी त्वरित रूप से प्राप्त करने में मदद करता है।",
        "ja": "DNS検索ツールは、ドメインの様々なDNSレコード情報を迅速に取得するのに役立ちます。",
        "ko": "DNS 조회 도구는 도메인의 다양한 DNS 레코드 정보를 빠르게 검색하는 데 도움이 됩니다."
      },
      "feature1": {
        "zh-TW": "多種記錄類型支援",
        "zh-CN": "多种记录类型支持",
        "en": "Multiple record type support",
        "hi": "कई रिकॉर्ड प्रकार समर्थन",
        "ja": "複数のレコードタイプサポート",
        "ko": "다양한 레코드 유형 지원"
      },
      "feature2": {
        "zh-TW": "快速查詢結果",
        "zh-CN": "快速查询结果",
        "en": "Fast lookup results",
        "hi": "तेज़ लुकअप परिणाम",
        "ja": "高速検索結果",
        "ko": "빠른 조회 결과"
      },
      "feature3": {
        "zh-TW": "詳細記錄信息",
        "zh-CN": "详细记录信息",
        "en": "Detailed record information",
        "hi": "विस्तृत रिकॉर्ड जानकारी",
        "ja": "詳細なレコード情報",
        "ko": "상세한 레코드 정보"
      },
      "feature4": {
        "zh-TW": "易於使用的介面",
        "zh-CN": "易于使用的界面",
        "en": "User-friendly interface",
        "hi": "उपयोगकर्ता-अनुकूल इंटरफेस",
        "ja": "使いやすいインターフェース",
        "ko": "사용자 친화적인 인터페이스"
      }
    },
    "sslChecker": {
      "title": {
        "zh-TW": "SSL 憑證檢查工具",
        "zh-CN": "SSL 证书检查工具",
        "en": "SSL Certificate Checker",
        "hi": "SSL प्रमाणपत्र जांचकर्ता",
        "ja": "SSL証明書チェッカー",
        "ko": "SSL 인증서 검사기"
      },
      "description": {
        "zh-TW": "檢查網站的 SSL/TLS 憑證狀態，包括有效期、簽發機構、加密強度等詳細資訊",
        "zh-CN": "检查网站的 SSL/TLS 证书状态，包括有效期、签发机构、加密强度等详细信息",
        "en": "Check SSL/TLS certificate status for websites, including validity period, issuer, encryption strength and detailed information",
        "hi": "वेबसाइटों के लिए SSL/TLS प्रमाणपत्र स्थिति की जांच करें, जिसमें वैधता अवधि, जारीकर्ता, एन्क्रिप्शन शक्ति और विस्तृत जानकारी शामिल है",
        "ja": "ウェブサイトのSSL/TLS証明書の状態をチェックし、有効期限、発行者、暗号化強度などの詳細情報を確認",
        "ko": "웹사이트의 SSL/TLS 인증서 상태를 확인하여 유효 기간, 발급자, 암호화 강도 등의 세부 정보를 제공합니다"
      },
      "hostPlaceholder": {
        "zh-TW": "輸入主機名，例如：google.com",
        "zh-CN": "输入主机名，例如：google.com",
        "en": "Enter hostname, e.g.: google.com",
        "hi": "होस्टनाम दर्ज करें, जैसे: google.com",
        "ja": "ホスト名を入力、例：google.com",
        "ko": "호스트명을 입력하세요. 예: google.com"
      },
      "portLabel": {
        "zh-TW": "連接埠",
        "zh-CN": "端口",
        "en": "Port",
        "hi": "पोर्ट",
        "ja": "ポート",
        "ko": "포트"
      },
      "checkCertificate": {
        "zh-TW": "檢查憑證",
        "zh-CN": "检查证书",
        "en": "Check Certificate",
        "hi": "प्रमाणपत्र जांचें",
        "ja": "証明書チェック",
        "ko": "인증서 검사"
      },
      "certificateDetails": {
        "zh-TW": "憑證詳細資訊",
        "zh-CN": "证书详细信息",
        "en": "Certificate Details",
        "hi": "प्रमाणपत्र विवरण",
        "ja": "証明書詳細",
        "ko": "인증서 세부 정보"
      },
      "issuer": {
        "zh-TW": "簽發機構",
        "zh-CN": "签发机构",
        "en": "Issuer",
        "hi": "जारीकर्ता",
        "ja": "発行者",
        "ko": "발급자"
      },
      "subject": {
        "zh-TW": "主體",
        "zh-CN": "主体",
        "en": "Subject",
        "hi": "विषय",
        "ja": "サブジェクト",
        "ko": "주체"
      },
      "validFrom": {
        "zh-TW": "有效期從",
        "zh-CN": "有效期从",
        "en": "Valid From",
        "hi": "से वैध",
        "ja": "有効期限開始",
        "ko": "유효 시작일"
      },
      "validTo": {
        "zh-TW": "有效期至",
        "zh-CN": "有效期至",
        "en": "Valid To",
        "hi": "तक वैध",
        "ja": "有効期限終了",
        "ko": "유효 만료일"
      },
      "serialNumber": {
        "zh-TW": "序列號",
        "zh-CN": "序列号",
        "en": "Serial Number",
        "hi": "सीरियल नंबर",
        "ja": "シリアル番号",
        "ko": "일련번호"
      },
      "signatureAlgorithm": {
        "zh-TW": "簽名演算法",
        "zh-CN": "签名算法",
        "en": "Signature Algorithm",
        "hi": "हस्ताक्षर एल्गोरिदम",
        "ja": "署名アルゴリズム",
        "ko": "서명 알고리즘"
      },
      "daysRemaining": {
        "zh-TW": "剩餘天數",
        "zh-CN": "剩余天数",
        "en": "Days Remaining",
        "hi": "शेष दिन",
        "ja": "残り日数",
        "ko": "남은 일수"
      },
      "certificateStatus": {
        "zh-TW": "憑證狀態",
        "zh-CN": "证书状态",
        "en": "Certificate Status",
        "hi": "प्रमाणपत्र स्थिति",
        "ja": "証明書ステータス",
        "ko": "인증서 상태"
      },
      "valid": {
        "zh-TW": "有效",
        "zh-CN": "有效",
        "en": "Valid",
        "hi": "वैध",
        "ja": "有効",
        "ko": "유효"
      },
      "expired": {
        "zh-TW": "已過期",
        "zh-CN": "已过期",
        "en": "Expired",
        "hi": "समाप्त हो गया",
        "ja": "期限切れ",
        "ko": "만료됨"
      },
      "expiringSoon": {
        "zh-TW": "即將過期",
        "zh-CN": "即将过期",
        "en": "Expiring Soon",
        "hi": "जल्द ही समाप्त हो रहा है",
        "ja": "間もなく期限切れ",
        "ko": "곧 만료됨"
      },
      "error": {
        "zh-TW": "檢查錯誤",
        "zh-CN": "检查错误",
        "en": "Check Error",
        "hi": "जांच त्रुटि",
        "ja": "チェックエラー",
        "ko": "검사 오류"
      },
      "about": {
        "zh-TW": "關於此工具",
        "zh-CN": "关于此工具",
        "en": "About This Tool",
        "hi": "इस टूल के बारे में",
        "ja": "このツールについて",
        "ko": "이 도구에 대해"
      },
      "aboutDescription": {
        "zh-TW": "SSL 憑證檢查工具可以幫助您驗證網站的安全憑證狀態，確保連接安全。",
        "zh-CN": "SSL 证书检查工具可以帮助您验证网站的安全证书状态，确保连接安全。",
        "en": "SSL Certificate Checker helps you verify website security certificate status and ensure secure connections.",
        "hi": "SSL प्रमाणपत्र जांचकर्ता आपको वेबसाइट सुरक्षा प्रमाणपत्र स्थिति सत्यापित करने और सुरक्षित कनेक्शन सुनिश्चित करने में मदद करता है।",
        "ja": "SSL証明書チェッカーは、ウェブサイトのセキュリティ証明書の状態を確認し、安全な接続を保証するのに役立ちます。",
        "ko": "SSL 인증서 검사기는 웹사이트의 보안 인증서 상태를 확인하고 안전한 연결을 보장하는 데 도움이 됩니다."
      },
      "feature1": {
        "zh-TW": "詳細憑證資訊",
        "zh-CN": "详细证书信息",
        "en": "Detailed certificate information",
        "hi": "विस्तृत प्रमाणपत्र जानकारी",
        "ja": "詳細な証明書情報",
        "ko": "상세한 인증서 정보"
      },
      "feature2": {
        "zh-TW": "有效期監控",
        "zh-CN": "有效期监控",
        "en": "Validity period monitoring",
        "hi": "वैधता अवधि निगरानी",
        "ja": "有効期限監視",
        "ko": "유효 기간 모니터링"
      },
      "feature3": {
        "zh-TW": "安全狀態評估",
        "zh-CN": "安全状态评估",
        "en": "Security status assessment",
        "hi": "सुरक्षा स्थिति मूल्यांकन",
        "ja": "セキュリティ状態評価",
        "ko": "보안 상태 평가"
      },
      "feature4": {
        "zh-TW": "即時檢查結果",
        "zh-CN": "即时检查结果",
        "en": "Real-time check results",
        "hi": "वास्तविक समय जांच परिणाम",
        "ja": "リアルタイムチェック結果",
        "ko": "실시간 검사 결과"
      }
    },
    "networkMonitor": {
      "title": {
        "zh-TW": "網路監控工具",
        "zh-CN": "网络监控工具",
        "en": "Network Monitor Tool",
        "hi": "नेटवर्क मॉनिटर टूल",
        "ja": "ネットワークモニターツール",
        "ko": "네트워크 모니터 도구"
      },
      "description": {
        "zh-TW": "監控網路性能、正常運行時間和連接品質",
        "zh-CN": "监控网络性能、正常运行时间和连接质量",
        "en": "Monitor network performance, uptime and connection quality",
        "hi": "नेटवर्क प्रदर्शन, अपटाइम और कनेक्शन गुणवत्ता की निगरानी करें",
        "ja": "ネットワークパフォーマンス、稼働時間、接続品質を監視",
        "ko": "네트워크 성능, 가동 시간 및 연결 품질을 모니터링합니다"
      },
      "monitor": {
        "zh-TW": "開始監控",
        "zh-CN": "开始监控",
        "en": "Start Monitor",
        "hi": "मॉनिटर शुरू करें",
        "ja": "監視開始",
        "ko": "모니터링 시작"
      },
      "stopMonitor": {
        "zh-TW": "停止監控",
        "zh-CN": "停止监控",
        "en": "Stop Monitor",
        "hi": "मॉनिटर रोकें",
        "ja": "監視停止",
        "ko": "모니터링 중지"
      },
      "status": {
        "zh-TW": "狀態",
        "zh-CN": "状态",
        "en": "Status",
        "hi": "स्थिति",
        "ja": "ステータス",
        "ko": "상태"
      },
      "uptime": {
        "zh-TW": "正常運行時間",
        "zh-CN": "正常运行时间",
        "en": "Uptime",
        "hi": "अपटाइम",
        "ja": "稼働時間",
        "ko": "가동 시간"
      },
      "latency": {
        "zh-TW": "延遲",
        "zh-CN": "延迟",
        "en": "Latency",
        "hi": "विलंबता",
        "ja": "遅延",
        "ko": "지연 시간"
      },
      "performance": {
        "zh-TW": "性能",
        "zh-CN": "性能",
        "en": "Performance",
        "hi": "प्रदर्शन",
        "ja": "パフォーマンス",
        "ko": "성능"
      },
      "about": {
        "zh-TW": "關於此工具",
        "zh-CN": "关于此工具",
        "en": "About This Tool",
        "hi": "इस टूल के बारे में",
        "ja": "このツールについて",
        "ko": "이 도구에 대해"
      },
      "aboutDescription": {
        "zh-TW": "網路監控工具可以持續監控網路服務的可用性和性能。",
        "zh-CN": "网络监控工具可以持续监控网络服务的可用性和性能。",
        "en": "Network Monitor tool continuously monitors the availability and performance of network services.",
        "hi": "नेटवर्क मॉनिटर टूल नेटवर्क सेवाओं की उपलब्धता और प्रदर्शन की निरंतर निगरानी करता है।",
        "ja": "ネットワークモニターツールは、ネットワークサービスの可用性とパフォーマンスを継続的に監視します。",
        "ko": "네트워크 모니터 도구는 네트워크 서비스의 가용성과 성능을 지속적으로 모니터링합니다."
      },
      "feature1": {
        "zh-TW": "即時監控網路狀態",
        "zh-CN": "实时监控网络状态",
        "en": "Real-time network status monitoring",
        "hi": "वास्तविक समय नेटवर्क स्थिति निगरानी",
        "ja": "リアルタイムネットワーク状態監視",
        "ko": "실시간 네트워크 상태 모니터링"
      },
      "feature2": {
        "zh-TW": "性能趨勢分析",
        "zh-CN": "性能趋势分析",
        "en": "Performance trend analysis",
        "hi": "प्रदर्शन रुझान विश्लेषण",
        "ja": "パフォーマンストレンド分析",
        "ko": "성능 트렌드 분석"
      },
      "feature3": {
        "zh-TW": "正常運行時間統計",
        "zh-CN": "正常运行时间统计",
        "en": "Uptime statistics",
        "hi": "अपटाइम आंकड़े",
        "ja": "稼働時間統計",
        "ko": "가동 시간 통계"
      },
      "feature4": {
        "zh-TW": "警報和通知",
        "zh-CN": "警报和通知",
        "en": "Alerts and notifications",
        "hi": "अलर्ट और सूचनाएं",
        "ja": "アラートと通知",
        "ko": "알림 및 통지"
      }
    },
    "title": {
      "zh-TW": "開發工具",
      "zh-CN": "开发工具",
      "en": "Development Tools",
      "hi": "विकास उपकरण",
      "ja": "開発ツール",
      "ko": "개발 도구"
    },
    "urlEncoder": {
      "decode": {
        "zh-TW": "解碼",
        "zh-CN": "解码",
        "en": "Decode",
        "hi": "डिकोड करें",
        "ja": "デコード",
        "ko": "디코딩"
      },
      "description": {
        "zh-TW": "編碼和解碼 URL 字符串，處理特殊字符",
        "zh-CN": "编码和解码 URL 字符串，处理特殊字符",
        "en": "Encode and decode URL strings, handle special characters",
        "hi": "URL स्ट्रिंग्स को एन्कोड और डिकोड करें, विशेष वर्णों को संभालें",
        "ja": "URL文字列のエンコードとデコード、特殊文字を処理",
        "ko": "URL 문자열을 인코딩 및 디코딩하고, 특수 문자를 처리합니다"
      },
      "encode": {
        "zh-TW": "編碼",
        "zh-CN": "编码",
        "en": "Encode",
        "hi": "एन्कोड करें",
        "ja": "エンコード",
        "ko": "인코딩"
      },
      "title": {
        "zh-TW": "URL 編碼工具",
        "zh-CN": "URL 编码工具",
        "en": "URL Encoder Tool",
        "hi": "URL एन्कोडर टूल",
        "ja": "URLエンコーダー",
        "ko": "URL 인코더 도구"
      },
      "originalText": {
        "zh-TW": "原始文字",
        "zh-CN": "原始文字",
        "en": "Original Text",
        "hi": "मूल पाठ",
        "ja": "元のテキスト",
        "ko": "원본 텍스트"
      },
      "originalPlaceholder": {
        "zh-TW": "輸入需要編碼的 URL 或文字...",
        "zh-CN": "输入需要编码的 URL 或文字...",
        "en": "Enter URL or text to encode...",
        "hi": "एन्कोड करने के लिए URL या टेक्स्ट दर्ज करें...",
        "ja": "エンコードするURLまたはテキストを入力...",
        "ko": "인코딩할 URL 또는 텍스트를 입력하세요..."
      },
      "encodedResult": {
        "zh-TW": "編碼結果",
        "zh-CN": "编码结果",
        "en": "Encoded Result",
        "hi": "एन्कोडेड परिणाम",
        "ja": "エンコード結果",
        "ko": "인코딩 결과"
      },
      "encodedText": {
        "zh-TW": "編碼文字",
        "zh-CN": "编码文字",
        "en": "Encoded Text",
        "hi": "एन्कोडेड टेक्स्ट",
        "ja": "エンコード済みテキスト",
        "ko": "인코딩된 텍스트"
      },
      "encodedPlaceholder": {
        "zh-TW": "貼上需要解碼的 URL 編碼文字...",
        "zh-CN": "粘贴需要解码的 URL 编码文字...",
        "en": "Paste URL encoded text to decode...",
        "hi": "डिकोड करने के लिए URL एन्कोडेड टेक्स्ट पेस्ट करें...",
        "ja": "デコードするURLエンコードされたテキストを貼り付け...",
        "ko": "디코딩할 URL 인코딩된 텍스트를 붙여넣으세요..."
      },
      "decodedResult": {
        "zh-TW": "解碼結果",
        "zh-CN": "解码结果",
        "en": "Decoded Result",
        "hi": "डिकोडेड परिणाम",
        "ja": "デコード結果",
        "ko": "디코딩 결과"
      },
      "commonChars": {
        "zh-TW": "常用字符對照表",
        "zh-CN": "常用字符对照表",
        "en": "Common Characters Reference",
        "hi": "सामान्य वर्ण संदर्भ",
        "ja": "一般的な文字対照表",
        "ko": "일반 문자 참조표"
      },
      "usageGuide": {
        "zh-TW": "使用指南",
        "zh-CN": "使用指南",
        "en": "Usage Guide",
        "hi": "उपयोग गाइड",
        "ja": "使用ガイド",
        "ko": "사용 가이드"
      },
      "whenToEncode": {
        "zh-TW": "何時需要編碼",
        "zh-CN": "何时需要编码",
        "en": "When to Encode",
        "hi": "कब एन्कोड करें",
        "ja": "いつエンコードするか",
        "ko": "언제 인코딩해야 하는가"
      },
      "safeChars": {
        "zh-TW": "安全字符",
        "zh-CN": "安全字符",
        "en": "Safe Characters",
        "hi": "सुरक्षित वर्ण",
        "ja": "安全な文字",
        "ko": "안전한 문자"
      },
      "decodeError": {
        "zh-TW": "解碼錯誤：輸入的文字不是有效的 URL 編碼格式",
        "zh-CN": "解码错误：输入的文字不是有效的 URL 编码格式",
        "en": "Decode error: The input text is not valid URL encoded format",
        "hi": "डिकोड त्रुटि: इनपुट टेक्स्ट वैध URL एन्कोडेड प्रारूप नहीं है",
        "ja": "デコードエラー：入力テキストは有効なURLエンコード形式ではありません",
        "ko": "디코딩 오류: 입력 텍스트가 유효한 URL 인코딩 형식이 아닙니다"
      }
    },
    "cryptoTool": {
      "title": {
        "zh-TW": "高級密碼學工具",
        "zh-CN": "高级密码学工具",
        "en": "Advanced Cryptographic Tool",
        "hi": "उन्नत क्रिप्टोग्राफिक टूल",
        "ja": "高度な暗号化ツール",
        "ko": "고급 암호화 도구"
      },
      "description": {
        "zh-TW": "高級密碼學工具，支援 RSA/AES 加解密、數位簽章等功能",
        "zh-CN": "高级密码学工具，支持 RSA/AES 加解密、数字签名等功能",
        "en": "Advanced cryptographic tool supporting RSA/AES encryption/decryption, digital signatures and more",
        "hi": "उन्नत क्रिप्टोग्राफिक टूल जो RSA/AES एन्क्रिप्शन/डिक्रिप्शन, डिजिटल हस्ताक्षर आदि का समर्थन करता है",
        "ja": "RSA/AES暗号化/復号化、デジタル署名などを支援する高度な暗号化ツール",
        "ko": "RSA/AES 암호화/복호화, 디지털 서명 등을 지원하는 고급 암호화 도구"
      },
      "operation": {
        "zh-TW": "選擇操作模式",
        "zh-CN": "选择操作模式",
        "en": "Select Operation Mode",
        "hi": "ऑपरेशन मोड चुनें",
        "ja": "操作モードを選択",
        "ko": "작업 모드 선택"
      },
      "selectOperation": {
        "zh-TW": "請選擇要執行的密碼學操作",
        "zh-CN": "请选择要执行的密码学操作",
        "en": "Please select the cryptographic operation to perform",
        "hi": "कृपया करने के लिए क्रिप्टोग्राफिक ऑपरेशन का चयन करें",
        "ja": "実行する暗号化操作を選択してください",
        "ko": "수행할 암호화 작업을 선택하세요"
      },
      "algorithm": {
        "zh-TW": "演算法選擇",
        "zh-CN": "算法选择",
        "en": "Algorithm Selection",
        "hi": "एल्गोरिदम चयन",
        "ja": "アルゴリズム選択",
        "ko": "알고리즘 선택"
      },
      "recommended": {
        "zh-TW": "推薦",
        "zh-CN": "推荐",
        "en": "Recommended",
        "hi": "अनुशंसित",
        "ja": "推奨",
        "ko": "권장"
      },
      "rsaEncrypt": {
        "zh-TW": "RSA 加密",
        "zh-CN": "RSA 加密",
        "en": "RSA Encrypt",
        "hi": "RSA एन्क्रिप्शन",
        "ja": "RSA暗号化",
        "ko": "RSA 암호화"
      },
      "rsaEncryptDesc": {
        "zh-TW": "使用 RSA 公鑰加密資料",
        "zh-CN": "使用 RSA 公钥加密数据",
        "en": "Encrypt data using RSA public key",
        "hi": "RSA पब्लिक की का उपयोग करके डेटा एन्क्रिप्ट करें",
        "ja": "RSA公開鍵を使用してデータを暗号化",
        "ko": "RSA 공개 키를 사용하여 데이터 암호화"
      },
      "rsaDecrypt": {
        "zh-TW": "RSA 解密",
        "zh-CN": "RSA 解密",
        "en": "RSA Decrypt",
        "hi": "RSA डिक्रिप्शन",
        "ja": "RSA復号化",
        "ko": "RSA 복호화"
      },
      "rsaDecryptDesc": {
        "zh-TW": "使用 RSA 私鑰解密資料",
        "zh-CN": "使用 RSA 私钥解密数据",
        "en": "Decrypt data using RSA private key",
        "hi": "RSA प्राइवेट की का उपयोग करके डेटा डिक्रिप्ट करें",
        "ja": "RSA秘密鍵を使用してデータを復号化",
        "ko": "RSA 개인 키를 사용하여 데이터 복호화"
      },
      "aesEncrypt": {
        "zh-TW": "AES 加密",
        "zh-CN": "AES 加密",
        "en": "AES Encrypt",
        "hi": "AES एन्क्रिप्शन",
        "ja": "AES暗号化",
        "ko": "AES 암호화"
      },
      "aesEncryptDesc": {
        "zh-TW": "使用 AES 對稱密鑰加密資料",
        "zh-CN": "使用 AES 对称密钥加密数据",
        "en": "Encrypt data using AES symmetric key",
        "hi": "AES सिमेट्रिक की का उपयोग करके डेटा एन्क्रिप्ट करें",
        "ja": "AES対称鍵を使用してデータを暗号化",
        "ko": "AES 대칭 키를 사용하여 데이터 암호화"
      },
      "aesDecrypt": {
        "zh-TW": "AES 解密",
        "zh-CN": "AES 解密",
        "en": "AES Decrypt",
        "hi": "AES डिक्रिप्शन",
        "ja": "AES復号化",
        "ko": "AES 복호화"
      },
      "aesDecryptDesc": {
        "zh-TW": "使用 AES 對稱密鑰解密資料",
        "zh-CN": "使用 AES 对称密钥解密数据",
        "en": "Decrypt data using AES symmetric key",
        "hi": "AES सिमेट्रिक की का उपयोग करके डेटा डिक्रिप्ट करें",
        "ja": "AES対称鍵を使用してデータを復号化",
        "ko": "AES 대칭 키를 사용하여 데이터 복호화"
      },
      "digitalSign": {
        "zh-TW": "數位簽章",
        "zh-CN": "数字签名",
        "en": "Digital Sign",
        "hi": "डिजिटल हस्ताक्षर",
        "ja": "デジタル署名",
        "ko": "디지털 서명"
      },
      "digitalSignDesc": {
        "zh-TW": "使用 RSA 私鑰對訊息進行數位簽章",
        "zh-CN": "使用 RSA 私钥对消息进行数字签名",
        "en": "Sign message using RSA private key",
        "hi": "RSA प्राइवेट की का उपयोग करके संदेश पर हस्ताक्षर करें",
        "ja": "RSA秘密鍵を使用してメッセージにデジタル署名",
        "ko": "RSA 개인 키를 사용하여 메시지에 디지털 서명"
      },
      "verifySign": {
        "zh-TW": "驗證簽章",
        "zh-CN": "验证签名",
        "en": "Verify Signature",
        "hi": "हस्ताक्षर सत्यापित करें",
        "ja": "署名の検証",
        "ko": "서명 검증"
      },
      "verifySignDesc": {
        "zh-TW": "使用 RSA 公鑰驗證數位簽章",
        "zh-CN": "使用 RSA 公钥验证数字签名",
        "en": "Verify digital signature using RSA public key",
        "hi": "RSA पब्लिक की का उपयोग करके डिजिटल हस्ताक्षर सत्यापित करें",
        "ja": "RSA公開鍵を使用してデジタル署名を検証",
        "ko": "RSA 공개 키를 사용하여 디지털 서명 검증"
      },
      "rsaOaepDesc": {
        "zh-TW": "RSA-OAEP：最適化非對稱加密填充，提供最佳安全性",
        "zh-CN": "RSA-OAEP：最优非对称加密填充，提供最佳安全性",
        "en": "RSA-OAEP: Optimal Asymmetric Encryption Padding, provides best security",
        "hi": "RSA-OAEP: ऑप्टिमल असिमेट्रिक एन्क्रिप्शन पैडिंग, सबसे अच्छी सुरक्षा प्रदान करता है",
        "ja": "RSA-OAEP：最適非対称暗号化パディング、最高のセキュリティを提供",
        "ko": "RSA-OAEP: 최적 비대칭 암호화 패딩, 최상의 보안 제공"
      },
      "rsaPssDesc": {
        "zh-TW": "RSA-PSS：概率簽章方案，適用於數位簽章",
        "zh-CN": "RSA-PSS：概率签名方案，适用于数字签名",
        "en": "RSA-PSS: Probabilistic Signature Scheme, suitable for digital signatures",
        "hi": "RSA-PSS: प्रोबेबिलिस्टिक सिग्नेचर स्कीम, डिजिटल हस्ताक्षर के लिए उपयुक्त",
        "ja": "RSA-PSS：確率的署名方式、デジタル署名に適用",
        "ko": "RSA-PSS: 확률적 서명 방식, 디지털 서명에 적합"
      },
      "aesGcmDesc": {
        "zh-TW": "AES-GCM：伽羅瓦計數器模式，提供認證加密",
        "zh-CN": "AES-GCM：伽罗瓦计数器模式，提供认证加密",
        "en": "AES-GCM: Galois/Counter Mode, provides authenticated encryption",
        "hi": "AES-GCM: गैलोइस/काउंटर मोड, प्रमाणित एन्क्रिप्शन प्रदान करता है",
        "ja": "AES-GCM：ガロア/カウンターモード、認証付き暗号化を提供",
        "ko": "AES-GCM: 갈루아/카운터 모드, 인증된 암호화 제공"
      },
      "aesCbcDesc": {
        "zh-TW": "AES-CBC：密碼塊鏈模式，傳統對稱加密",
        "zh-CN": "AES-CBC：密码块链模式，传统对称加密",
        "en": "AES-CBC: Cipher Block Chaining mode, traditional symmetric encryption",
        "hi": "AES-CBC: साइफर ब्लॉक चेनिंग मोड, पारंपरिक सिमेट्रिक एन्क्रिप्शन",
        "ja": "AES-CBC：暗号ブロック連鎖モード、従来の対称暗号化",
        "ko": "AES-CBC: 암호 블록 체인 모드, 전통적인 대칭 암호화"
      },
      "rsaKeys": {
        "zh-TW": "RSA 密鑰管理",
        "zh-CN": "RSA 密钥管理",
        "en": "RSA Key Management",
        "hi": "RSA की प्रबंधन",
        "ja": "RSA鍵管理",
        "ko": "RSA 키 관리"
      },
      "generateKeys": {
        "zh-TW": "生成 RSA 密鑰對",
        "zh-CN": "生成 RSA 密钥对",
        "en": "Generate RSA Key Pair",
        "hi": "RSA की जोड़ी उत्पन्न करें",
        "ja": "RSA鍵ペアを生成",
        "ko": "RSA 키 쌍 생성"
      },
      "publicKey": {
        "zh-TW": "RSA 公鑰 (PEM 格式)",
        "zh-CN": "RSA 公钥 (PEM 格式)",
        "en": "RSA Public Key (PEM Format)",
        "hi": "RSA पब्लिक की (PEM प्रारूप)",
        "ja": "RSA公開鍵 (PEM形式)",
        "ko": "RSA 공개 키 (PEM 형식)"
      },
      "privateKey": {
        "zh-TW": "RSA 私鑰 (PEM 格式)",
        "zh-CN": "RSA 私钥 (PEM 格式)",
        "en": "RSA Private Key (PEM Format)",
        "hi": "RSA प्राइवेट की (PEM प्रारूप)",
        "ja": "RSA秘密鍵 (PEM形式)",
        "ko": "RSA 개인 키 (PEM 형식)"
      },
      "publicKeyPlaceholder": {
        "zh-TW": "請輸入或生成 RSA 公鑰...",
        "zh-CN": "请输入或生成 RSA 公钥...",
        "en": "Please enter or generate RSA public key...",
        "hi": "कृपया RSA पब्लिक की दर्ज करें या उत्पन्न करें...",
        "ja": "RSA公開鍵を入力または生成してください...",
        "ko": "RSA 공개 키를 입력하거나 생성하세요..."
      },
      "privateKeyPlaceholder": {
        "zh-TW": "請輸入或生成 RSA 私鑰...",
        "zh-CN": "请输入或生成 RSA 私钥...",
        "en": "Please enter or generate RSA private key...",
        "hi": "कृपया RSA प्राइवेट की दर्ज करें या उत्पन्न करें...",
        "ja": "RSA秘密鍵を入力または生成してください...",
        "ko": "RSA 개인 키를 입력하거나 생성하세요..."
      },
      "aesKey": {
        "zh-TW": "AES 密鑰管理",
        "zh-CN": "AES 密钥管理",
        "en": "AES Key Management",
        "hi": "AES की प्रबंधन",
        "ja": "AES鍵管理",
        "ko": "AES 키 관리"
      },
      "generateKey": {
        "zh-TW": "生成 AES 密鑰",
        "zh-CN": "生成 AES 密钥",
        "en": "Generate AES Key",
        "hi": "AES की उत्पन्न करें",
        "ja": "AES鍵を生成",
        "ko": "AES 키 생성"
      },
      "secretKey": {
        "zh-TW": "AES 密鑰 (256位元十六進制)",
        "zh-CN": "AES 密钥 (256位十六进制)",
        "en": "AES Secret Key (256-bit Hex)",
        "hi": "AES सीक्रेट की (256-बिट हेक्स)",
        "ja": "AES秘密鍵 (256ビット16進)",
        "ko": "AES 비밀 키 (256비트 16진수)"
      },
      "iv": {
        "zh-TW": "初始化向量 (128位元十六進制)",
        "zh-CN": "初始化向量 (128位十六进制)",
        "en": "Initialization Vector (128-bit Hex)",
        "hi": "इनिशियलाइज़ेशन वेक्टर (128-बिट हेक्स)",
        "ja": "初期化ベクター (128ビット16進)",
        "ko": "초기화 벡터 (128비트 16진수)"
      },
      "aesKeyPlaceholder": {
        "zh-TW": "請輸入或生成 64 字符的十六進制 AES 密鑰...",
        "zh-CN": "请输入或生成 64 字符的十六进制 AES 密钥...",
        "en": "Please enter or generate 64-character hex AES key...",
        "hi": "कृपया 64-कैरेक्टर हेक्स AES की दर्ज करें या उत्पन्न करें...",
        "ja": "64文字の16進AES鍵を入力または生成してください...",
        "ko": "64자리 16진수 AES 키를 입력하거나 생성하세요..."
      },
      "ivPlaceholder": {
        "zh-TW": "請輸入或生成 32 字符的十六進制初始化向量...",
        "zh-CN": "请输入或生成 32 字符的十六进制初始化向量...",
        "en": "Please enter or generate 32-character hex IV...",
        "hi": "कृपया 32-कैरेक्टर हेक्स IV दर्ज करें या उत्पन्न करें...",
        "ja": "32文字の16進IVを入力または生成してください...",
        "ko": "32자리 16진수 IV를 입력하거나 생성하세요..."
      },
      "plainText": {
        "zh-TW": "明文",
        "zh-CN": "明文",
        "en": "Plain Text",
        "hi": "सादा पाठ",
        "ja": "平文",
        "ko": "평문"
      },
      "cipherText": {
        "zh-TW": "密文",
        "zh-CN": "密文",
        "en": "Cipher Text",
        "hi": "साइफर टेक्स्ट",
        "ja": "暗号文",
        "ko": "암호문"
      },
      "messageToSign": {
        "zh-TW": "待簽章訊息",
        "zh-CN": "待签名消息",
        "en": "Message to Sign",
        "hi": "हस्ताक्षर करने के लिए संदेश",
        "ja": "署名するメッセージ",
        "ko": "서명할 메시지"
      },
      "originalMessage": {
        "zh-TW": "原始訊息",
        "zh-CN": "原始消息",
        "en": "Original Message",
        "hi": "मूल संदेश",
        "ja": "元のメッセージ",
        "ko": "원본 메시지"
      },
      "statistics": {
        "zh-TW": "處理統計",
        "zh-CN": "处理统计",
        "en": "Processing Statistics",
        "hi": "प्रसंस्करण आंकड़े",
        "ja": "処理統計",
        "ko": "처리 통계"
      },
      "inputBytes": {
        "zh-TW": "輸入位元組",
        "zh-CN": "输入字节",
        "en": "Input Bytes",
        "hi": "इनपुट बाइट्स",
        "ja": "入力バイト",
        "ko": "입력 바이트"
      },
      "outputBytes": {
        "zh-TW": "輸出位元組",
        "zh-CN": "输出字节",
        "en": "Output Bytes",
        "hi": "आउटपुट बाइट्स",
        "ja": "出力バイト",
        "ko": "출력 바이트"
      },
      "executionTime": {
        "zh-TW": "執行時間",
        "zh-CN": "执行时间",
        "en": "Execution Time",
        "hi": "निष्पादन समय",
        "ja": "実行時間",
        "ko": "실행 시간"
      },
      "usedAlgorithm": {
        "zh-TW": "使用演算法",
        "zh-CN": "使用算法",
        "en": "Used Algorithm",
        "hi": "उपयोग किया गया एल्गोरिदम",
        "ja": "使用アルゴリズム",
        "ko": "사용된 알고리즘"
      },
      "featuresTitle": {
        "zh-TW": "功能特色",
        "zh-CN": "功能特色",
        "en": "Features",
        "hi": "विशेषताएं",
        "ja": "機能",
        "ko": "기능"
      },
      "feature1Title": {
        "zh-TW": "專業級加密",
        "zh-CN": "专业级加密",
        "en": "Professional Encryption",
        "hi": "पेशेवर एन्क्रिप्शन",
        "ja": "プロフェッショナル暗号化",
        "ko": "전문가급 암호화"
      },
      "feature1Description": {
        "zh-TW": "支援業界標準的 RSA 和 AES 加密演算法",
        "zh-CN": "支持业界标准的 RSA 和 AES 加密算法",
        "en": "Support industry-standard RSA and AES encryption algorithms",
        "hi": "उद्योग-मानक RSA और AES एन्क्रिप्शन एल्गोरिदम का समर्थन करता है",
        "ja": "業界標準のRSAおよびAES暗号化アルゴリズムをサポート",
        "ko": "업계 표준 RSA 및 AES 암호화 알고리즘 지원"
      },
      "feature2Title": {
        "zh-TW": "數位簽章",
        "zh-CN": "数字签名",
        "en": "Digital Signatures",
        "hi": "डिजिटल हस्ताक्षर",
        "ja": "デジタル署名",
        "ko": "디지털 서명"
      },
      "feature2Description": {
        "zh-TW": "完整的數位簽章生成和驗證功能",
        "zh-CN": "完整的数字签名生成和验证功能",
        "en": "Complete digital signature generation and verification",
        "hi": "संपूर्ण डिजिटल हस्ताक्षर निर्माण और सत्यापन",
        "ja": "完全なデジタル署名の生成と検証",
        "ko": "완전한 디지털 서명 생성 및 검증"
      },
      "feature3Title": {
        "zh-TW": "密鑰管理",
        "zh-CN": "密钥管理",
        "en": "Key Management",
        "hi": "की प्रबंधन",
        "ja": "鍵管理",
        "ko": "키 관리"
      },
      "feature3Description": {
        "zh-TW": "自動生成安全的 RSA 和 AES 密鑰",
        "zh-CN": "自动生成安全的 RSA 和 AES 密钥",
        "en": "Automatically generate secure RSA and AES keys",
        "hi": "सुरक्षित RSA और AES कुंजी स्वचालित रूप से उत्पन्न करें",
        "ja": "安全なRSAおよびAES鍵を自動生成",
        "ko": "안전한 RSA 및 AES 키 자동 생성"
      },
      "feature4Title": {
        "zh-TW": "本地端處理",
        "zh-CN": "本地处理",
        "en": "Local Processing",
        "hi": "स्थानीय प्रसंस्करण",
        "ja": "ローカル処理",
        "ko": "로컬 처리"
      },
      "feature4Description": {
        "zh-TW": "所有密碼學操作在瀏覽器本地執行，確保安全性",
        "zh-CN": "所有密码学操作在浏览器本地执行，确保安全性",
        "en": "All cryptographic operations run locally in browser for security",
        "hi": "सुरक्षा के लिए सभी क्रिप्टोग्राफिक ऑपरेशन ब्राउज़र में स्थानीय रूप से चलते हैं",
        "ja": "セキュリティのため、すべての暗号化操作をブラウザーでローカル実行",
        "ko": "보안을 위해 모든 암호화 작업을 브라우저에서 로컬로 실행"
      },
      "securityWarningTitle": {
        "zh-TW": "安全提醒",
        "zh-CN": "安全提醒",
        "en": "Security Warning",
        "hi": "सुरक्षा चेतावनी",
        "ja": "セキュリティ警告",
        "ko": "보안 경고"
      },
      "securityWarningDescription": {
        "zh-TW": "請勿在不安全的網路環境中使用此工具處理敏感資料。確保您的密鑰安全存儲。",
        "zh-CN": "请勿在不安全的网络环境中使用此工具处理敏感数据。确保您的密钥安全存储。",
        "en": "Do not use this tool to process sensitive data in insecure network environments. Ensure your keys are stored securely.",
        "hi": "असुरक्षित नेटवर्क वातावरण में संवेदनशील डेटा को प्रोसेस करने के लिए इस टूल का उपयोग न करें। सुनिश्चित करें कि आपकी कुंजी सुरक्षित रूप से संग्रहीत हैं।",
        "ja": "安全でないネットワーク環境で機密データを処理するためにこのツールを使用しないでください。鍵が安全に保存されていることを確認してください。",
        "ko": "안전하지 않은 네트워크 환경에서 민감한 데이터를 처리하기 위해 이 도구를 사용하지 마십시오. 키가 안전하게 저장되어 있는지 확인하십시오."
      },
      "keyGenerationError": {
        "zh-TW": "密鑰生成失敗",
        "zh-CN": "密钥生成失败",
        "en": "Key generation failed",
        "hi": "की उत्पादन विफल",
        "ja": "鍵の生成に失敗しました",
        "ko": "키 생성 실패"
      },
      "processingError": {
        "zh-TW": "處理過程發生錯誤",
        "zh-CN": "处理过程发生错误",
        "en": "An error occurred during processing",
        "hi": "प्रसंस्करण के दौरान एक त्रुटि हुई",
        "ja": "処理中にエラーが発生しました",
        "ko": "처리 중 오류가 발생했습니다"
      },
      "rsaEncryptPlaceholder": {
        "zh-TW": "請輸入要加密的明文...",
        "zh-CN": "请输入要加密的明文...",
        "en": "Enter plain text to encrypt...",
        "hi": "एन्क्रिप्ट करने के लिए सादा पाठ दर्ज करें...",
        "ja": "暗号化する平文を入力してください...",
        "ko": "암호화할 평문을 입력하세요..."
      },
      "rsaDecryptPlaceholder": {
        "zh-TW": "請輸入要解密的密文...",
        "zh-CN": "请输入要解密的密文...",
        "en": "Enter cipher text to decrypt...",
        "hi": "डिक्रिप्ट करने के लिए साइफर टेक्स्ट दर्ज करें...",
        "ja": "復号化する暗号文を入力してください...",
        "ko": "복호화할 암호문을 입력하세요..."
      },
      "aesEncryptPlaceholder": {
        "zh-TW": "請輸入要加密的明文...",
        "zh-CN": "请输入要加密的明文...",
        "en": "Enter plain text to encrypt...",
        "hi": "एन्क्रिप्ट करने के लिए सादा पाठ दर्ज करें...",
        "ja": "暗号化する平文を入力してください...",
        "ko": "암호화할 평문을 입력하세요..."
      },
      "aesDecryptPlaceholder": {
        "zh-TW": "請輸入要解密的密文...",
        "zh-CN": "请输入要解密的密文...",
        "en": "Enter cipher text to decrypt...",
        "hi": "डिक्रिप्ट करने के लिए साइफर टेक्स्ट दर्ज करें...",
        "ja": "復号化する暗号文を入力してください...",
        "ko": "복호화할 암호문을 입력하세요..."
      },
      "digitalSignPlaceholder": {
        "zh-TW": "請輸入要簽章的訊息...",
        "zh-CN": "请输入要签名的消息...",
        "en": "Enter message to sign...",
        "hi": "हस्ताक्षर करने के लिए संदेश दर्ज करें...",
        "ja": "署名するメッセージを入力してください...",
        "ko": "서명할 메시지를 입력하세요..."
      },
      "verifySignPlaceholder": {
        "zh-TW": "請輸入原始訊息...",
        "zh-CN": "请输入原始消息...",
        "en": "Enter original message...",
        "hi": "मूल संदेश दर्ज करें...",
        "ja": "元のメッセージを入力してください...",
        "ko": "원본 메시지를 입력하세요..."
      },
      "rsaEncryptButton": {
        "zh-TW": "執行 RSA 加密",
        "zh-CN": "执行 RSA 加密",
        "en": "Execute RSA Encryption",
        "hi": "RSA एन्क्रिप्शन निष्पादित करें",
        "ja": "RSA暗号化を実行",
        "ko": "RSA 암호화 실행"
      },
      "rsaDecryptButton": {
        "zh-TW": "執行 RSA 解密",
        "zh-CN": "执行 RSA 解密",
        "en": "Execute RSA Decryption",
        "hi": "RSA डिक्रिप्शन निष्पादित करें",
        "ja": "RSA復号化を実行",
        "ko": "RSA 복호화 실행"
      },
      "aesEncryptButton": {
        "zh-TW": "執行 AES 加密",
        "zh-CN": "执行 AES 加密",
        "en": "Execute AES Encryption",
        "hi": "AES एन्क्रिप्शन निष्पादित करें",
        "ja": "AES暗号化を実行",
        "ko": "AES 암호화 실행"
      },
      "aesDecryptButton": {
        "zh-TW": "執行 AES 解密",
        "zh-CN": "执行 AES 解密",
        "en": "Execute AES Decryption",
        "hi": "AES डिक्रिप्शन निष्पादित करें",
        "ja": "AES復号化を実行",
        "ko": "AES 복호화 실행"
      },
      "digitalSignButton": {
        "zh-TW": "執行數位簽章",
        "zh-CN": "执行数字签名",
        "en": "Execute Digital Signing",
        "hi": "डिजिटल हस्ताक्षर निष्पादित करें",
        "ja": "デジタル署名を実行",
        "ko": "디지털 서명 실행"
      },
      "verifySignButton": {
        "zh-TW": "執行簽章驗證",
        "zh-CN": "执行签名验证",
        "en": "Execute Signature Verification",
        "hi": "हस्ताक्षर सत्यापन निष्पादित करें",
        "ja": "署名検証を実行",
        "ko": "서명 검증 실행"
      },
      "rsaEncryptSample": {
        "zh-TW": "這是一個 RSA 加密的範例文字",
        "zh-CN": "这是一个 RSA 加密的范例文字",
        "en": "This is a sample text for RSA encryption",
        "hi": "यह RSA एन्क्रिप्शन के लिए एक नमूना पाठ है",
        "ja": "これはRSA暗号化のサンプルテキストです",
        "ko": "이것은 RSA 암호화를 위한 샘플 텍스트입니다"
      },
      "aesEncryptSample": {
        "zh-TW": "這是一個 AES 加密的範例文字，支援大量資料處理",
        "zh-CN": "这是一个 AES 加密的范例文字，支持大量数据处理",
        "en": "This is a sample text for AES encryption, supporting large data processing",
        "hi": "यह AES एन्क्रिप्शन के लिए एक नमूना पाठ है, बड़े डेटा प्रसंस्करण का समर्थन करता है",
        "ja": "これはAES暗号化のサンプルテキストで、大量データ処理をサポートします",
        "ko": "이것은 AES 암호화를 위한 샘플 텍스트로, 대용량 데이터 처리를 지원합니다"
      },
      "digitalSignSample": {
        "zh-TW": "這是一個需要數位簽章的重要文件內容",
        "zh-CN": "这是一个需要数字签名的重要文件内容",
        "en": "This is important document content that needs digital signature",
        "hi": "यह एक महत्वपूर्ण दस्तावेज़ सामग्री है जिसे डिजिटल हस्ताक्षर की आवश्यकता है",
        "ja": "これはデジタル署名が必要な重要な文書内容です",
        "ko": "이것은 디지털 서명이 필요한 중요한 문서 내용입니다"
      }
    }
  },
  "categories": {
    // === 開發工具類 ===
    "development": {
      "zh-TW": "開發工具",
      "zh-CN": "开发工具",
      "en": "Development Tools",
      "hi": "विकास उपकरण",
      "ja": "開発ツール",
      "ko": "개발 도구"
    },
    "api": {
      "zh-TW": "API 工具",
      "zh-CN": "API 工具",
      "en": "API Tools",
      "hi": "API उपकरण",
      "ja": "APIツール",
      "ko": "API 도구"
    },
    "database": {
      "zh-TW": "資料庫工具",
      "zh-CN": "数据库工具",
      "en": "Database Tools",
      "hi": "डेटाबेस उपकरण",
      "ja": "データベースツール",
      "ko": "데이터베이스 도구"
    },
    "git": {
      "zh-TW": "版本控制",
      "zh-CN": "版本控制",
      "en": "Version Control",
      "hi": "संस्करण नियंत्रण",
      "ja": "バージョン管理",
      "ko": "버전 관리"
    },
    "frontend": {
      "zh-TW": "前端工具",
      "zh-CN": "前端工具",
      "en": "Frontend Tools",
      "hi": "फ्रंटएंड उपकरण",
      "ja": "フロントエンドツール",
      "ko": "프론트엔드 도구"
    },
    "backend": {
      "zh-TW": "後端工具",
      "zh-CN": "后端工具",
      "en": "Backend Tools",
      "hi": "बैकएंड उपकरण",
      "ja": "バックエンドツール",
      "ko": "백엔드 도구"
    },

    // === 格式化與轉換類 ===
    "formatter": {
      "zh-TW": "格式化工具",
      "zh-CN": "格式化工具",
      "en": "Formatter Tools",
      "hi": "फॉर्मेटर उपकरण",
      "ja": "フォーマッターツール",
      "ko": "포맷터 도구"
    },
    "converter": {
      "zh-TW": "格式轉換",
      "zh-CN": "格式转换",
      "en": "Format Converter",
      "hi": "प्रारूप कनवर्टर",
      "ja": "フォーマット変換",
      "ko": "포맷 변환기"
    },
    "validator": {
      "zh-TW": "驗證工具",
      "zh-CN": "验证工具",
      "en": "Validation Tools",
      "hi": "सत्यापन उपकरण",
      "ja": "検証ツール",
      "ko": "검증 도구"
    },
    "json": {
      "zh-TW": "JSON 工具",
      "zh-CN": "JSON 工具",
      "en": "JSON Tools",
      "hi": "JSON उपकरण",
      "ja": "JSONツール",
      "ko": "JSON 도구"
    },
    "xml": {
      "zh-TW": "XML 工具",
      "zh-CN": "XML 工具",
      "en": "XML Tools",
      "hi": "XML उपकरण",
      "ja": "XMLツール",
      "ko": "XML 도구"
    },
    "yaml": {
      "zh-TW": "YAML 工具",
      "zh-CN": "YAML 工具",
      "en": "YAML Tools",
      "hi": "YAML उपकरण",
      "ja": "YAMLツール",
      "ko": "YAML 도구"
    },
    "csv": {
      "zh-TW": "CSV 工具",
      "zh-CN": "CSV 工具",
      "en": "CSV Tools",
      "hi": "CSV उपकरण",
      "ja": "CSVツール",
      "ko": "CSV 도구"
    },
    "dataProcessing": {
      "zh-TW": "資料處理",
      "zh-CN": "数据处理",
      "en": "Data Processing",
      "hi": "डेटा प्रोसेसिंग",
      "ja": "データ処理",
      "ko": "데이터 처리"
    },

    // === 編碼解碼類 ===
    "encoder": {
      "zh-TW": "編碼解碼",
      "zh-CN": "编码解码",
      "en": "Encoder/Decoder",
      "hi": "एन्कोडर/डिकोडर",
      "ja": "エンコーダー/デコーダー",
      "ko": "인코더/디코더"
    },
    "hash": {
      "zh-TW": "雜湊運算",
      "zh-CN": "哈希运算",
      "en": "Hash Functions",
      "hi": "हैश फ़ंक्शन",
      "ja": "ハッシュ関数",
      "ko": "해시 함수"
    },
    "crypto": {
      "zh-TW": "加密解密",
      "zh-CN": "加密解密",
      "en": "Encryption/Decryption",
      "hi": "एन्क्रिप्शन/डिक्रिप्शन",
      "ja": "暗号化/復号化",
      "ko": "암호화/복호화"
    },

    // === 安全工具類 ===
    "security": {
      "zh-TW": "安全工具",
      "zh-CN": "安全工具",
      "en": "Security Tools",
      "hi": "सुरक्षा उपकरण",
      "ja": "セキュリティツール",
      "ko": "보안 도구"
    },
    "jwt": {
      "zh-TW": "JWT 工具",
      "zh-CN": "JWT 工具",
      "en": "JWT Tools",
      "hi": "JWT उपकरण",
      "ja": "JWTツール",
      "ko": "JWT 도구"
    },
    "password": {
      "zh-TW": "密碼工具",
      "zh-CN": "密码工具",
      "en": "Password Tools",
      "hi": "पासवर्ड उपकरण",
      "ja": "パスワードツール",
      "ko": "비밀번호 도구"
    },
    "certificate": {
      "zh-TW": "憑證工具",
      "zh-CN": "证书工具",
      "en": "Certificate Tools",
      "hi": "प्रमाणपत्र उपकरण",
      "ja": "証明書ツール",
      "ko": "인증서 도구"
    },

    // === 網路工具類 ===
    "network": {
      "zh-TW": "網路工具",
      "zh-CN": "网络工具",
      "en": "Network Tools",
      "hi": "नेटवर्क उपकरण",
      "ja": "ネットワークツール",
      "ko": "네트워크 도구"
    },
    "monitoring": {
      "zh-TW": "監控工具",
      "zh-CN": "监控工具",
      "en": "Monitoring Tools",
      "hi": "निगरानी उपकरण",
      "ja": "監視ツール",
      "ko": "모니터링 도구"
    },
    "dns": {
      "zh-TW": "DNS 工具",
      "zh-CN": "DNS 工具",
      "en": "DNS Tools",
      "hi": "DNS उपकरण",
      "ja": "DNSツール",
      "ko": "DNS 도구"
    },
    "http": {
      "zh-TW": "HTTP 工具",
      "zh-CN": "HTTP 工具",
      "en": "HTTP Tools",
      "hi": "HTTP उपकरण",
      "ja": "HTTPツール",
      "ko": "HTTP 도구"
    },
    "ssl": {
      "zh-TW": "SSL/TLS 工具",
      "zh-CN": "SSL/TLS 工具",
      "en": "SSL/TLS Tools",
      "hi": "SSL/TLS उपकरण",
      "ja": "SSL/TLSツール",
      "ko": "SSL/TLS 도구"
    },

    // === 圖像處理類 ===
    "image": {
      "zh-TW": "圖像工具",
      "zh-CN": "图像工具",
      "en": "Image Tools",
      "hi": "छवि उपकरण",
      "ja": "画像ツール",
      "ko": "이미지 도구"
    },
    "imageConverter": {
      "zh-TW": "圖像轉換",
      "zh-CN": "图像转换",
      "en": "Image Converter",
      "hi": "छवि कनवर्टर",
      "ja": "画像変換",
      "ko": "이미지 변환"
    },
    "imageOptimizer": {
      "zh-TW": "圖像優化",
      "zh-CN": "图像优化",
      "en": "Image Optimizer",
      "hi": "छवि अनुकूलक",
      "ja": "画像最適化",
      "ko": "이미지 최적화"
    },
    "qrCode": {
      "zh-TW": "QR 碼工具",
      "zh-CN": "二维码工具",
      "en": "QR Code Tools",
      "hi": "QR कोड उपकरण",
      "ja": "QRコードツール",
      "ko": "QR 코드 도구"
    },

    // === 文檔處理類 ===
    "document": {
      "zh-TW": "文檔處理",
      "zh-CN": "文档处理",
      "en": "Document Processing",
      "hi": "दस्तावेज़ प्रसंस्करण",
      "ja": "ドキュメント処理",
      "ko": "문서 처리"
    },
    "pdf": {
      "zh-TW": "PDF 工具",
      "zh-CN": "PDF 工具",
      "en": "PDF Tools",
      "hi": "PDF उपकरण",
      "ja": "PDFツール",
      "ko": "PDF 도구"
    },
    "office": {
      "zh-TW": "Office 工具",
      "zh-CN": "Office 工具",
      "en": "Office Tools",
      "hi": "Office उपकरण",
      "ja": "Officeツール",
      "ko": "Office 도구"
    },

    // === 文字處理類 ===
    "text": {
      "zh-TW": "文字工具",
      "zh-CN": "文字工具",
      "en": "Text Tools",
      "hi": "टेक्स्ट उपकरण",
      "ja": "テキストツール",
      "ko": "텍스트 도구"
    },
    "regex": {
      "zh-TW": "正規表達式",
      "zh-CN": "正则表达式",
      "en": "Regular Expression",
      "hi": "नियमित अभिव्यक्ति",
      "ja": "正規表現",
      "ko": "정규 표현식"
    },
    "markdown": {
      "zh-TW": "Markdown 工具",
      "zh-CN": "Markdown 工具",
      "en": "Markdown Tools",
      "hi": "Markdown उपकरण",
      "ja": "Markdownツール",
      "ko": "Markdown 도구"
    },

    // === 系統工具類 ===
    "system": {
      "zh-TW": "系統工具",
      "zh-CN": "系统工具",
      "en": "System Tools",
      "hi": "सिस्टम उपकरण",
      "ja": "システムツール",
      "ko": "시스템 도구"
    },
    "testing": {
      "zh-TW": "測試工具",
      "zh-CN": "测试工具",
      "en": "Testing Tools",
      "hi": "परीक्षण उपकरण",
      "ja": "テストツール",
      "ko": "테스트 도구"
    },

    // === 生活工具類 ===
    "lifestyle": {
      "zh-TW": "生活工具",
      "zh-CN": "生活工具",
      "en": "Lifestyle Tools",
      "hi": "जीवनशैली उपकरण",
      "ja": "ライフスタイルツール",
      "ko": "라이프스타일 도구"
    },
    "calculator": {
      "zh-TW": "計算工具",
      "zh-CN": "计算工具",
      "en": "Calculator Tools",
      "hi": "कैलकुलेटर उपकरण",
      "ja": "計算ツール",
      "ko": "계산기 도구"
    },
    "finance": {
      "zh-TW": "金融工具",
      "zh-CN": "金融工具",
      "en": "Finance Tools",
      "hi": "वित्त उपकरण",
      "ja": "金融ツール",
      "ko": "금융 도구"
    },
    "datetime": {
      "zh-TW": "日期時間",
      "zh-CN": "日期时间",
      "en": "Date & Time",
      "hi": "दिनांक और समय",
      "ja": "日付・時刻",
      "ko": "날짜 시간"
    },
    "reference": {
      "zh-TW": "參考工具",
      "zh-CN": "参考工具",
      "en": "Reference Tools",
      "hi": "संदर्भ उपकरण",
      "ja": "リファレンスツール",
      "ko": "참조 도구"
    },

    // === 設計工具類 ===
    "design": {
      "zh-TW": "設計工具",
      "zh-CN": "设计工具",
      "en": "Design Tools",
      "hi": "डिज़ाइन उपकरण",
      "ja": "デザインツール",
      "ko": "디자인 도구"
    },
    "color": {
      "zh-TW": "顏色工具",
      "zh-CN": "颜色工具",
      "en": "Color Tools",
      "hi": "रंग उपकरण",
      "ja": "カラーツール",
      "ko": "컬러 도구"
    },
    "typography": {
      "zh-TW": "字體工具",
      "zh-CN": "字体工具",
      "en": "Typography Tools",
      "hi": "टाइपोग्राफी उपकरण",
      "ja": "タイポグラフィツール",
      "ko": "타이포그래피 도구"
    },

    // === 舊版分類（向後相容）===
    "developer": {
      "zh-TW": "開發工具",
      "zh-CN": "开发工具",
      "en": "Developer Tools",
      "hi": "डेवलपर उपकरण",
      "ja": "開発ツール",
      "ko": "개발자 도구"
    },
    "allCategories": {
      "zh-TW": "所有分類",
      "zh-CN": "所有分类",
      "en": "All Categories",
      "hi": "सभी श्रेणियां",
      "ja": "すべてのカテゴリ",
      "ko": "모든 카테고리"
    },
    "categoryManagement": {
      "zh-TW": "分類管理",
      "zh-CN": "分类管理",
      "en": "Category Management",
      "hi": "श्रेणी प्रबंधन",
      "ja": "カテゴリ管理",
      "ko": "카테고리 관리"
    },
    "toolsByCategory": {
      "zh-TW": "按分類瀏覽",
      "zh-CN": "按分类浏览",
      "en": "Browse by Category",
      "hi": "श्रेणी के अनुसार ब्राउज़ करें",
      "ja": "カテゴリ別で閲覧",
      "ko": "카테고리별 탐색"
    },
    "expandCategory": {
      "zh-TW": "展開分類",
      "zh-CN": "展开分类",
      "en": "Expand Category",
      "hi": "श्रेणी का विस्तार करें",
      "ja": "カテゴリを展開",
      "ko": "카테고리 확장"
    },
    "collapseCategory": {
      "zh-TW": "收合分類",
      "zh-CN": "收起分类",
      "en": "Collapse Category",
      "hi": "श्रेणी को संक्षेप करें",
      "ja": "カテゴリを折りたたむ",
      "ko": "카테고리 축소"
    },
    "searchInCategory": {
      "zh-TW": "在分類中搜尋",
      "zh-CN": "在分类中搜索",
      "en": "Search in Category",
      "hi": "श्रेणी में खोजें",
      "ja": "カテゴリ内で検索",
      "ko": "카테고리 내 검색"
    }
  },
  "categoryGroups": {
    "development": {
      "zh-TW": "開發類",
      "zh-CN": "开发类",
      "en": "Development",
      "hi": "विकास",
      "ja": "開発",
      "ko": "개발"
    },
    "processing": {
      "zh-TW": "處理類",
      "zh-CN": "处理类",
      "en": "Processing",
      "hi": "प्रसंस्करण",
      "ja": "処理",
      "ko": "처리"
    },
    "security": {
      "zh-TW": "安全類",
      "zh-CN": "安全类",
      "en": "Security",
      "hi": "सुरक्षा",
      "ja": "セキュリティ",
      "ko": "보안"
    },
    "network": {
      "zh-TW": "網路類",
      "zh-CN": "网络类",
      "en": "Network",
      "hi": "नेटवर्क",
      "ja": "ネットワーク",
      "ko": "네트워크"
    },
    "media": {
      "zh-TW": "多媒體類",
      "zh-CN": "多媒体类",
      "en": "Media",
      "hi": "मीडिया",
      "ja": "メディア",
      "ko": "미디어"
    },
    "utility": {
      "zh-TW": "實用類",
      "zh-CN": "实用类",
      "en": "Utility",
      "hi": "उपयोगिता",
      "ja": "ユーティリティ",
      "ko": "유틸리티"
    }
  },
  "ranking": {
    "title": {
      "zh-TW": "工具使用排行榜",
      "zh-CN": "工具使用排行榜",
      "en": "Tools Usage Ranking",
      "hi": "टूल उपयोग रैंकिंग",
      "ja": "ツール使用ランキング",
      "ko": "도구 사용 순위"
    },
    "description": {
      "zh-TW": "探索最受歡迎的 API 開發工具，發現用戶最喜愛的功能",
      "zh-CN": "探索最受欢迎的 API 开发工具，发现用户最喜爱的功能",
      "en": "Explore the most popular API development tools and discover user favorites",
      "hi": "सबसे लोकप्रिय API विकास उपकरणों का अन्वेषण करें और उपयोगकर्ता पसंदीदा खोजें",
      "ja": "最も人気のAPIツールを探索し、ユーザーのお気に入りを発見",
      "ko": "가장 인기 있는 API 개발 도구를 탐색하고 사용자 즐겨찾기를 발견하세요"
    },
    "lastUpdated": {
      "zh-TW": "最後更新",
      "zh-CN": "最後更新",
      "en": "Last Updated",
      "hi": "अंतिम अपडेट",
      "ja": "最終更新",
      "ko": "마지막 업데이트"
    },
    "loading": {
      "zh-TW": "載入排行榜中...",
      "zh-CN": "载入排行榜中...",
      "en": "Loading ranking...",
      "hi": "रैंकिंग लोड हो रही है...",
      "ja": "ランキング読み込み中...",
      "ko": "순위 로딩 중..."
    },
    "systemStats": {
      "zh-TW": "系統統計",
      "zh-CN": "系统统计",
      "en": "System Statistics",
      "hi": "सिस्टम आंकड़े",
      "ja": "システム統計",
      "ko": "시스템 통계"
    },
    "totalCalls": {
      "zh-TW": "總使用次數",
      "zh-CN": "总使用次数",
      "en": "Total Calls",
      "hi": "कुल कॉल",
      "ja": "総使用回数",
      "ko": "총 사용 횟수"
    },
    "toolsUsed": {
      "zh-TW": "已使用工具",
      "zh-CN": "已使用工具",
      "en": "Tools Used",
      "hi": "उपयोग किए गए टूल",
      "ja": "使用されたツール",
      "ko": "사용된 도구"
    },
    "successRate": {
      "zh-TW": "成功率",
      "zh-CN": "成功率",
      "en": "Success Rate",
      "hi": "सफलता दर",
      "ja": "成功率",
      "ko": "성공률"
    },
    "popularTool": {
      "zh-TW": "最熱門工具",
      "zh-CN": "最热门工具",
      "en": "Most Popular Tool",
      "hi": "सबसे लोकप्रिय टूल",
      "ja": "最も人気のツール",
      "ko": "가장 인기 있는 도구"
    },
    "toolsRanking": {
      "zh-TW": "工具排行榜",
      "zh-CN": "工具排行榜",
      "en": "Tools Ranking",
      "hi": "टूल रैंकिंग",
      "ja": "ツールランキング",
      "ko": "도구 순위"
    },
    "rankingDescription": {
      "zh-TW": "根據實際使用量排序，點擊即可快速前往使用",
      "zh-CN": "根据实际使用量排序，点击即可快速前往使用",
      "en": "Ranked by actual usage, click to navigate quickly",
      "hi": "वास्तविक उपयोग के आधार पर रैंक किया गया, जल्दी नेविगेट करने के लिए क्लिक करें",
      "ja": "実際の使用量でランク付け、クリックで素早くナビゲート",
      "ko": "실제 사용량으로 순위 매김, 클릭하여 빠르게 이동"
    },
    "usageCount": {
      "zh-TW": "使用次數",
      "zh-CN": "使用次数",
      "en": "Usage Count",
      "hi": "उपयोग गिनती",
      "ja": "使用回数",
      "ko": "사용 횟수"
    },
    "avgTime": {
      "zh-TW": "平均耗時",
      "zh-CN": "平均耗时",
      "en": "Avg Time",
      "hi": "औसत समय",
      "ja": "平均時間",
      "ko": "평균 시간"
    },
    "todayUsage": {
      "zh-TW": "今日使用",
      "zh-CN": "今日使用",
      "en": "Today Usage",
      "hi": "आज का उपयोग",
      "ja": "今日の使用",
      "ko": "오늘 사용량"
    },
    "noData": {
      "zh-TW": "暫無統計數據",
      "zh-CN": "暂无统计数据",
      "en": "No Statistics Available",
      "hi": "कोई आंकड़े उपलब्ध नहीं",
      "ja": "統計データなし",
      "ko": "통계 데이터 없음"
    },
    "noDataDescription": {
      "zh-TW": "開始使用工具後即可查看排行榜",
      "zh-CN": "开始使用工具后即可查看排行榜",
      "en": "Rankings will appear after tools are used",
      "hi": "टूल का उपयोग करने के बाद रैंकिंग दिखाई देगी",
      "ja": "ツールを使用した後にランキングが表示されます",
      "ko": "도구를 사용한 후 순위가 표시됩니다"
    },
    "error": {
      "zh-TW": "載入失敗",
      "zh-CN": "载入失败",
      "en": "Loading Failed",
      "hi": "लोड विफल",
      "ja": "読み込み失敗",
      "ko": "로딩 실패"
    },
    "loadError": {
      "zh-TW": "無法載入排行榜數據，請稍後再試",
      "zh-CN": "无法载入排行榜数据，请稍后再试",
      "en": "Failed to load ranking data, please try again later",
      "hi": "रैंकिंग डेटा लोड नहीं कर सका, कृपया बाद में पुनः प्रयास करें",
      "ja": "ランキングデータの読み込みに失敗しました。後でもう一度お試しください",
      "ko": "순위 데이터를 로드할 수 없습니다. 나중에 다시 시도해 주세요"
    },
    "retry": {
      "zh-TW": "重新載入",
      "zh-CN": "重新载入",
      "en": "Retry",
      "hi": "पुनः प्रयास करें",
      "ja": "再試行",
      "ko": "다시 시도"
    },
    "quickNav": {
      "zh-TW": "快速導航",
      "zh-CN": "快速导航",
      "en": "Quick Navigation",
      "hi": "त्वरित नेवीगेशन",
      "ja": "クイックナビゲーション",
      "ko": "빠른 탐색"
    },
    "allTools": {
      "zh-TW": "所有工具",
      "zh-CN": "所有工具",
      "en": "All Tools",
      "hi": "सभी टूल",
      "ja": "すべてのツール",
      "ko": "모든 도구"
    },
    "tips": {
      "title": {
        "zh-TW": "使用提示",
        "zh-CN": "使用提示",
        "en": "Usage Tips",
        "hi": "उपयोग सुझाव",
        "ja": "使用のヒント",
        "ko": "사용 팁"
      },
      "tip1": {
        "zh-TW": "點擊任何工具即可直接前往使用",
        "zh-CN": "点击任何工具即可直接前往使用",
        "en": "Click any tool to navigate directly",
        "hi": "किसी भी टूल पर क्लिक करके सीधे उपयोग करें",
        "ja": "任意のツールをクリックして直接使用",
        "ko": "도구를 클릭하면 바로 사용할 수 있습니다"
      },
      "tip2": {
        "zh-TW": "熱門工具通常功能更加穩定可靠",
        "zh-CN": "热门工具通常功能更加稳定可靠",
        "en": "Popular tools are usually more stable and reliable",
        "hi": "लोकप्रिय टूल आमतौर पर अधिक स्थिर और विश्वसनीय होते हैं",
        "ja": "人気のツールは通常より安定して信頼性が高い",
        "ko": "인기 있는 도구는 일반적으로 더 안정적이고 신뢰할 수 있습니다"
      },
      "tip3": {
        "zh-TW": "統計數據每5分鐘更新一次",
        "zh-CN": "统计数据每5分钟更新一次",
        "en": "Statistics are updated every 5 minutes",
        "hi": "आंकड़े हर 5 मिनट में अपडेट होते हैं",
        "ja": "統計は5分ごとに更新されます",
        "ko": "통계는 5분마다 업데이트됩니다"
      }
    }
  },
  "homepage": {
    "toolsSectionTitle": {
      "zh-TW": "熱門開發工具",
      "zh-CN": "熱門开发工具",
      "en": "Popular Development Tools",
      "hi": "लोकप्रिय विकास उपकरण",
      "ja": "人気の開発ツール",
      "ko": "인기 개발 도구"
    },
    "toolsSectionSubtitle": {
      "zh-TW": "提升開發效率的專業工具集合",
      "zh-CN": "提升开发效率的专业工具集合",
      "en": "Professional tools collection to boost development efficiency",
      "hi": "विकास दक्षता बढ़ाने के लिए पेशेवर उपकरण संग्रह",
      "ja": "開発効率を向上させるプロフェッショナルツールセット",
      "ko": "개발 효율성을 높이는 전문 도구 모음"
    },
    "whyChooseUs": {
      "zh-TW": "為什麼選擇 CallMeAPI？",
      "zh-CN": "為什麼选择 CallMeAPI？",
      "en": "Why Choose CallMeAPI?",
      "hi": "CallMeAPI क्यों चुनें?",
      "ja": "なぜCallMeAPIを選ぶのか？",
      "ko": "왜 CallMeAPI를 선택해야 할까요?"
    },
    "feature1Title": {
      "zh-TW": "快速高效",
      "zh-CN": "快速高效",
      "en": "Fast & Efficient",
      "hi": "तेज़ और कुशल",
      "ja": "高速で効率的",
      "ko": "빠르고 효율적"
    },
    "feature1Description": {
      "zh-TW": "專為開發者設計的工具，提升您的開發效率",
      "zh-CN": "专為开发者设计的工具，提升您的开发效率",
      "en": "Tools designed specifically for developers to boost your productivity",
      "hi": "डेवलपर्स के लिए विशेष रूप से डिज़ाइन किए गए उपकरण",
      "ja": "開発者向けに設計されたツールで、開発効率を向上",
      "ko": "개발자를 위해 특별히 설계된 도구로 생산성 향상"
    },
    "feature2Title": {
      "zh-TW": "安全可靠",
      "zh-CN": "安全可靠",
      "en": "Secure & Reliable",
      "hi": "सुरक्षित और विश्वसनीय",
      "ja": "安全で信頼性が高い",
      "ko": "안전하고 신뢰할 수 있는"
    },
    "feature2Description": {
      "zh-TW": "所有處理都在瀏覽器本地進行，保護您的數據安全",
      "zh-CN": "所有处理都在瀏览器本地进行，保护您的数据安全",
      "en": "All processing is done locally in your browser, protecting your data security",
      "hi": "सभी प्रक्रिया आपके ब्राउज़र में स्थानीय रूप से की जाती है",
      "ja": "すべての処理はブラウザのローカルで実行され、データセキュリティを保護",
      "ko": "모든 처리는 브라우저에서 로컬로 수행되어 데이터 보안을 보호"
    },
    "feature3Title": {
      "zh-TW": "多語系支援",
      "zh-CN": "多语系支持",
      "en": "Multi-language Support",
      "hi": "बहु-भाषा समर्थन",
      "ja": "多言語サポート",
      "ko": "다국어 지원"
    },
    "feature3Description": {
      "zh-TW": "支援多種語言，服務全球開發者社群",
      "zh-CN": "支持多种语言，服务全球开发者社群",
      "en": "Support multiple languages, serving the global developer community",
      "hi": "कई भाषाओं का समर्थन, वैश्विक डेवलपर समुदाय की सेवा",
      "ja": "複数の言語をサポートし、グローバルな開発者コミュニティにサービスを提供",
      "ko": "여러 언어를 지원하여 글로벌 개발자 커뮤니티에 서비스 제공"
    },
    "viewAllTools": {
      "zh-TW": "查看所有工具",
      "zh-CN": "查看所有工具",
      "en": "View All Tools",
      "hi": "सभी उपकरण देखें",
      "ja": "すべてのツールを表示",
      "ko": "모든 도구 보기"
    }
  }
}
